export const POSTAL_CODE = [
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10110",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10120",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10130",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10140",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10150",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10160",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10210",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10220",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10230",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10240",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10250",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10260",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10270",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10310",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10320",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10330",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10340",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10350",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10410",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10420",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10430",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10440",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10450",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10460",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10510",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10520",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10530",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10540",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10550",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10560",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10570",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10610",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10620",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10630",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10640",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10650",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10710",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10720",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10730",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10740",
  },
  {
    city_short: "JAKARTA PUSAT",
    province: "DKI JAKARTA",
    postal_code: "10750",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11110",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11120",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11130",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11140",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11150",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11160",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11170",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11180",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11210",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11220",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11230",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11240",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11250",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11260",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11270",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11310",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11320",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11330",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11410",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11420",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11430",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11440",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11450",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11460",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11470",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11480",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11510",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11520",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11530",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11540",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11550",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11560",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11610",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11620",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11630",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11640",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11650",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11710",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11720",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11730",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11740",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11750",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11810",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11820",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11830",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11840",
  },
  {
    city_short: "JAKARTA BARAT",
    province: "DKI JAKARTA",
    postal_code: "11850",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12110",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12120",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12130",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12140",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12150",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12160",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12170",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12180",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12190",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12210",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12220",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12230",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12240",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12250",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12260",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12270",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12310",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12320",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12330",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12410",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12420",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12430",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12440",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12450",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12510",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12520",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12530",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12540",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12550",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12560",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12620",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12630",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12640",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12710",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12720",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12730",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12740",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12750",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12760",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12770",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12780",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12790",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12810",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12820",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12830",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12840",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12850",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12860",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12870",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12910",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12920",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12930",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12940",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12950",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12960",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12970",
  },
  {
    city_short: "JAKARTA SELATAN",
    province: "DKI JAKARTA",
    postal_code: "12980",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13110",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13120",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13130",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13140",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13150",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13210",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13220",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13230",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13240",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13250",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13260",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13310",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13320",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13330",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13340",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13350",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13410",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13420",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13430",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13440",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13450",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13460",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13470",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13510",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13520",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13530",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13540",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13550",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13560",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13570",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13610",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13620",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13630",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13640",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13650",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13710",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13720",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13730",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13740",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13750",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13760",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13770",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13780",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13790",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13810",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13820",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13830",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13840",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13850",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13860",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13870",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13880",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13890",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13910",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13920",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13930",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13940",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13950",
  },
  {
    city_short: "JAKARTA TIMUR",
    province: "DKI JAKARTA",
    postal_code: "13960",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14110",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14120",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14130",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14140",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14150",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14210",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14230",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14240",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14250",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14260",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14270",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14310",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14320",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14330",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14340",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14350",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14360",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14370",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14410",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14420",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14430",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14440",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14450",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14460",
  },
  {
    city_short: "JAKARTA UTARA",
    province: "DKI JAKARTA",
    postal_code: "14470",
  },
  {
    city_short: "KEP SERIBU",
    province: "DKI JAKARTA",
    postal_code: "14510",
  },
  {
    city_short: "KEP SERIBU",
    province: "DKI JAKARTA",
    postal_code: "14520",
  },
  {
    city_short: "KEP SERIBU",
    province: "DKI JAKARTA",
    postal_code: "14530",
  },
  {
    city_short: "KEP SERIBU",
    province: "DKI JAKARTA",
    postal_code: "14540",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15111",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15112",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15113",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15114",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15115",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15116",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15117",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15118",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15119",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15121",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15122",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15123",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15124",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15125",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15126",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15127",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15128",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15129",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15131",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15132",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15133",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15134",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15135",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15136",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15137",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15138",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15139",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15141",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15142",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15143",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15144",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15145",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15146",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15147",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15148",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15151",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15152",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15153",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15154",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15155",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15156",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15157",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15158",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15159",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15211",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15212",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15213",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15214",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15215",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15220",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15221",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15222",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15223",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15224",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15225",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15226",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15227",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15228",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15229",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15310",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15311",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15312",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15313",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15314",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15315",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15318",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15320",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15321",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15322",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15323",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15324",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15325",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15326",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15330",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15331",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15332",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15334",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15335",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15336",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15337",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15338",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15339",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15340",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15341",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15342",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15343",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15344",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15345",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15411",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15412",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15413",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15414",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15415",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15416",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15417",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15418",
  },
  {
    city_short: "TANGSEL",
    province: "BANTEN",
    postal_code: "15419",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15510",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15520",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15530",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15540",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15550",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15560",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15570",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15610",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15620",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15710",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15720",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15730",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15810",
  },
  {
    city_short: "TANGERANG",
    province: "BANTEN",
    postal_code: "15820",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16110",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16111",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16112",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16113",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16114",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16115",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16116",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16117",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16118",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16119",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16120",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16121",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16122",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16123",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16124",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16125",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16126",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16128",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16129",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16131",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16132",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16133",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16134",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16135",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16136",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16137",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16138",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16139",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16141",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16142",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16143",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16144",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16145",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16146",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16151",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16152",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16153",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16154",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16155",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16156",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16157",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16158",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16161",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16162",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16164",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16165",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16166",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16167",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16168",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16169",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16310",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16320",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16330",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16340",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16350",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16360",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16370",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16411",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16412",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16413",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16414",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16415",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16416",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16417",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16418",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16421",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16422",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16423",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16424",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16425",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16426",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16431",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16432",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16433",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16434",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16435",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16436",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16437",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16438",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16439",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16451",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16452",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16453",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16454",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16455",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16456",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16457",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16458",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16459",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16511",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16512",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16513",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16514",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16515",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16516",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16517",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16518",
  },
  {
    city_short: "DEPOK",
    province: "JAWA BARAT",
    postal_code: "16519",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16610",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16620",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16630",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16640",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16650",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16660",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16670",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16680",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16710",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16720",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16730",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16740",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16750",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16770",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16810",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16820",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16830",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16840",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16911",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16912",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16913",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16914",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16915",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16916",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16917",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16918",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16920",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16921",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16922",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16923",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16960",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16961",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16962",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16963",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16964",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16965",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16966",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16967",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16968",
  },
  {
    city_short: "BOGOR",
    province: "JAWA BARAT",
    postal_code: "16969",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17111",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17112",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17113",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17114",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17115",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17116",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17117",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17121",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17122",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17123",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17124",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17125",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17131",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17132",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17133",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17134",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17135",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17136",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17141",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17142",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17143",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17144",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17145",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17146",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17147",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17148",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17151",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17152",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17153",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17154",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17155",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17156",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17157",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17158",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17211",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17212",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17213",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17214",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17215",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17216",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17217",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17218",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17320",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17330",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17340",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17350",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17352",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17356",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17411",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17412",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17413",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17414",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17415",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17421",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17422",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17423",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17424",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17425",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17426",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17431",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17432",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17433",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17434",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17435",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17510",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17520",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17530",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17540",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17610",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17620",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17630",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17710",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17720",
  },
  {
    city_short: "BEKASI",
    province: "JAWA BARAT",
    postal_code: "17730",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20111",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20112",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20113",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20114",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20115",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20116",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20117",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20118",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20119",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20121",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20122",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20123",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20124",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20125",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20126",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20127",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20128",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20131",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20132",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20133",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20134",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20135",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20136",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20137",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20138",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20141",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20142",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20143",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20144",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20145",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20146",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20147",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20148",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20149",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20151",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20152",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20153",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20154",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20155",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20156",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20157",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20158",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20159",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20211",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20212",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20213",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20214",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20215",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20216",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20217",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20218",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20219",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20221",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20222",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20223",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20224",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20225",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20226",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20227",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20228",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20229",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20231",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20232",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20233",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20234",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20235",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20236",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20237",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20238",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20239",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20241",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20242",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20243",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20244",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20245",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20250",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20251",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20252",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20253",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20254",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20255",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20256",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20351",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20353",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20354",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20355",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20356",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20357",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20358",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20361",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20362",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20363",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20371",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20372",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20373",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20374",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20411",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20412",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20414",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20415",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20511",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20512",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20513",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20514",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20515",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20516",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20517",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20518",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20524",
  },
  {
    city_short: "MEDAN",
    province: "SUMATERA UTARA",
    postal_code: "20525",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20551",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20552",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20553",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20581",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20582",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20583",
  },
  {
    city_short: "DELI SERDANG",
    province: "SUMATERA UTARA",
    postal_code: "20585",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20611",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20612",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20613",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20614",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20615",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20616",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20621",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20622",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20623",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20624",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20625",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20626",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20627",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20628",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20631",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20632",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20633",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20634",
  },
  {
    city_short: "TEBING TINGGI",
    province: "SUMATERA UTARA",
    postal_code: "20636",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20711",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20712",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20713",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20714",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20715",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20716",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20717",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20718",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20719",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20721",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20722",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20723",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20724",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20725",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20726",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20727",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20728",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20731",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20732",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20733",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20734",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20735",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20736",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20737",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20741",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20742",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20743",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20744",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20745",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20746",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20747",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20748",
  },
  {
    city_short: "BINJAI",
    province: "SUMATERA UTARA",
    postal_code: "20749",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20761",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20762",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20771",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20772",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20773",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20774",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20811",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20812",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20813",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20815",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20816",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20851",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20852",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20853",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20854",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20855",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20856",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20857",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20858",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20859",
  },
  {
    city_short: "LANGKAT",
    province: "SUMATERA UTARA",
    postal_code: "20881",
  },
  {
    city_short: "SERDANG BEDAGAI",
    province: "SUMATERA UTARA",
    postal_code: "20984",
  },
  {
    city_short: "SERDANG BEDAGAI",
    province: "SUMATERA UTARA",
    postal_code: "20986",
  },
  {
    city_short: "SERDANG BEDAGAI",
    province: "SUMATERA UTARA",
    postal_code: "20987",
  },
  {
    city_short: "SERDANG BEDAGAI",
    province: "SUMATERA UTARA",
    postal_code: "20991",
  },
  {
    city_short: "SERDANG BEDAGAI",
    province: "SUMATERA UTARA",
    postal_code: "20992",
  },
  {
    city_short: "SERDANG BEDAGAI",
    province: "SUMATERA UTARA",
    postal_code: "20993",
  },
  {
    city_short: "SERDANG BEDAGAI",
    province: "SUMATERA UTARA",
    postal_code: "20994",
  },
  {
    city_short: "SERDANG BEDAGAI",
    province: "SUMATERA UTARA",
    postal_code: "20995",
  },
  {
    city_short: "SERDANG BEDAGAI",
    province: "SUMATERA UTARA",
    postal_code: "20996",
  },
  {
    city_short: "SERDANG BEDAGAI",
    province: "SUMATERA UTARA",
    postal_code: "20997",
  },
  {
    city_short: "SERDANG BEDAGAI",
    province: "SUMATERA UTARA",
    postal_code: "20998",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21111",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21112",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21113",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21114",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21115",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21116",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21117",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21118",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21121",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21122",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21123",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21124",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21125",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21126",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21127",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21128",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21129",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21131",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21132",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21133",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21134",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21135",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21136",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21137",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21139",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21141",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21142",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21143",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21144",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21145",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21146",
  },
  {
    city_short: "PEM SIANTAR",
    province: "SUMATERA UTARA",
    postal_code: "21147",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21151",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21153",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21154",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21155",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21156",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21157",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21161",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21162",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21163",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21165",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21167",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21168",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21171",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21172",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21173",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21174",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21181",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21182",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21183",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21184",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21186",
  },
  {
    city_short: "SIMALUNGUN",
    province: "SUMATERA UTARA",
    postal_code: "21187",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21211",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21212",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21213",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21214",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21215",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21216",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21217",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21218",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21219",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21221",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21222",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21223",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21224",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21225",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21226",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21227",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21228",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21229",
  },
  {
    city_short: "BATU BARA",
    province: "SUMATERA UTARA",
    postal_code: "21252",
  },
  {
    city_short: "BATU BARA",
    province: "SUMATERA UTARA",
    postal_code: "21253",
  },
  {
    city_short: "BATU BARA",
    province: "SUMATERA UTARA",
    postal_code: "21254",
  },
  {
    city_short: "BATU BARA",
    province: "SUMATERA UTARA",
    postal_code: "21255",
  },
  {
    city_short: "BATU BARA",
    province: "SUMATERA UTARA",
    postal_code: "21256",
  },
  {
    city_short: "BATU BARA",
    province: "SUMATERA UTARA",
    postal_code: "21257",
  },
  {
    city_short: "BATU BARA",
    province: "SUMATERA UTARA",
    postal_code: "21258",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21261",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21262",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21263",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21264",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21271",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21272",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21273",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21274",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21311",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21312",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21313",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21314",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21315",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21316",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21321",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21322",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21323",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21324",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21325",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21331",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21332",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21333",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21334",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21335",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21341",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21342",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21343",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21344",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21345",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21352",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21361",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21362",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21364",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21365",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21366",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21367",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21368",
  },
  {
    city_short: "TANJUNG BALAI",
    province: "SUMATERA UTARA",
    postal_code: "21369",
  },
  {
    city_short: "ASAHAN",
    province: "SUMATERA UTARA",
    postal_code: "21381",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21411",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21412",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21413",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21414",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21415",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21416",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21417",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21418",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21419",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21421",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21422",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21423",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21424",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21425",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21426",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21427",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21428",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21429",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21451",
  },
  {
    city_short: "LABUHANBATU UTA",
    province: "SUMATERA UTARA",
    postal_code: "21452",
  },
  {
    city_short: "LABUHANBATU UTA",
    province: "SUMATERA UTARA",
    postal_code: "21454",
  },
  {
    city_short: "LABUHANBATU UTA",
    province: "SUMATERA UTARA",
    postal_code: "21455",
  },
  {
    city_short: "LABUHANBATU UTA",
    province: "SUMATERA UTARA",
    postal_code: "21457",
  },
  {
    city_short: "LABUHANBATU SEL",
    province: "SUMATERA UTARA",
    postal_code: "21461",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21462",
  },
  {
    city_short: "LABUHANBATU SEL",
    province: "SUMATERA UTARA",
    postal_code: "21463",
  },
  {
    city_short: "LABUHANBATU SEL",
    province: "SUMATERA UTARA",
    postal_code: "21464",
  },
  {
    city_short: "LABUHANBATU SEL",
    province: "SUMATERA UTARA",
    postal_code: "21465",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21471",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21472",
  },
  {
    city_short: "LABUHAN BATU",
    province: "SUMATERA UTARA",
    postal_code: "21473",
  },
  {
    city_short: "LABUHANBATU UTA",
    province: "SUMATERA UTARA",
    postal_code: "21474",
  },
  {
    city_short: "LABUHANBATU UTA",
    province: "SUMATERA UTARA",
    postal_code: "21475",
  },
  {
    city_short: "KARO",
    province: "SUMATERA UTARA",
    postal_code: "22111",
  },
  {
    city_short: "KARO",
    province: "SUMATERA UTARA",
    postal_code: "22112",
  },
  {
    city_short: "KARO",
    province: "SUMATERA UTARA",
    postal_code: "22113",
  },
  {
    city_short: "KARO",
    province: "SUMATERA UTARA",
    postal_code: "22114",
  },
  {
    city_short: "KARO",
    province: "SUMATERA UTARA",
    postal_code: "22115",
  },
  {
    city_short: "KARO",
    province: "SUMATERA UTARA",
    postal_code: "22152",
  },
  {
    city_short: "KARO",
    province: "SUMATERA UTARA",
    postal_code: "22153",
  },
  {
    city_short: "KARO",
    province: "SUMATERA UTARA",
    postal_code: "22154",
  },
  {
    city_short: "KARO",
    province: "SUMATERA UTARA",
    postal_code: "22155",
  },
  {
    city_short: "KARO",
    province: "SUMATERA UTARA",
    postal_code: "22161",
  },
  {
    city_short: "KARO",
    province: "SUMATERA UTARA",
    postal_code: "22162",
  },
  {
    city_short: "KARO",
    province: "SUMATERA UTARA",
    postal_code: "22163",
  },
  {
    city_short: "KARO",
    province: "SUMATERA UTARA",
    postal_code: "22164",
  },
  {
    city_short: "KARO",
    province: "SUMATERA UTARA",
    postal_code: "22165",
  },
  {
    city_short: "KARO",
    province: "SUMATERA UTARA",
    postal_code: "22171",
  },
  {
    city_short: "KARO",
    province: "SUMATERA UTARA",
    postal_code: "22172",
  },
  {
    city_short: "KARO",
    province: "SUMATERA UTARA",
    postal_code: "22173",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22211",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22212",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22213",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22214",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22215",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22216",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22217",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22218",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22219",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22251",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22252",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22253",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22254",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22261",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22262",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22263",
  },
  {
    city_short: "PAKPAK BHARAT",
    province: "SUMATERA UTARA",
    postal_code: "22271",
  },
  {
    city_short: "PAKPAK BHARAT",
    province: "SUMATERA UTARA",
    postal_code: "22272",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22281",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22282",
  },
  {
    city_short: "DAIRI",
    province: "SUMATERA UTARA",
    postal_code: "22283",
  },
  {
    city_short: "TOBA SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22311",
  },
  {
    city_short: "TOBA SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22312",
  },
  {
    city_short: "TOBA SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22313",
  },
  {
    city_short: "TOBA SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22314",
  },
  {
    city_short: "TOBA SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22315",
  },
  {
    city_short: "TOBA SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22316",
  },
  {
    city_short: "TOBA SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22381",
  },
  {
    city_short: "TOBA SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22382",
  },
  {
    city_short: "TOBA SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22383",
  },
  {
    city_short: "TOBA SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22384",
  },
  {
    city_short: "TOBA SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22385",
  },
  {
    city_short: "TOBA SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22386",
  },
  {
    city_short: "SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22391",
  },
  {
    city_short: "SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22392",
  },
  {
    city_short: "SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22393",
  },
  {
    city_short: "SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22394",
  },
  {
    city_short: "SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22395",
  },
  {
    city_short: "SAMOSIR",
    province: "SUMATERA UTARA",
    postal_code: "22396",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22411",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22412",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22413",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22414",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22415",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22416",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22417",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22418",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22419",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22452",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22453",
  },
  {
    city_short: "HUMBAHAS",
    province: "SUMATERA UTARA",
    postal_code: "22454",
  },
  {
    city_short: "HUMBAHAS",
    province: "SUMATERA UTARA",
    postal_code: "22455",
  },
  {
    city_short: "HUMBAHAS",
    province: "SUMATERA UTARA",
    postal_code: "22456",
  },
  {
    city_short: "HUMBAHAS",
    province: "SUMATERA UTARA",
    postal_code: "22457",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22458",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22461",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22463",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22465",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22466",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22471",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22472",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22473",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22474",
  },
  {
    city_short: "HUMBAHAS",
    province: "SUMATERA UTARA",
    postal_code: "22475",
  },
  {
    city_short: "TAPANULI UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22476",
  },
  {
    city_short: "SIBOLGA",
    province: "SUMATERA UTARA",
    postal_code: "22511",
  },
  {
    city_short: "SIBOLGA",
    province: "SUMATERA UTARA",
    postal_code: "22512",
  },
  {
    city_short: "SIBOLGA",
    province: "SUMATERA UTARA",
    postal_code: "22513",
  },
  {
    city_short: "SIBOLGA",
    province: "SUMATERA UTARA",
    postal_code: "22514",
  },
  {
    city_short: "SIBOLGA",
    province: "SUMATERA UTARA",
    postal_code: "22521",
  },
  {
    city_short: "SIBOLGA",
    province: "SUMATERA UTARA",
    postal_code: "22522",
  },
  {
    city_short: "SIBOLGA",
    province: "SUMATERA UTARA",
    postal_code: "22523",
  },
  {
    city_short: "SIBOLGA",
    province: "SUMATERA UTARA",
    postal_code: "22524",
  },
  {
    city_short: "SIBOLGA",
    province: "SUMATERA UTARA",
    postal_code: "22531",
  },
  {
    city_short: "SIBOLGA",
    province: "SUMATERA UTARA",
    postal_code: "22532",
  },
  {
    city_short: "SIBOLGA",
    province: "SUMATERA UTARA",
    postal_code: "22533",
  },
  {
    city_short: "SIBOLGA",
    province: "SUMATERA UTARA",
    postal_code: "22534",
  },
  {
    city_short: "SIBOLGA",
    province: "SUMATERA UTARA",
    postal_code: "22535",
  },
  {
    city_short: "SIBOLGA",
    province: "SUMATERA UTARA",
    postal_code: "22536",
  },
  {
    city_short: "SIBOLGA",
    province: "SUMATERA UTARA",
    postal_code: "22537",
  },
  {
    city_short: "SIBOLGA",
    province: "SUMATERA UTARA",
    postal_code: "22538",
  },
  {
    city_short: "TAPANULI TENGAH",
    province: "SUMATERA UTARA",
    postal_code: "22562",
  },
  {
    city_short: "TAPANULI TENGAH",
    province: "SUMATERA UTARA",
    postal_code: "22563",
  },
  {
    city_short: "TAPANULI TENGAH",
    province: "SUMATERA UTARA",
    postal_code: "22564",
  },
  {
    city_short: "TAPANULI TENGAH",
    province: "SUMATERA UTARA",
    postal_code: "22565",
  },
  {
    city_short: "TAPANULI TENGAH",
    province: "SUMATERA UTARA",
    postal_code: "22611",
  },
  {
    city_short: "TAPANULI TENGAH",
    province: "SUMATERA UTARA",
    postal_code: "22612",
  },
  {
    city_short: "TAPANULI TENGAH",
    province: "SUMATERA UTARA",
    postal_code: "22613",
  },
  {
    city_short: "TAPANULI TENGAH",
    province: "SUMATERA UTARA",
    postal_code: "22614",
  },
  {
    city_short: "TAPANULI TENGAH",
    province: "SUMATERA UTARA",
    postal_code: "22615",
  },
  {
    city_short: "TAPANULI TENGAH",
    province: "SUMATERA UTARA",
    postal_code: "22616",
  },
  {
    city_short: "TAPANULI TENGAH",
    province: "SUMATERA UTARA",
    postal_code: "22617",
  },
  {
    city_short: "TAPANULI TENGAH",
    province: "SUMATERA UTARA",
    postal_code: "22618",
  },
  {
    city_short: "TAPANULI TENGAH",
    province: "SUMATERA UTARA",
    postal_code: "22651",
  },
  {
    city_short: "TAPANULI TENGAH",
    province: "SUMATERA UTARA",
    postal_code: "22654",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22711",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22712",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22713",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22714",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22715",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22716",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22718",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22719",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22721",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22722",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22723",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22724",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22725",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22726",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22727",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22728",
  },
  {
    city_short: "TAPANULI SEL",
    province: "SUMATERA UTARA",
    postal_code: "22732",
  },
  {
    city_short: "PADANG LAWAS UT",
    province: "SUMATERA UTARA",
    postal_code: "22733",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22733",
  },
  {
    city_short: "TAPANULI SEL",
    province: "SUMATERA UTARA",
    postal_code: "22733",
  },
  {
    city_short: "TAPANULI SEL",
    province: "SUMATERA UTARA",
    postal_code: "22735",
  },
  {
    city_short: "TAPANULI SEL",
    province: "SUMATERA UTARA",
    postal_code: "22738",
  },
  {
    city_short: "PADANG LAWAS UT",
    province: "SUMATERA UTARA",
    postal_code: "22741",
  },
  {
    city_short: "PADANG LAWAS",
    province: "SUMATERA UTARA",
    postal_code: "22742",
  },
  {
    city_short: "TAPANULI SEL",
    province: "SUMATERA UTARA",
    postal_code: "22742",
  },
  {
    city_short: "TAPANULI SEL",
    province: "SUMATERA UTARA",
    postal_code: "22747",
  },
  {
    city_short: "PADANG LAWAS UT",
    province: "SUMATERA UTARA",
    postal_code: "22747",
  },
  {
    city_short: "PADANG SIDEMPUA",
    province: "SUMATERA UTARA",
    postal_code: "22753",
  },
  {
    city_short: "PADANG LAWAS UT",
    province: "SUMATERA UTARA",
    postal_code: "22753",
  },
  {
    city_short: "PADANG LAWAS",
    province: "SUMATERA UTARA",
    postal_code: "22755",
  },
  {
    city_short: "PADANG LAWAS UT",
    province: "SUMATERA UTARA",
    postal_code: "22756",
  },
  {
    city_short: "TAPANULI SEL",
    province: "SUMATERA UTARA",
    postal_code: "22758",
  },
  {
    city_short: "PADANG LAWAS UT",
    province: "SUMATERA UTARA",
    postal_code: "22762",
  },
  {
    city_short: "PADANG LAWAS",
    province: "SUMATERA UTARA",
    postal_code: "22762",
  },
  {
    city_short: "PADANG LAWAS",
    province: "SUMATERA UTARA",
    postal_code: "22763",
  },
  {
    city_short: "PADANG LAWAS",
    province: "SUMATERA UTARA",
    postal_code: "22765",
  },
  {
    city_short: "TAPANULI SEL",
    province: "SUMATERA UTARA",
    postal_code: "22773",
  },
  {
    city_short: "TAPANULI SEL",
    province: "SUMATERA UTARA",
    postal_code: "22774",
  },
  {
    city_short: "PADANG LAWAS",
    province: "SUMATERA UTARA",
    postal_code: "22774",
  },
  {
    city_short: "GUNUNGSITOLI",
    province: "SUMATERA UTARA",
    postal_code: "22811",
  },
  {
    city_short: "NIAS BARAT",
    province: "SUMATERA UTARA",
    postal_code: "22812",
  },
  {
    city_short: "GUNUNGSITOLI",
    province: "SUMATERA UTARA",
    postal_code: "22812",
  },
  {
    city_short: "GUNUNGSITOLI",
    province: "SUMATERA UTARA",
    postal_code: "22814",
  },
  {
    city_short: "NIAS UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22814",
  },
  {
    city_short: "NIAS BARAT",
    province: "SUMATERA UTARA",
    postal_code: "22814",
  },
  {
    city_short: "NIAS",
    province: "SUMATERA UTARA",
    postal_code: "22815",
  },
  {
    city_short: "NIAS UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22816",
  },
  {
    city_short: "NIAS UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22817",
  },
  {
    city_short: "GUNUNGSITOLI",
    province: "SUMATERA UTARA",
    postal_code: "22851",
  },
  {
    city_short: "NIAS UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22851",
  },
  {
    city_short: "NIAS",
    province: "SUMATERA UTARA",
    postal_code: "22851",
  },
  {
    city_short: "NIAS UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22852",
  },
  {
    city_short: "NIAS",
    province: "SUMATERA UTARA",
    postal_code: "22852",
  },
  {
    city_short: "NIAS UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22853",
  },
  {
    city_short: "NIAS",
    province: "SUMATERA UTARA",
    postal_code: "22854",
  },
  {
    city_short: "NIAS UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22857",
  },
  {
    city_short: "NIAS UTARA",
    province: "SUMATERA UTARA",
    postal_code: "22861",
  },
  {
    city_short: "NIAS",
    province: "SUMATERA UTARA",
    postal_code: "22861",
  },
  {
    city_short: "NIAS BARAT",
    province: "SUMATERA UTARA",
    postal_code: "22862",
  },
  {
    city_short: "NIAS BARAT",
    province: "SUMATERA UTARA",
    postal_code: "22863",
  },
  {
    city_short: "NIAS SELATAN",
    province: "SUMATERA UTARA",
    postal_code: "22864",
  },
  {
    city_short: "NIAS BARAT",
    province: "SUMATERA UTARA",
    postal_code: "22864",
  },
  {
    city_short: "NIAS SELATAN",
    province: "SUMATERA UTARA",
    postal_code: "22865",
  },
  {
    city_short: "NIAS SELATAN",
    province: "SUMATERA UTARA",
    postal_code: "22866",
  },
  {
    city_short: "NIAS BARAT",
    province: "SUMATERA UTARA",
    postal_code: "22867",
  },
  {
    city_short: "NIAS SELATAN",
    province: "SUMATERA UTARA",
    postal_code: "22867",
  },
  {
    city_short: "NIAS",
    province: "SUMATERA UTARA",
    postal_code: "22871",
  },
  {
    city_short: "GUNUNGSITOLI",
    province: "SUMATERA UTARA",
    postal_code: "22871",
  },
  {
    city_short: "NIAS",
    province: "SUMATERA UTARA",
    postal_code: "22872",
  },
  {
    city_short: "NIAS SELATAN",
    province: "SUMATERA UTARA",
    postal_code: "22873",
  },
  {
    city_short: "NIAS SELATAN",
    province: "SUMATERA UTARA",
    postal_code: "22874",
  },
  {
    city_short: "NIAS BARAT",
    province: "SUMATERA UTARA",
    postal_code: "22875",
  },
  {
    city_short: "NIAS",
    province: "SUMATERA UTARA",
    postal_code: "22876",
  },
  {
    city_short: "NIAS SELATAN",
    province: "SUMATERA UTARA",
    postal_code: "22881",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22911",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22912",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22913",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22915",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22916",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22917",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22918",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22919",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22952",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22976",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22977",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22978",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22983",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22987",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22988",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22989",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22994",
  },
  {
    city_short: "MANDAILING NATA",
    province: "SUMATERA UTARA",
    postal_code: "22998",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23111",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23112",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23114",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23115",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23116",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23117",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23118",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23119",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23121",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23122",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23123",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23124",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23125",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23126",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23127",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23128",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23129",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23230",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23231",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23232",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23233",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23234",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23235",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23236",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23238",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23239",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23241",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23242",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23243",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23244",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23245",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23246",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23247",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23248",
  },
  {
    city_short: "BANDA ACEH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23249",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23351",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23352",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23353",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23354",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23361",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23362",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23363",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23371",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23372",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23373",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23381",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23391",
  },
  {
    city_short: "SABANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23511",
  },
  {
    city_short: "SABANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23512",
  },
  {
    city_short: "SABANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23513",
  },
  {
    city_short: "SABANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23514",
  },
  {
    city_short: "SABANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23515",
  },
  {
    city_short: "SABANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23516",
  },
  {
    city_short: "SABANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23517",
  },
  {
    city_short: "SABANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23518",
  },
  {
    city_short: "SABANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23521",
  },
  {
    city_short: "SABANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23522",
  },
  {
    city_short: "SABANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23523",
  },
  {
    city_short: "SABANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23524",
  },
  {
    city_short: "SABANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23525",
  },
  {
    city_short: "SABANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23526",
  },
  {
    city_short: "SABANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23527",
  },
  {
    city_short: "SABANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23528",
  },
  {
    city_short: "SABANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23529",
  },
  {
    city_short: "ACEH BARAT",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23611",
  },
  {
    city_short: "ACEH BARAT",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23612",
  },
  {
    city_short: "ACEH BARAT",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23613",
  },
  {
    city_short: "ACEH BARAT",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23614",
  },
  {
    city_short: "ACEH BARAT",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23615",
  },
  {
    city_short: "ACEH BARAT",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23616",
  },
  {
    city_short: "ACEH BARAT",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23617",
  },
  {
    city_short: "ACEH BARAT",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23618",
  },
  {
    city_short: "ACEH BARAT",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23652",
  },
  {
    city_short: "ACEH JAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23653",
  },
  {
    city_short: "ACEH BARAT",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23654",
  },
  {
    city_short: "ACEH JAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23654",
  },
  {
    city_short: "ACEH JAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23655",
  },
  {
    city_short: "ACEH JAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23656",
  },
  {
    city_short: "ACEH JAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23657",
  },
  {
    city_short: "NAGAN RAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23661",
  },
  {
    city_short: "NAGAN RAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23662",
  },
  {
    city_short: "NAGAN RAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23671",
  },
  {
    city_short: "NAGAN RAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23672",
  },
  {
    city_short: "ACEH BARAT",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23681",
  },
  {
    city_short: "ACEH BARAT",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23682",
  },
  {
    city_short: "ACEH BARAT",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23683",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23711",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23712",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23713",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23714",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23715",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23716",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23717",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23718",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23752",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23753",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23754",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23755",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23757",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23758",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23761",
  },
  {
    city_short: "ACEH BARAT DAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23762",
  },
  {
    city_short: "ACEH BARAT DAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23763",
  },
  {
    city_short: "ACEH BARAT DAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23764",
  },
  {
    city_short: "ACEH BARAT DAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23765",
  },
  {
    city_short: "ACEH BARAT DAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23766",
  },
  {
    city_short: "ACEH BARAT DAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23767",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23771",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23772",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23773",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23774",
  },
  {
    city_short: "ACEH SELATAN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23776",
  },
  {
    city_short: "SIMEULUE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23891",
  },
  {
    city_short: "SIMEULUE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23892",
  },
  {
    city_short: "SIMEULUE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23893",
  },
  {
    city_short: "SIMEULUE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23894",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23911",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23912",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23913",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23915",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23917",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23918",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23919",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23951",
  },
  {
    city_short: "ACEH BESAR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "23952",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24111",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24112",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24113",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24114",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24115",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24116",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24118",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24119",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24151",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24152",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24153",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24161",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24162",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24163",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24164",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24165",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24166",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24167",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24171",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24172",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24173",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24174",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24181",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24182",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24183",
  },
  {
    city_short: "PIDIE JAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24184",
  },
  {
    city_short: "PIDIE JAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24185",
  },
  {
    city_short: "PIDIE JAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24186",
  },
  {
    city_short: "PIDIE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24186",
  },
  {
    city_short: "PIDIE JAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24187",
  },
  {
    city_short: "PIDIE JAYA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24188",
  },
  {
    city_short: "BIREUEN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24251",
  },
  {
    city_short: "BIREUEN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24261",
  },
  {
    city_short: "BIREUEN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24262",
  },
  {
    city_short: "BIREUEN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24263",
  },
  {
    city_short: "BIREUEN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24264",
  },
  {
    city_short: "LHOKSEUMAWE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24311",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24313",
  },
  {
    city_short: "LHOKSEUMAWE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24313",
  },
  {
    city_short: "LHOKSEUMAWE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24314",
  },
  {
    city_short: "LHOKSEUMAWE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24315",
  },
  {
    city_short: "LHOKSEUMAWE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24351",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24352",
  },
  {
    city_short: "LHOKSEUMAWE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24352",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24354",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24355",
  },
  {
    city_short: "BIREUEN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24356",
  },
  {
    city_short: "BIREUEN",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24357",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24371",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24372",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24373",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24374",
  },
  {
    city_short: "LHOKSEUMAWE",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24375",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24376",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24377",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24381",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24382",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24385",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24386",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24391",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24392",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24393",
  },
  {
    city_short: "ACEH UTARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24394",
  },
  {
    city_short: "LANGSA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24410",
  },
  {
    city_short: "LANGSA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24411",
  },
  {
    city_short: "LANGSA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24412",
  },
  {
    city_short: "LANGSA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24413",
  },
  {
    city_short: "LANGSA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24414",
  },
  {
    city_short: "LANGSA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24415",
  },
  {
    city_short: "LANGSA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24416",
  },
  {
    city_short: "LANGSA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24451",
  },
  {
    city_short: "ACEH TIMUR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24452",
  },
  {
    city_short: "ACEH TIMUR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24453",
  },
  {
    city_short: "ACEH TIMUR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24454",
  },
  {
    city_short: "ACEH TIMUR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24455",
  },
  {
    city_short: "ACEH TIMUR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24456",
  },
  {
    city_short: "ACEH TIMUR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24457",
  },
  {
    city_short: "ACEH TIMUR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24458",
  },
  {
    city_short: "ACEH TIMUR",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24461",
  },
  {
    city_short: "ACEH TAMIANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24471",
  },
  {
    city_short: "ACEH TAMIANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24472",
  },
  {
    city_short: "ACEH TAMIANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24473",
  },
  {
    city_short: "ACEH TAMIANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24474",
  },
  {
    city_short: "ACEH TAMIANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24475",
  },
  {
    city_short: "ACEH TAMIANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24476",
  },
  {
    city_short: "ACEH TAMIANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24477",
  },
  {
    city_short: "ACEH TAMIANG",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24478",
  },
  {
    city_short: "ACEH TENGAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24511",
  },
  {
    city_short: "ACEH TENGAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24512",
  },
  {
    city_short: "ACEH TENGAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24513",
  },
  {
    city_short: "ACEH TENGAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24514",
  },
  {
    city_short: "ACEH TENGAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24515",
  },
  {
    city_short: "ACEH TENGAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24516",
  },
  {
    city_short: "ACEH TENGAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24517",
  },
  {
    city_short: "ACEH TENGAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24518",
  },
  {
    city_short: "ACEH TENGAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24519",
  },
  {
    city_short: "ACEH TENGAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24552",
  },
  {
    city_short: "BENER MERIAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24553",
  },
  {
    city_short: "ACEH TENGAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24561",
  },
  {
    city_short: "ACEH TENGAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24562",
  },
  {
    city_short: "ACEH TENGAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24563",
  },
  {
    city_short: "ACEH TENGAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24568",
  },
  {
    city_short: "ACEH TENGAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24571",
  },
  {
    city_short: "BENER MERIAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24581",
  },
  {
    city_short: "BENER MERIAH",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24582",
  },
  {
    city_short: "ACEH TENGGARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24651",
  },
  {
    city_short: "ACEH TENGGARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24652",
  },
  {
    city_short: "ACEH TENGGARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24653",
  },
  {
    city_short: "GAYO LUES",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24653",
  },
  {
    city_short: "GAYO LUES",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24654",
  },
  {
    city_short: "GAYO LUES",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24655",
  },
  {
    city_short: "GAYO LUES",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24656",
  },
  {
    city_short: "ACEH TENGGARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24661",
  },
  {
    city_short: "ACEH TENGGARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24671",
  },
  {
    city_short: "ACEH TENGGARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24673",
  },
  {
    city_short: "ACEH TENGGARA",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24678",
  },
  {
    city_short: "SUBULUSSALAM",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24782",
  },
  {
    city_short: "ACEH SINGKIL",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24783",
  },
  {
    city_short: "ACEH SINGKIL",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24784",
  },
  {
    city_short: "ACEH SINGKIL",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24785",
  },
  {
    city_short: "SUBULUSSALAM",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24786",
  },
  {
    city_short: "ACEH SINGKIL",
    province: "NANGGROE ACEH DARUSSALAM (NAD)",
    postal_code: "24791",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25111",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25112",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25114",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25115",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25117",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25118",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25119",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25121",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25122",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25123",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25125",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25126",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25129",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25132",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25133",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25134",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25136",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25137",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25139",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25142",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25143",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25144",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25145",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25146",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25147",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25151",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25152",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25153",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25154",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25155",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25156",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25157",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25158",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25159",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25161",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25162",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25163",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25164",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25166",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25168",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25171",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25172",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25173",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25175",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25176",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25211",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25212",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25213",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25214",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25215",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25216",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25217",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25221",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25222",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25223",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25224",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25225",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25226",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25227",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25231",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25232",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25233",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25234",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25235",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25236",
  },
  {
    city_short: "PADANG",
    province: "SUMATERA BARAT",
    postal_code: "25237",
  },
  {
    city_short: "KEP MENTAWAI",
    province: "SUMATERA BARAT",
    postal_code: "25391",
  },
  {
    city_short: "KEP MENTAWAI",
    province: "SUMATERA BARAT",
    postal_code: "25392",
  },
  {
    city_short: "KEP MENTAWAI",
    province: "SUMATERA BARAT",
    postal_code: "25393",
  },
  {
    city_short: "KEP MENTAWAI",
    province: "SUMATERA BARAT",
    postal_code: "25394",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25511",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25512",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25513",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25514",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25515",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25516",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25517",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25518",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25519",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25521",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25522",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25523",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25524",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25526",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25529",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25531",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25532",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25533",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25534",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25535",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25536",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25537",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25538",
  },
  {
    city_short: "PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25539",
  },
  {
    city_short: "PADANG PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25552",
  },
  {
    city_short: "PADANG PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25561",
  },
  {
    city_short: "PADANG PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25563",
  },
  {
    city_short: "PADANG PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25564",
  },
  {
    city_short: "PADANG PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25571",
  },
  {
    city_short: "PADANG PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25572",
  },
  {
    city_short: "PADANG PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25573",
  },
  {
    city_short: "PADANG PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25581",
  },
  {
    city_short: "PADANG PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25582",
  },
  {
    city_short: "PADANG PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25584",
  },
  {
    city_short: "PADANG PARIAMAN",
    province: "SUMATERA BARAT",
    postal_code: "25586",
  },
  {
    city_short: "PESISIR SELATAN",
    province: "SUMATERA BARAT",
    postal_code: "25651",
  },
  {
    city_short: "PESISIR SELATAN",
    province: "SUMATERA BARAT",
    postal_code: "25652",
  },
  {
    city_short: "PESISIR SELATAN",
    province: "SUMATERA BARAT",
    postal_code: "25654",
  },
  {
    city_short: "PESISIR SELATAN",
    province: "SUMATERA BARAT",
    postal_code: "25661",
  },
  {
    city_short: "PESISIR SELATAN",
    province: "SUMATERA BARAT",
    postal_code: "25662",
  },
  {
    city_short: "PESISIR SELATAN",
    province: "SUMATERA BARAT",
    postal_code: "25663",
  },
  {
    city_short: "PESISIR SELATAN",
    province: "SUMATERA BARAT",
    postal_code: "25666",
  },
  {
    city_short: "PESISIR SELATAN",
    province: "SUMATERA BARAT",
    postal_code: "25668",
  },
  {
    city_short: "PESISIR SELATAN",
    province: "SUMATERA BARAT",
    postal_code: "25673",
  },
  {
    city_short: "PESISIR SELATAN",
    province: "SUMATERA BARAT",
    postal_code: "25674",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26111",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26112",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26113",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26114",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26115",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26116",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26117",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26121",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26122",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26123",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26124",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26125",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26126",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26127",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26128",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26129",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26131",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26132",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26133",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26134",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26135",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26136",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26137",
  },
  {
    city_short: "BUKITTINGGI",
    province: "SUMATERA BARAT",
    postal_code: "26138",
  },
  {
    city_short: "AGAM",
    province: "SUMATERA BARAT",
    postal_code: "26151",
  },
  {
    city_short: "AGAM",
    province: "SUMATERA BARAT",
    postal_code: "26152",
  },
  {
    city_short: "AGAM",
    province: "SUMATERA BARAT",
    postal_code: "26161",
  },
  {
    city_short: "AGAM",
    province: "SUMATERA BARAT",
    postal_code: "26162",
  },
  {
    city_short: "AGAM",
    province: "SUMATERA BARAT",
    postal_code: "26164",
  },
  {
    city_short: "AGAM",
    province: "SUMATERA BARAT",
    postal_code: "26181",
  },
  {
    city_short: "AGAM",
    province: "SUMATERA BARAT",
    postal_code: "26191",
  },
  {
    city_short: "AGAM",
    province: "SUMATERA BARAT",
    postal_code: "26192",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26211",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26212",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26213",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26214",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26215",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26216",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26217",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26218",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26219",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26221",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26222",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26223",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26224",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26225",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26226",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26227",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26228",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26229",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26231",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26232",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26233",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26235",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26236",
  },
  {
    city_short: "PAYAKUMBUH",
    province: "SUMATERA BARAT",
    postal_code: "26237",
  },
  {
    city_short: "LIMA PULUH KOTA",
    province: "SUMATERA BARAT",
    postal_code: "26251",
  },
  {
    city_short: "LIMA PULUH KOTA",
    province: "SUMATERA BARAT",
    postal_code: "26252",
  },
  {
    city_short: "LIMA PULUH KOTA",
    province: "SUMATERA BARAT",
    postal_code: "26253",
  },
  {
    city_short: "LIMA PULUH KOTA",
    province: "SUMATERA BARAT",
    postal_code: "26254",
  },
  {
    city_short: "LIMA PULUH KOTA",
    province: "SUMATERA BARAT",
    postal_code: "26255",
  },
  {
    city_short: "LIMA PULUH KOTA",
    province: "SUMATERA BARAT",
    postal_code: "26256",
  },
  {
    city_short: "LIMA PULUH KOTA",
    province: "SUMATERA BARAT",
    postal_code: "26257",
  },
  {
    city_short: "LIMA PULUH KOTA",
    province: "SUMATERA BARAT",
    postal_code: "26261",
  },
  {
    city_short: "LIMA PULUH KOTA",
    province: "SUMATERA BARAT",
    postal_code: "26262",
  },
  {
    city_short: "LIMA PULUH KOTA",
    province: "SUMATERA BARAT",
    postal_code: "26271",
  },
  {
    city_short: "LIMA PULUH KOTA",
    province: "SUMATERA BARAT",
    postal_code: "26272",
  },
  {
    city_short: "LIMA PULUH KOTA",
    province: "SUMATERA BARAT",
    postal_code: "26273",
  },
  {
    city_short: "PASAMAN",
    province: "SUMATERA BARAT",
    postal_code: "26311",
  },
  {
    city_short: "PASAMAN",
    province: "SUMATERA BARAT",
    postal_code: "26318",
  },
  {
    city_short: "PASAMAN",
    province: "SUMATERA BARAT",
    postal_code: "26352",
  },
  {
    city_short: "PASAMAN",
    province: "SUMATERA BARAT",
    postal_code: "26353",
  },
  {
    city_short: "PASAMAN BARAT",
    province: "SUMATERA BARAT",
    postal_code: "26366",
  },
  {
    city_short: "PASAMAN",
    province: "SUMATERA BARAT",
    postal_code: "26381",
  },
  {
    city_short: "AGAM",
    province: "SUMATERA BARAT",
    postal_code: "26451",
  },
  {
    city_short: "AGAM",
    province: "SUMATERA BARAT",
    postal_code: "26471",
  },
  {
    city_short: "AGAM",
    province: "SUMATERA BARAT",
    postal_code: "26473",
  },
  {
    city_short: "PASAMAN BARAT",
    province: "SUMATERA BARAT",
    postal_code: "26561",
  },
  {
    city_short: "PASAMAN BARAT",
    province: "SUMATERA BARAT",
    postal_code: "26566",
  },
  {
    city_short: "PASAMAN BARAT",
    province: "SUMATERA BARAT",
    postal_code: "26567",
  },
  {
    city_short: "PASAMAN BARAT",
    province: "SUMATERA BARAT",
    postal_code: "26571",
  },
  {
    city_short: "PASAMAN BARAT",
    province: "SUMATERA BARAT",
    postal_code: "26572",
  },
  {
    city_short: "PASAMAN BARAT",
    province: "SUMATERA BARAT",
    postal_code: "26573",
  },
  {
    city_short: "PADANG PANJANG",
    province: "SUMATERA BARAT",
    postal_code: "27111",
  },
  {
    city_short: "PADANG PANJANG",
    province: "SUMATERA BARAT",
    postal_code: "27112",
  },
  {
    city_short: "PADANG PANJANG",
    province: "SUMATERA BARAT",
    postal_code: "27113",
  },
  {
    city_short: "PADANG PANJANG",
    province: "SUMATERA BARAT",
    postal_code: "27114",
  },
  {
    city_short: "PADANG PANJANG",
    province: "SUMATERA BARAT",
    postal_code: "27115",
  },
  {
    city_short: "PADANG PANJANG",
    province: "SUMATERA BARAT",
    postal_code: "27116",
  },
  {
    city_short: "PADANG PANJANG",
    province: "SUMATERA BARAT",
    postal_code: "27117",
  },
  {
    city_short: "PADANG PANJANG",
    province: "SUMATERA BARAT",
    postal_code: "27118",
  },
  {
    city_short: "PADANG PANJANG",
    province: "SUMATERA BARAT",
    postal_code: "27121",
  },
  {
    city_short: "PADANG PANJANG",
    province: "SUMATERA BARAT",
    postal_code: "27122",
  },
  {
    city_short: "PADANG PANJANG",
    province: "SUMATERA BARAT",
    postal_code: "27123",
  },
  {
    city_short: "PADANG PANJANG",
    province: "SUMATERA BARAT",
    postal_code: "27124",
  },
  {
    city_short: "PADANG PANJANG",
    province: "SUMATERA BARAT",
    postal_code: "27125",
  },
  {
    city_short: "PADANG PANJANG",
    province: "SUMATERA BARAT",
    postal_code: "27126",
  },
  {
    city_short: "PADANG PANJANG",
    province: "SUMATERA BARAT",
    postal_code: "27127",
  },
  {
    city_short: "PADANG PANJANG",
    province: "SUMATERA BARAT",
    postal_code: "27128",
  },
  {
    city_short: "TANAH DATAR",
    province: "SUMATERA BARAT",
    postal_code: "27151",
  },
  {
    city_short: "TANAH DATAR",
    province: "SUMATERA BARAT",
    postal_code: "27211",
  },
  {
    city_short: "TANAH DATAR",
    province: "SUMATERA BARAT",
    postal_code: "27213",
  },
  {
    city_short: "TANAH DATAR",
    province: "SUMATERA BARAT",
    postal_code: "27216",
  },
  {
    city_short: "TANAH DATAR",
    province: "SUMATERA BARAT",
    postal_code: "27261",
  },
  {
    city_short: "TANAH DATAR",
    province: "SUMATERA BARAT",
    postal_code: "27262",
  },
  {
    city_short: "TANAH DATAR",
    province: "SUMATERA BARAT",
    postal_code: "27263",
  },
  {
    city_short: "TANAH DATAR",
    province: "SUMATERA BARAT",
    postal_code: "27264",
  },
  {
    city_short: "TANAH DATAR",
    province: "SUMATERA BARAT",
    postal_code: "27265",
  },
  {
    city_short: "TANAH DATAR",
    province: "SUMATERA BARAT",
    postal_code: "27271",
  },
  {
    city_short: "TANAH DATAR",
    province: "SUMATERA BARAT",
    postal_code: "27281",
  },
  {
    city_short: "TANAH DATAR",
    province: "SUMATERA BARAT",
    postal_code: "27282",
  },
  {
    city_short: "TANAH DATAR",
    province: "SUMATERA BARAT",
    postal_code: "27292",
  },
  {
    city_short: "TANAH DATAR",
    province: "SUMATERA BARAT",
    postal_code: "27294",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27311",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27312",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27313",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27314",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27315",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27316",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27317",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27321",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27322",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27323",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27324",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27325",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27326",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27355",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27356",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27361",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27365",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27371",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27372",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27373",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27381",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27383",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27387",
  },
  {
    city_short: "SOLOK",
    province: "SUMATERA BARAT",
    postal_code: "27388",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27411",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27412",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27413",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27415",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27416",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27418",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27419",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27421",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27422",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27423",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27424",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27425",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27427",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27431",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27432",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27433",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27434",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27435",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27441",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27442",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27443",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27444",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27445",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27446",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27447",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27448",
  },
  {
    city_short: "SAWAH LUNTO",
    province: "SUMATERA BARAT",
    postal_code: "27449",
  },
  {
    city_short: "SIJUNJUNG",
    province: "SUMATERA BARAT",
    postal_code: "27511",
  },
  {
    city_short: "SIJUNJUNG",
    province: "SUMATERA BARAT",
    postal_code: "27553",
  },
  {
    city_short: "SIJUNJUNG",
    province: "SUMATERA BARAT",
    postal_code: "27561",
  },
  {
    city_short: "SIJUNJUNG",
    province: "SUMATERA BARAT",
    postal_code: "27562",
  },
  {
    city_short: "SIJUNJUNG",
    province: "SUMATERA BARAT",
    postal_code: "27563",
  },
  {
    city_short: "SIJUNJUNG",
    province: "SUMATERA BARAT",
    postal_code: "27564",
  },
  {
    city_short: "SIJUNJUNG",
    province: "SUMATERA BARAT",
    postal_code: "27571",
  },
  {
    city_short: "SIJUNJUNG",
    province: "SUMATERA BARAT",
    postal_code: "27572",
  },
  {
    city_short: "DHARMASRAYA",
    province: "SUMATERA BARAT",
    postal_code: "27573",
  },
  {
    city_short: "DHARMASRAYA",
    province: "SUMATERA BARAT",
    postal_code: "27678",
  },
  {
    city_short: "DHARMASRAYA",
    province: "SUMATERA BARAT",
    postal_code: "27681",
  },
  {
    city_short: "DHARMASRAYA",
    province: "SUMATERA BARAT",
    postal_code: "27684",
  },
  {
    city_short: "SOLOK SELATAN",
    province: "SUMATERA BARAT",
    postal_code: "27775",
  },
  {
    city_short: "SOLOK SELATAN",
    province: "SUMATERA BARAT",
    postal_code: "27776",
  },
  {
    city_short: "SOLOK SELATAN",
    province: "SUMATERA BARAT",
    postal_code: "27777",
  },
  {
    city_short: "SOLOK SELATAN",
    province: "SUMATERA BARAT",
    postal_code: "27778",
  },
  {
    city_short: "SOLOK SELATAN",
    province: "SUMATERA BARAT",
    postal_code: "27779",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28111",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28112",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28113",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28114",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28115",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28116",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28121",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28122",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28123",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28124",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28125",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28126",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28127",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28128",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28131",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28141",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28142",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28143",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28144",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28151",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28152",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28153",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28154",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28155",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28156",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28261",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28262",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28263",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28264",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28265",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28266",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28267",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28281",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28282",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28284",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28285",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28286",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28287",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28288",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28289",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28291",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28292",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28293",
  },
  {
    city_short: "PEKANBARU",
    province: "RIAU",
    postal_code: "28294",
  },
  {
    city_short: "PELALAWAN",
    province: "RIAU",
    postal_code: "28353",
  },
  {
    city_short: "PELALAWAN",
    province: "RIAU",
    postal_code: "28381",
  },
  {
    city_short: "PELALAWAN",
    province: "RIAU",
    postal_code: "28382",
  },
  {
    city_short: "PELALAWAN",
    province: "RIAU",
    postal_code: "28383",
  },
  {
    city_short: "PELALAWAN",
    province: "RIAU",
    postal_code: "28384",
  },
  {
    city_short: "KAMPAR",
    province: "RIAU",
    postal_code: "28411",
  },
  {
    city_short: "KAMPAR",
    province: "RIAU",
    postal_code: "28412",
  },
  {
    city_short: "KAMPAR",
    province: "RIAU",
    postal_code: "28451",
  },
  {
    city_short: "KAMPAR",
    province: "RIAU",
    postal_code: "28452",
  },
  {
    city_short: "KAMPAR",
    province: "RIAU",
    postal_code: "28453",
  },
  {
    city_short: "KAMPAR",
    province: "RIAU",
    postal_code: "28458",
  },
  {
    city_short: "KAMPAR",
    province: "RIAU",
    postal_code: "28461",
  },
  {
    city_short: "KAMPAR",
    province: "RIAU",
    postal_code: "28462",
  },
  {
    city_short: "KAMPAR",
    province: "RIAU",
    postal_code: "28463",
  },
  {
    city_short: "KAMPAR",
    province: "RIAU",
    postal_code: "28464",
  },
  {
    city_short: "KAMPAR",
    province: "RIAU",
    postal_code: "28471",
  },
  {
    city_short: "ROKAN HULU",
    province: "RIAU",
    postal_code: "28554",
  },
  {
    city_short: "ROKAN HULU",
    province: "RIAU",
    postal_code: "28555",
  },
  {
    city_short: "ROKAN HULU",
    province: "RIAU",
    postal_code: "28556",
  },
  {
    city_short: "ROKAN HULU",
    province: "RIAU",
    postal_code: "28557",
  },
  {
    city_short: "ROKAN HULU",
    province: "RIAU",
    postal_code: "28558",
  },
  {
    city_short: "ROKAN HULU",
    province: "RIAU",
    postal_code: "28559",
  },
  {
    city_short: "ROKAN HULU",
    province: "RIAU",
    postal_code: "28565",
  },
  {
    city_short: "SIAK",
    province: "RIAU",
    postal_code: "28654",
  },
  {
    city_short: "SIAK",
    province: "RIAU",
    postal_code: "28662",
  },
  {
    city_short: "SIAK",
    province: "RIAU",
    postal_code: "28671",
  },
  {
    city_short: "SIAK",
    province: "RIAU",
    postal_code: "28685",
  },
  {
    city_short: "SIAK",
    province: "RIAU",
    postal_code: "28686",
  },
  {
    city_short: "BENGKALIS",
    province: "RIAU",
    postal_code: "28711",
  },
  {
    city_short: "BENGKALIS",
    province: "RIAU",
    postal_code: "28712",
  },
  {
    city_short: "BENGKALIS",
    province: "RIAU",
    postal_code: "28713",
  },
  {
    city_short: "BENGKALIS",
    province: "RIAU",
    postal_code: "28714",
  },
  {
    city_short: "KEP MERANTI",
    province: "RIAU",
    postal_code: "28752",
  },
  {
    city_short: "KEP MERANTI",
    province: "RIAU",
    postal_code: "28753",
  },
  {
    city_short: "BENGKALIS",
    province: "RIAU",
    postal_code: "28754",
  },
  {
    city_short: "KEP MERANTI",
    province: "RIAU",
    postal_code: "28755",
  },
  {
    city_short: "BENGKALIS",
    province: "RIAU",
    postal_code: "28761",
  },
  {
    city_short: "SIAK",
    province: "RIAU",
    postal_code: "28763",
  },
  {
    city_short: "BENGKALIS",
    province: "RIAU",
    postal_code: "28771",
  },
  {
    city_short: "SIAK",
    province: "RIAU",
    postal_code: "28772",
  },
  {
    city_short: "SIAK",
    province: "RIAU",
    postal_code: "28773",
  },
  {
    city_short: "BENGKALIS",
    province: "RIAU",
    postal_code: "28781",
  },
  {
    city_short: "BENGKALIS",
    province: "RIAU",
    postal_code: "28784",
  },
  {
    city_short: "DUMAI",
    province: "RIAU",
    postal_code: "28811",
  },
  {
    city_short: "DUMAI",
    province: "RIAU",
    postal_code: "28812",
  },
  {
    city_short: "DUMAI",
    province: "RIAU",
    postal_code: "28813",
  },
  {
    city_short: "DUMAI",
    province: "RIAU",
    postal_code: "28814",
  },
  {
    city_short: "DUMAI",
    province: "RIAU",
    postal_code: "28815",
  },
  {
    city_short: "DUMAI",
    province: "RIAU",
    postal_code: "28816",
  },
  {
    city_short: "DUMAI",
    province: "RIAU",
    postal_code: "28821",
  },
  {
    city_short: "DUMAI",
    province: "RIAU",
    postal_code: "28822",
  },
  {
    city_short: "DUMAI",
    province: "RIAU",
    postal_code: "28823",
  },
  {
    city_short: "DUMAI",
    province: "RIAU",
    postal_code: "28824",
  },
  {
    city_short: "DUMAI",
    province: "RIAU",
    postal_code: "28825",
  },
  {
    city_short: "DUMAI",
    province: "RIAU",
    postal_code: "28826",
  },
  {
    city_short: "DUMAI",
    province: "RIAU",
    postal_code: "28882",
  },
  {
    city_short: "ROKAN HILIR",
    province: "RIAU",
    postal_code: "28911",
  },
  {
    city_short: "ROKAN HILIR",
    province: "RIAU",
    postal_code: "28912",
  },
  {
    city_short: "ROKAN HILIR",
    province: "RIAU",
    postal_code: "28913",
  },
  {
    city_short: "ROKAN HILIR",
    province: "RIAU",
    postal_code: "28914",
  },
  {
    city_short: "ROKAN HILIR",
    province: "RIAU",
    postal_code: "28953",
  },
  {
    city_short: "ROKAN HILIR",
    province: "RIAU",
    postal_code: "28983",
  },
  {
    city_short: "ROKAN HILIR",
    province: "RIAU",
    postal_code: "28991",
  },
  {
    city_short: "ROKAN HILIR",
    province: "RIAU",
    postal_code: "28992",
  },
  {
    city_short: "TANJUNG PINANG",
    province: "KEPULAUAN RIAU",
    postal_code: "29111",
  },
  {
    city_short: "TANJUNG PINANG",
    province: "KEPULAUAN RIAU",
    postal_code: "29112",
  },
  {
    city_short: "TANJUNG PINANG",
    province: "KEPULAUAN RIAU",
    postal_code: "29113",
  },
  {
    city_short: "TANJUNG PINANG",
    province: "KEPULAUAN RIAU",
    postal_code: "29114",
  },
  {
    city_short: "TANJUNG PINANG",
    province: "KEPULAUAN RIAU",
    postal_code: "29115",
  },
  {
    city_short: "TANJUNG PINANG",
    province: "KEPULAUAN RIAU",
    postal_code: "29122",
  },
  {
    city_short: "TANJUNG PINANG",
    province: "KEPULAUAN RIAU",
    postal_code: "29123",
  },
  {
    city_short: "TANJUNG PINANG",
    province: "KEPULAUAN RIAU",
    postal_code: "29124",
  },
  {
    city_short: "TANJUNG PINANG",
    province: "KEPULAUAN RIAU",
    postal_code: "29125",
  },
  {
    city_short: "BINTAN",
    province: "KEPULAUAN RIAU",
    postal_code: "29132",
  },
  {
    city_short: "BINTAN",
    province: "KEPULAUAN RIAU",
    postal_code: "29133",
  },
  {
    city_short: "BINTAN",
    province: "KEPULAUAN RIAU",
    postal_code: "29134",
  },
  {
    city_short: "BINTAN",
    province: "KEPULAUAN RIAU",
    postal_code: "29135",
  },
  {
    city_short: "BINTAN",
    province: "KEPULAUAN RIAU",
    postal_code: "29136",
  },
  {
    city_short: "BINTAN",
    province: "KEPULAUAN RIAU",
    postal_code: "29151",
  },
  {
    city_short: "BINTAN",
    province: "KEPULAUAN RIAU",
    postal_code: "29152",
  },
  {
    city_short: "BINTAN",
    province: "KEPULAUAN RIAU",
    postal_code: "29193",
  },
  {
    city_short: "INDRAGIRI HILIR",
    province: "RIAU",
    postal_code: "29211",
  },
  {
    city_short: "INDRAGIRI HILIR",
    province: "RIAU",
    postal_code: "29212",
  },
  {
    city_short: "INDRAGIRI HILIR",
    province: "RIAU",
    postal_code: "29213",
  },
  {
    city_short: "INDRAGIRI HILIR",
    province: "RIAU",
    postal_code: "29214",
  },
  {
    city_short: "INDRAGIRI HILIR",
    province: "RIAU",
    postal_code: "29252",
  },
  {
    city_short: "INDRAGIRI HILIR",
    province: "RIAU",
    postal_code: "29253",
  },
  {
    city_short: "INDRAGIRI HILIR",
    province: "RIAU",
    postal_code: "29254",
  },
  {
    city_short: "INDRAGIRI HILIR",
    province: "RIAU",
    postal_code: "29255",
  },
  {
    city_short: "INDRAGIRI HILIR",
    province: "RIAU",
    postal_code: "29256",
  },
  {
    city_short: "INDRAGIRI HILIR",
    province: "RIAU",
    postal_code: "29261",
  },
  {
    city_short: "INDRAGIRI HILIR",
    province: "RIAU",
    postal_code: "29271",
  },
  {
    city_short: "INDRAGIRI HILIR",
    province: "RIAU",
    postal_code: "29272",
  },
  {
    city_short: "INDRAGIRI HILIR",
    province: "RIAU",
    postal_code: "29273",
  },
  {
    city_short: "INDRAGIRI HILIR",
    province: "RIAU",
    postal_code: "29274",
  },
  {
    city_short: "INDRAGIRI HILIR",
    province: "RIAU",
    postal_code: "29281",
  },
  {
    city_short: "INDRAGIRI HILIR",
    province: "RIAU",
    postal_code: "29282",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29311",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29312",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29313",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29314",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29316",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29317",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29318",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29319",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29335",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29344",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29345",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29351",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29352",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29353",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29354",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29355",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29363",
  },
  {
    city_short: "INDRAGIRI HULU",
    province: "RIAU",
    postal_code: "29371",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29412",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29413",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29414",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29416",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29422",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29424",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29425",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29426",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29427",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29428",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29431",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29432",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29433",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29437",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29438",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29439",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29441",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29443",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29444",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29445",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29452",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29453",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29454",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29458",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29461",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29464",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29465",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29466",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29467",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29468",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29471",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29472",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29473",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29474",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29475",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29476",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29481",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29482",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29483",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29484",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29485",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29486",
  },
  {
    city_short: "BATAM",
    province: "KEPULAUAN RIAU",
    postal_code: "29487",
  },
  {
    city_short: "KUANSING",
    province: "RIAU",
    postal_code: "29511",
  },
  {
    city_short: "KUANSING",
    province: "RIAU",
    postal_code: "29512",
  },
  {
    city_short: "KUANSING",
    province: "RIAU",
    postal_code: "29513",
  },
  {
    city_short: "KUANSING",
    province: "RIAU",
    postal_code: "29514",
  },
  {
    city_short: "KUANSING",
    province: "RIAU",
    postal_code: "29515",
  },
  {
    city_short: "KUANSING",
    province: "RIAU",
    postal_code: "29553",
  },
  {
    city_short: "KUANSING",
    province: "RIAU",
    postal_code: "29555",
  },
  {
    city_short: "KUANSING",
    province: "RIAU",
    postal_code: "29556",
  },
  {
    city_short: "KUANSING",
    province: "RIAU",
    postal_code: "29561",
  },
  {
    city_short: "KUANSING",
    province: "RIAU",
    postal_code: "29563",
  },
  {
    city_short: "KUANSING",
    province: "RIAU",
    postal_code: "29564",
  },
  {
    city_short: "KUANSING",
    province: "RIAU",
    postal_code: "29565",
  },
  {
    city_short: "KUANSING",
    province: "RIAU",
    postal_code: "29566",
  },
  {
    city_short: "KARIMUN",
    province: "KEPULAUAN RIAU",
    postal_code: "29661",
  },
  {
    city_short: "KARIMUN",
    province: "KEPULAUAN RIAU",
    postal_code: "29662",
  },
  {
    city_short: "KARIMUN",
    province: "KEPULAUAN RIAU",
    postal_code: "29663",
  },
  {
    city_short: "KARIMUN",
    province: "KEPULAUAN RIAU",
    postal_code: "29664",
  },
  {
    city_short: "NATUNA",
    province: "KEPULAUAN RIAU",
    postal_code: "29781",
  },
  {
    city_short: "NATUNA",
    province: "KEPULAUAN RIAU",
    postal_code: "29782",
  },
  {
    city_short: "NATUNA",
    province: "KEPULAUAN RIAU",
    postal_code: "29783",
  },
  {
    city_short: "KEP ANAMBAS",
    province: "KEPULAUAN RIAU",
    postal_code: "29783",
  },
  {
    city_short: "NATUNA",
    province: "KEPULAUAN RIAU",
    postal_code: "29784",
  },
  {
    city_short: "KEP ANAMBAS",
    province: "KEPULAUAN RIAU",
    postal_code: "29791",
  },
  {
    city_short: "KEP ANAMBAS",
    province: "KEPULAUAN RIAU",
    postal_code: "29792",
  },
  {
    city_short: "LINGGA",
    province: "KEPULAUAN RIAU",
    postal_code: "29871",
  },
  {
    city_short: "LINGGA",
    province: "KEPULAUAN RIAU",
    postal_code: "29872",
  },
  {
    city_short: "LINGGA",
    province: "KEPULAUAN RIAU",
    postal_code: "29873",
  },
  {
    city_short: "LINGGA",
    province: "KEPULAUAN RIAU",
    postal_code: "29874",
  },
  {
    city_short: "LINGGA",
    province: "KEPULAUAN RIAU",
    postal_code: "29875",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30111",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30112",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30113",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30114",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30115",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30116",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30117",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30118",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30119",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30121",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30122",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30123",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30124",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30125",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30126",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30127",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30128",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30129",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30131",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30132",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30133",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30134",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30135",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30136",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30137",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30138",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30139",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30141",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30142",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30143",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30144",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30145",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30146",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30147",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30148",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30149",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30151",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30153",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30154",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30155",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30161",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30162",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30163",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30164",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30165",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30251",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30252",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30253",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30254",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30255",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30257",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30258",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30259",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30261",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30262",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30263",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30264",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30265",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30266",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30267",
  },
  {
    city_short: "PALEMBANG",
    province: "SUMATERA SELATAN",
    postal_code: "30268",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30611",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30612",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30613",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30614",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30615",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30616",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30617",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30618",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30652",
  },
  {
    city_short: "OGAN ILIR",
    province: "SUMATERA SELATAN",
    postal_code: "30653",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30654",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30655",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30656",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30657",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30658",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30659",
  },
  {
    city_short: "OGAN ILIR",
    province: "SUMATERA SELATAN",
    postal_code: "30661",
  },
  {
    city_short: "OGAN ILIR",
    province: "SUMATERA SELATAN",
    postal_code: "30664",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30664",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30671",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30672",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30673",
  },
  {
    city_short: "OKI",
    province: "SUMATERA SELATAN",
    postal_code: "30681",
  },
  {
    city_short: "MUSI BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30711",
  },
  {
    city_short: "MUSI BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30752",
  },
  {
    city_short: "MUSI BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30754",
  },
  {
    city_short: "MUSI BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30755",
  },
  {
    city_short: "MUSI BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30756",
  },
  {
    city_short: "MUSI BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30757",
  },
  {
    city_short: "MUSI BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30758",
  },
  {
    city_short: "MUSI BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30759",
  },
  {
    city_short: "MUSI RAWAS",
    province: "SUMATERA SELATAN",
    postal_code: "30771",
  },
  {
    city_short: "OGAN ILIR",
    province: "SUMATERA SELATAN",
    postal_code: "30812",
  },
  {
    city_short: "OGAN ILIR",
    province: "SUMATERA SELATAN",
    postal_code: "30813",
  },
  {
    city_short: "OGAN ILIR",
    province: "SUMATERA SELATAN",
    postal_code: "30814",
  },
  {
    city_short: "OGAN ILIR",
    province: "SUMATERA SELATAN",
    postal_code: "30815",
  },
  {
    city_short: "OGAN ILIR",
    province: "SUMATERA SELATAN",
    postal_code: "30816",
  },
  {
    city_short: "OGAN ILIR",
    province: "SUMATERA SELATAN",
    postal_code: "30817",
  },
  {
    city_short: "OGAN ILIR",
    province: "SUMATERA SELATAN",
    postal_code: "30862",
  },
  {
    city_short: "OGAN ILIR",
    province: "SUMATERA SELATAN",
    postal_code: "30865",
  },
  {
    city_short: "OGAN ILIR",
    province: "SUMATERA SELATAN",
    postal_code: "30866",
  },
  {
    city_short: "OGAN ILIR",
    province: "SUMATERA SELATAN",
    postal_code: "30867",
  },
  {
    city_short: "OGAN ILIR",
    province: "SUMATERA SELATAN",
    postal_code: "30868",
  },
  {
    city_short: "OGAN ILIR",
    province: "SUMATERA SELATAN",
    postal_code: "30869",
  },
  {
    city_short: "BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30911",
  },
  {
    city_short: "BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30912",
  },
  {
    city_short: "BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30913",
  },
  {
    city_short: "BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30914",
  },
  {
    city_short: "BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30915",
  },
  {
    city_short: "BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30916",
  },
  {
    city_short: "BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30953",
  },
  {
    city_short: "BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30958",
  },
  {
    city_short: "BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30959",
  },
  {
    city_short: "BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30961",
  },
  {
    city_short: "BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30962",
  },
  {
    city_short: "BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30967",
  },
  {
    city_short: "BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30968",
  },
  {
    city_short: "BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30971",
  },
  {
    city_short: "BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30972",
  },
  {
    city_short: "BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30974",
  },
  {
    city_short: "BANYUASIN",
    province: "SUMATERA SELATAN",
    postal_code: "30975",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31111",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31112",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31113",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31115",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31116",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31117",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31121",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31122",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31123",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31124",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31125",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31126",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31127",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31131",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31132",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31133",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31134",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31135",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31141",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31142",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31143",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31144",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31145",
  },
  {
    city_short: "PRABUMULIH",
    province: "SUMATERA SELATAN",
    postal_code: "31146",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31171",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31172",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31173",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31211",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31212",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31213",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31214",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31311",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31312",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31313",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31314",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31315",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31351",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31352",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31355",
  },
  {
    city_short: "LAHAT",
    province: "SUMATERA SELATAN",
    postal_code: "31356",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31356",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31357",
  },
  {
    city_short: "LAHAT",
    province: "SUMATERA SELATAN",
    postal_code: "31411",
  },
  {
    city_short: "LAHAT",
    province: "SUMATERA SELATAN",
    postal_code: "31412",
  },
  {
    city_short: "LAHAT",
    province: "SUMATERA SELATAN",
    postal_code: "31413",
  },
  {
    city_short: "LAHAT",
    province: "SUMATERA SELATAN",
    postal_code: "31414",
  },
  {
    city_short: "LAHAT",
    province: "SUMATERA SELATAN",
    postal_code: "31415",
  },
  {
    city_short: "LAHAT",
    province: "SUMATERA SELATAN",
    postal_code: "31416",
  },
  {
    city_short: "LAHAT",
    province: "SUMATERA SELATAN",
    postal_code: "31417",
  },
  {
    city_short: "LAHAT",
    province: "SUMATERA SELATAN",
    postal_code: "31418",
  },
  {
    city_short: "LAHAT",
    province: "SUMATERA SELATAN",
    postal_code: "31419",
  },
  {
    city_short: "LAHAT",
    province: "SUMATERA SELATAN",
    postal_code: "31452",
  },
  {
    city_short: "EMPAT LAWANG",
    province: "SUMATERA SELATAN",
    postal_code: "31453",
  },
  {
    city_short: "LAHAT",
    province: "SUMATERA SELATAN",
    postal_code: "31453",
  },
  {
    city_short: "LAHAT",
    province: "SUMATERA SELATAN",
    postal_code: "31461",
  },
  {
    city_short: "LAHAT",
    province: "SUMATERA SELATAN",
    postal_code: "31462",
  },
  {
    city_short: "LAHAT",
    province: "SUMATERA SELATAN",
    postal_code: "31471",
  },
  {
    city_short: "PAGAR ALAM",
    province: "SUMATERA SELATAN",
    postal_code: "31511",
  },
  {
    city_short: "PAGAR ALAM",
    province: "SUMATERA SELATAN",
    postal_code: "31512",
  },
  {
    city_short: "PAGAR ALAM",
    province: "SUMATERA SELATAN",
    postal_code: "31513",
  },
  {
    city_short: "PAGAR ALAM",
    province: "SUMATERA SELATAN",
    postal_code: "31514",
  },
  {
    city_short: "PAGAR ALAM",
    province: "SUMATERA SELATAN",
    postal_code: "31515",
  },
  {
    city_short: "PAGAR ALAM",
    province: "SUMATERA SELATAN",
    postal_code: "31516",
  },
  {
    city_short: "PAGAR ALAM",
    province: "SUMATERA SELATAN",
    postal_code: "31517",
  },
  {
    city_short: "PAGAR ALAM",
    province: "SUMATERA SELATAN",
    postal_code: "31519",
  },
  {
    city_short: "PAGAR ALAM",
    province: "SUMATERA SELATAN",
    postal_code: "31521",
  },
  {
    city_short: "PAGAR ALAM",
    province: "SUMATERA SELATAN",
    postal_code: "31522",
  },
  {
    city_short: "PAGAR ALAM",
    province: "SUMATERA SELATAN",
    postal_code: "31526",
  },
  {
    city_short: "PAGAR ALAM",
    province: "SUMATERA SELATAN",
    postal_code: "31527",
  },
  {
    city_short: "PAGAR ALAM",
    province: "SUMATERA SELATAN",
    postal_code: "31529",
  },
  {
    city_short: "PAGAR ALAM",
    province: "SUMATERA SELATAN",
    postal_code: "31551",
  },
  {
    city_short: "LAHAT",
    province: "SUMATERA SELATAN",
    postal_code: "31581",
  },
  {
    city_short: "LAHAT",
    province: "SUMATERA SELATAN",
    postal_code: "31591",
  },
  {
    city_short: "EMPAT LAWANG",
    province: "SUMATERA SELATAN",
    postal_code: "31592",
  },
  {
    city_short: "EMPAT LAWANG",
    province: "SUMATERA SELATAN",
    postal_code: "31593",
  },
  {
    city_short: "EMPAT LAWANG",
    province: "SUMATERA SELATAN",
    postal_code: "31594",
  },
  {
    city_short: "EMPAT LAWANG",
    province: "SUMATERA SELATAN",
    postal_code: "31595",
  },
  {
    city_short: "EMPAT LAWANG",
    province: "SUMATERA SELATAN",
    postal_code: "31596",
  },
  {
    city_short: "LUBUK LINGGAU",
    province: "SUMATERA SELATAN",
    postal_code: "31611",
  },
  {
    city_short: "LUBUK LINGGAU",
    province: "SUMATERA SELATAN",
    postal_code: "31613",
  },
  {
    city_short: "LUBUK LINGGAU",
    province: "SUMATERA SELATAN",
    postal_code: "31614",
  },
  {
    city_short: "LUBUK LINGGAU",
    province: "SUMATERA SELATAN",
    postal_code: "31615",
  },
  {
    city_short: "LUBUK LINGGAU",
    province: "SUMATERA SELATAN",
    postal_code: "31616",
  },
  {
    city_short: "LUBUK LINGGAU",
    province: "SUMATERA SELATAN",
    postal_code: "31617",
  },
  {
    city_short: "LUBUK LINGGAU",
    province: "SUMATERA SELATAN",
    postal_code: "31618",
  },
  {
    city_short: "LUBUK LINGGAU",
    province: "SUMATERA SELATAN",
    postal_code: "31619",
  },
  {
    city_short: "LUBUK LINGGAU",
    province: "SUMATERA SELATAN",
    postal_code: "31621",
  },
  {
    city_short: "LUBUK LINGGAU",
    province: "SUMATERA SELATAN",
    postal_code: "31622",
  },
  {
    city_short: "LUBUK LINGGAU",
    province: "SUMATERA SELATAN",
    postal_code: "31624",
  },
  {
    city_short: "LUBUK LINGGAU",
    province: "SUMATERA SELATAN",
    postal_code: "31625",
  },
  {
    city_short: "MUSI RAWAS",
    province: "SUMATERA SELATAN",
    postal_code: "31625",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31626",
  },
  {
    city_short: "LUBUK LINGGAU",
    province: "SUMATERA SELATAN",
    postal_code: "31626",
  },
  {
    city_short: "LUBUK LINGGAU",
    province: "SUMATERA SELATAN",
    postal_code: "31627",
  },
  {
    city_short: "LUBUK LINGGAU",
    province: "SUMATERA SELATAN",
    postal_code: "31628",
  },
  {
    city_short: "MUSI RAWAS",
    province: "SUMATERA SELATAN",
    postal_code: "31652",
  },
  {
    city_short: "MUSI RAWAS",
    province: "SUMATERA SELATAN",
    postal_code: "31654",
  },
  {
    city_short: "MUSI RAWAS",
    province: "SUMATERA SELATAN",
    postal_code: "31655",
  },
  {
    city_short: "MUSI RAWAS",
    province: "SUMATERA SELATAN",
    postal_code: "31656",
  },
  {
    city_short: "MUSI RAWAS",
    province: "SUMATERA SELATAN",
    postal_code: "31657",
  },
  {
    city_short: "MUSI RAWAS",
    province: "SUMATERA SELATAN",
    postal_code: "31658",
  },
  {
    city_short: "MUSI RAWAS",
    province: "SUMATERA SELATAN",
    postal_code: "31661",
  },
  {
    city_short: "MUSI RAWAS",
    province: "SUMATERA SELATAN",
    postal_code: "31662",
  },
  {
    city_short: "MUSI RAWAS",
    province: "SUMATERA SELATAN",
    postal_code: "31663",
  },
  {
    city_short: "MUSI RAWAS",
    province: "SUMATERA SELATAN",
    postal_code: "31665",
  },
  {
    city_short: "MUSI RAWAS",
    province: "SUMATERA SELATAN",
    postal_code: "31666",
  },
  {
    city_short: "MUSI RAWAS",
    province: "SUMATERA SELATAN",
    postal_code: "31667",
  },
  {
    city_short: "MUSI RAWAS",
    province: "SUMATERA SELATAN",
    postal_code: "31668",
  },
  {
    city_short: "MUSI RAWAS",
    province: "SUMATERA SELATAN",
    postal_code: "31669",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31711",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31712",
  },
  {
    city_short: "MUARA ENIM",
    province: "SUMATERA SELATAN",
    postal_code: "31713",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32111",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32112",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32113",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32114",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32115",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32116",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32117",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32121",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32122",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32123",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32124",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32125",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32126",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32151",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32152",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32155",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32156",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32157",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32158",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32159",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32184",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32185",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32191",
  },
  {
    city_short: "OKU",
    province: "SUMATERA SELATAN",
    postal_code: "32192",
  },
  {
    city_short: "OKU SELATAN",
    province: "SUMATERA SELATAN",
    postal_code: "32211",
  },
  {
    city_short: "OKU SELATAN",
    province: "SUMATERA SELATAN",
    postal_code: "32264",
  },
  {
    city_short: "OKU SELATAN",
    province: "SUMATERA SELATAN",
    postal_code: "32265",
  },
  {
    city_short: "OKU SELATAN",
    province: "SUMATERA SELATAN",
    postal_code: "32272",
  },
  {
    city_short: "OKU SELATAN",
    province: "SUMATERA SELATAN",
    postal_code: "32273",
  },
  {
    city_short: "OKU SELATAN",
    province: "SUMATERA SELATAN",
    postal_code: "32274",
  },
  {
    city_short: "OKU SELATAN",
    province: "SUMATERA SELATAN",
    postal_code: "32276",
  },
  {
    city_short: "OKU SELATAN",
    province: "SUMATERA SELATAN",
    postal_code: "32277",
  },
  {
    city_short: "OKU SELATAN",
    province: "SUMATERA SELATAN",
    postal_code: "32278",
  },
  {
    city_short: "OKU SELATAN",
    province: "SUMATERA SELATAN",
    postal_code: "32279",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32311",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32312",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32313",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32314",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32315",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32361",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32362",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32366",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32367",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32381",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32382",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32383",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32384",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32385",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32386",
  },
  {
    city_short: "OKU TIMUR",
    province: "SUMATERA SELATAN",
    postal_code: "32387",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33111",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33113",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33115",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33116",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33117",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33118",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33119",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33121",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33123",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33124",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33125",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33127",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33132",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33133",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33134",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33135",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33136",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33137",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33138",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33139",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33141",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33142",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33143",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33145",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33146",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33147",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33148",
  },
  {
    city_short: "PANGKAL PINANG",
    province: "BANGKA BELITUNG",
    postal_code: "33149",
  },
  {
    city_short: "BANGKA",
    province: "BANGKA BELITUNG",
    postal_code: "33172",
  },
  {
    city_short: "BANGKA",
    province: "BANGKA BELITUNG",
    postal_code: "33173",
  },
  {
    city_short: "BANGKA",
    province: "BANGKA BELITUNG",
    postal_code: "33179",
  },
  {
    city_short: "BANGKA",
    province: "BANGKA BELITUNG",
    postal_code: "33211",
  },
  {
    city_short: "BANGKA",
    province: "BANGKA BELITUNG",
    postal_code: "33212",
  },
  {
    city_short: "BANGKA",
    province: "BANGKA BELITUNG",
    postal_code: "33213",
  },
  {
    city_short: "BANGKA",
    province: "BANGKA BELITUNG",
    postal_code: "33214",
  },
  {
    city_short: "BANGKA",
    province: "BANGKA BELITUNG",
    postal_code: "33215",
  },
  {
    city_short: "BANGKA",
    province: "BANGKA BELITUNG",
    postal_code: "33251",
  },
  {
    city_short: "BANGKA",
    province: "BANGKA BELITUNG",
    postal_code: "33252",
  },
  {
    city_short: "BANGKA",
    province: "BANGKA BELITUNG",
    postal_code: "33253",
  },
  {
    city_short: "BANGKA",
    province: "BANGKA BELITUNG",
    postal_code: "33255",
  },
  {
    city_short: "BANGKA BARAT",
    province: "BANGKA BELITUNG",
    postal_code: "33311",
  },
  {
    city_short: "BANGKA BARAT",
    province: "BANGKA BELITUNG",
    postal_code: "33312",
  },
  {
    city_short: "BANGKA BARAT",
    province: "BANGKA BELITUNG",
    postal_code: "33313",
  },
  {
    city_short: "BANGKA BARAT",
    province: "BANGKA BELITUNG",
    postal_code: "33351",
  },
  {
    city_short: "BANGKA BARAT",
    province: "BANGKA BELITUNG",
    postal_code: "33362",
  },
  {
    city_short: "BANGKA BARAT",
    province: "BANGKA BELITUNG",
    postal_code: "33364",
  },
  {
    city_short: "BANGKA BARAT",
    province: "BANGKA BELITUNG",
    postal_code: "33365",
  },
  {
    city_short: "BANGKA BARAT",
    province: "BANGKA BELITUNG",
    postal_code: "33366",
  },
  {
    city_short: "BELITUNG",
    province: "BANGKA BELITUNG",
    postal_code: "33411",
  },
  {
    city_short: "BELITUNG",
    province: "BANGKA BELITUNG",
    postal_code: "33412",
  },
  {
    city_short: "BELITUNG",
    province: "BANGKA BELITUNG",
    postal_code: "33413",
  },
  {
    city_short: "BELITUNG",
    province: "BANGKA BELITUNG",
    postal_code: "33414",
  },
  {
    city_short: "BELITUNG",
    province: "BANGKA BELITUNG",
    postal_code: "33415",
  },
  {
    city_short: "BELITUNG",
    province: "BANGKA BELITUNG",
    postal_code: "33417",
  },
  {
    city_short: "BELITUNG",
    province: "BANGKA BELITUNG",
    postal_code: "33451",
  },
  {
    city_short: "BELITUNG",
    province: "BANGKA BELITUNG",
    postal_code: "33452",
  },
  {
    city_short: "BELITUNG",
    province: "BANGKA BELITUNG",
    postal_code: "33481",
  },
  {
    city_short: "BELITUNG TIMUR",
    province: "BANGKA BELITUNG",
    postal_code: "33511",
  },
  {
    city_short: "BELITUNG TIMUR",
    province: "BANGKA BELITUNG",
    postal_code: "33512",
  },
  {
    city_short: "BELITUNG TIMUR",
    province: "BANGKA BELITUNG",
    postal_code: "33513",
  },
  {
    city_short: "BELITUNG TIMUR",
    province: "BANGKA BELITUNG",
    postal_code: "33514",
  },
  {
    city_short: "BELITUNG TIMUR",
    province: "BANGKA BELITUNG",
    postal_code: "33515",
  },
  {
    city_short: "BELITUNG TIMUR",
    province: "BANGKA BELITUNG",
    postal_code: "33516",
  },
  {
    city_short: "BELITUNG TIMUR",
    province: "BANGKA BELITUNG",
    postal_code: "33517",
  },
  {
    city_short: "BELITUNG TIMUR",
    province: "BANGKA BELITUNG",
    postal_code: "33561",
  },
  {
    city_short: "BELITUNG TIMUR",
    province: "BANGKA BELITUNG",
    postal_code: "33562",
  },
  {
    city_short: "BELITUNG TIMUR",
    province: "BANGKA BELITUNG",
    postal_code: "33571",
  },
  {
    city_short: "BANGKA TENGAH",
    province: "BANGKA BELITUNG",
    postal_code: "33674",
  },
  {
    city_short: "BANGKA TENGAH",
    province: "BANGKA BELITUNG",
    postal_code: "33675",
  },
  {
    city_short: "BANGKA TENGAH",
    province: "BANGKA BELITUNG",
    postal_code: "33681",
  },
  {
    city_short: "BANGKA TENGAH",
    province: "BANGKA BELITUNG",
    postal_code: "33684",
  },
  {
    city_short: "BANGKA SELATAN",
    province: "BANGKA BELITUNG",
    postal_code: "33777",
  },
  {
    city_short: "BANGKA SELATAN",
    province: "BANGKA BELITUNG",
    postal_code: "33778",
  },
  {
    city_short: "BANGKA SELATAN",
    province: "BANGKA BELITUNG",
    postal_code: "33782",
  },
  {
    city_short: "BANGKA SELATAN",
    province: "BANGKA BELITUNG",
    postal_code: "33783",
  },
  {
    city_short: "BANGKA SELATAN",
    province: "BANGKA BELITUNG",
    postal_code: "33791",
  },
  {
    city_short: "METRO",
    province: "LAMPUNG",
    postal_code: "34111",
  },
  {
    city_short: "METRO",
    province: "LAMPUNG",
    postal_code: "34112",
  },
  {
    city_short: "METRO",
    province: "LAMPUNG",
    postal_code: "34113",
  },
  {
    city_short: "METRO",
    province: "LAMPUNG",
    postal_code: "34114",
  },
  {
    city_short: "METRO",
    province: "LAMPUNG",
    postal_code: "34117",
  },
  {
    city_short: "METRO",
    province: "LAMPUNG",
    postal_code: "34118",
  },
  {
    city_short: "METRO",
    province: "LAMPUNG",
    postal_code: "34119",
  },
  {
    city_short: "METRO",
    province: "LAMPUNG",
    postal_code: "34121",
  },
  {
    city_short: "METRO",
    province: "LAMPUNG",
    postal_code: "34122",
  },
  {
    city_short: "METRO",
    province: "LAMPUNG",
    postal_code: "34123",
  },
  {
    city_short: "METRO",
    province: "LAMPUNG",
    postal_code: "34124",
  },
  {
    city_short: "METRO",
    province: "LAMPUNG",
    postal_code: "34125",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34152",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34153",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34155",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34156",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34157",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34158",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34159",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34161",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34162",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34163",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34164",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34166",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34167",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34168",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34169",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34171",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34172",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34173",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34174",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34175",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34176",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "34179",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34182",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34192",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34194",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34196",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34198",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34199",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34331",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34332",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34333",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34335",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34371",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34372",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34373",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34375",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34376",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34377",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34381",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34382",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34384",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34385",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34386",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34387",
  },
  {
    city_short: "TULANGBAWANG BA",
    province: "LAMPUNG",
    postal_code: "34388",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34388",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34389",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34391",
  },
  {
    city_short: "LAMPUNG TIMUR",
    province: "LAMPUNG",
    postal_code: "34396",
  },
  {
    city_short: "LAMPUNG UTARA",
    province: "LAMPUNG",
    postal_code: "34511",
  },
  {
    city_short: "LAMPUNG UTARA",
    province: "LAMPUNG",
    postal_code: "34513",
  },
  {
    city_short: "LAMPUNG UTARA",
    province: "LAMPUNG",
    postal_code: "34514",
  },
  {
    city_short: "LAMPUNG UTARA",
    province: "LAMPUNG",
    postal_code: "34515",
  },
  {
    city_short: "LAMPUNG UTARA",
    province: "LAMPUNG",
    postal_code: "34516",
  },
  {
    city_short: "LAMPUNG UTARA",
    province: "LAMPUNG",
    postal_code: "34517",
  },
  {
    city_short: "LAMPUNG UTARA",
    province: "LAMPUNG",
    postal_code: "34518",
  },
  {
    city_short: "LAMPUNG UTARA",
    province: "LAMPUNG",
    postal_code: "34519",
  },
  {
    city_short: "LAMPUNG UTARA",
    province: "LAMPUNG",
    postal_code: "34554",
  },
  {
    city_short: "LAMPUNG UTARA",
    province: "LAMPUNG",
    postal_code: "34555",
  },
  {
    city_short: "LAMPUNG UTARA",
    province: "LAMPUNG",
    postal_code: "34556",
  },
  {
    city_short: "LAMPUNG UTARA",
    province: "LAMPUNG",
    postal_code: "34557",
  },
  {
    city_short: "LAMPUNG UTARA",
    province: "LAMPUNG",
    postal_code: "34558",
  },
  {
    city_short: "LAMPUNG UTARA",
    province: "LAMPUNG",
    postal_code: "34559",
  },
  {
    city_short: "LAMPUNG UTARA",
    province: "LAMPUNG",
    postal_code: "34581",
  },
  {
    city_short: "LAMPUNG UTARA",
    province: "LAMPUNG",
    postal_code: "34582",
  },
  {
    city_short: "LAMPUNG UTARA",
    province: "LAMPUNG",
    postal_code: "34583",
  },
  {
    city_short: "TULANGBAWANG BA",
    province: "LAMPUNG",
    postal_code: "34594",
  },
  {
    city_short: "TULANG BAWANG",
    province: "LAMPUNG",
    postal_code: "34595",
  },
  {
    city_short: "TULANG BAWANG",
    province: "LAMPUNG",
    postal_code: "34596",
  },
  {
    city_short: "MESUJI",
    province: "LAMPUNG",
    postal_code: "34598",
  },
  {
    city_short: "TULANG BAWANG",
    province: "LAMPUNG",
    postal_code: "34611",
  },
  {
    city_short: "TULANG BAWANG",
    province: "LAMPUNG",
    postal_code: "34613",
  },
  {
    city_short: "TULANG BAWANG",
    province: "LAMPUNG",
    postal_code: "34614",
  },
  {
    city_short: "TULANG BAWANG",
    province: "LAMPUNG",
    postal_code: "34615",
  },
  {
    city_short: "TULANG BAWANG",
    province: "LAMPUNG",
    postal_code: "34616",
  },
  {
    city_short: "TULANG BAWANG",
    province: "LAMPUNG",
    postal_code: "34617",
  },
  {
    city_short: "TULANG BAWANG",
    province: "LAMPUNG",
    postal_code: "34618",
  },
  {
    city_short: "TULANG BAWANG",
    province: "LAMPUNG",
    postal_code: "34619",
  },
  {
    city_short: "TULANG BAWANG",
    province: "LAMPUNG",
    postal_code: "34681",
  },
  {
    city_short: "TULANG BAWANG",
    province: "LAMPUNG",
    postal_code: "34682",
  },
  {
    city_short: "TULANGBAWANG BA",
    province: "LAMPUNG",
    postal_code: "34683",
  },
  {
    city_short: "MESUJI",
    province: "LAMPUNG",
    postal_code: "34684",
  },
  {
    city_short: "TULANGBAWANG BA",
    province: "LAMPUNG",
    postal_code: "34691",
  },
  {
    city_short: "TULANGBAWANG BA",
    province: "LAMPUNG",
    postal_code: "34693",
  },
  {
    city_short: "MESUJI",
    province: "LAMPUNG",
    postal_code: "34696",
  },
  {
    city_short: "MESUJI",
    province: "LAMPUNG",
    postal_code: "34697",
  },
  {
    city_short: "MESUJI",
    province: "LAMPUNG",
    postal_code: "34698",
  },
  {
    city_short: "WAY KANAN",
    province: "LAMPUNG",
    postal_code: "34761",
  },
  {
    city_short: "WAY KANAN",
    province: "LAMPUNG",
    postal_code: "34762",
  },
  {
    city_short: "WAY KANAN",
    province: "LAMPUNG",
    postal_code: "34763",
  },
  {
    city_short: "WAY KANAN",
    province: "LAMPUNG",
    postal_code: "34764",
  },
  {
    city_short: "WAY KANAN",
    province: "LAMPUNG",
    postal_code: "34765",
  },
  {
    city_short: "WAY KANAN",
    province: "LAMPUNG",
    postal_code: "34766",
  },
  {
    city_short: "WAY KANAN",
    province: "LAMPUNG",
    postal_code: "34767",
  },
  {
    city_short: "WAY KANAN",
    province: "LAMPUNG",
    postal_code: "34768",
  },
  {
    city_short: "WAY KANAN",
    province: "LAMPUNG",
    postal_code: "34769",
  },
  {
    city_short: "LAMPUNG BARAT",
    province: "LAMPUNG",
    postal_code: "34811",
  },
  {
    city_short: "LAMPUNG BARAT",
    province: "LAMPUNG",
    postal_code: "34812",
  },
  {
    city_short: "LAMPUNG BARAT",
    province: "LAMPUNG",
    postal_code: "34813",
  },
  {
    city_short: "LAMPUNG BARAT",
    province: "LAMPUNG",
    postal_code: "34814",
  },
  {
    city_short: "LAMPUNG BARAT",
    province: "LAMPUNG",
    postal_code: "34815",
  },
  {
    city_short: "LAMPUNG BARAT",
    province: "LAMPUNG",
    postal_code: "34816",
  },
  {
    city_short: "LAMPUNG BARAT",
    province: "LAMPUNG",
    postal_code: "34817",
  },
  {
    city_short: "LAMPUNG BARAT",
    province: "LAMPUNG",
    postal_code: "34818",
  },
  {
    city_short: "PESISIR BARAT",
    province: "LAMPUNG",
    postal_code: "34871",
  },
  {
    city_short: "LAMPUNG BARAT",
    province: "LAMPUNG",
    postal_code: "34871",
  },
  {
    city_short: "LAMPUNG BARAT",
    province: "LAMPUNG",
    postal_code: "34872",
  },
  {
    city_short: "PESISIR BARAT",
    province: "LAMPUNG",
    postal_code: "34874",
  },
  {
    city_short: "PESISIR BARAT",
    province: "LAMPUNG",
    postal_code: "34875",
  },
  {
    city_short: "PESISIR BARAT",
    province: "LAMPUNG",
    postal_code: "34876",
  },
  {
    city_short: "LAMPUNG BARAT",
    province: "LAMPUNG",
    postal_code: "34876",
  },
  {
    city_short: "PESISIR BARAT",
    province: "LAMPUNG",
    postal_code: "34877",
  },
  {
    city_short: "PESISIR BARAT",
    province: "LAMPUNG",
    postal_code: "34878",
  },
  {
    city_short: "LAMPUNG BARAT",
    province: "LAMPUNG",
    postal_code: "34879",
  },
  {
    city_short: "LAMPUNG BARAT",
    province: "LAMPUNG",
    postal_code: "34881",
  },
  {
    city_short: "LAMPUNG BARAT",
    province: "LAMPUNG",
    postal_code: "34882",
  },
  {
    city_short: "PESISIR BARAT",
    province: "LAMPUNG",
    postal_code: "34883",
  },
  {
    city_short: "LAMPUNG BARAT",
    province: "LAMPUNG",
    postal_code: "34884",
  },
  {
    city_short: "LAMPUNG BARAT",
    province: "LAMPUNG",
    postal_code: "34885",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35111",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35112",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35113",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35115",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35116",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35117",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35118",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35119",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35121",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35122",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35123",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35124",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35125",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35126",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35127",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35128",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35129",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35131",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35132",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35133",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35134",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35135",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35136",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35141",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35142",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35143",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35144",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35145",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35146",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35147",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35148",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35149",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35151",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35152",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35153",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35154",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35155",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35156",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35157",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35158",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35159",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35211",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35212",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35213",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "35213",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35214",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35215",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35221",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35222",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35223",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35224",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35225",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35226",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35227",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35228",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35229",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35231",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35232",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35233",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35234",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35235",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35236",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35237",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35238",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35239",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35241",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35242",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35243",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35244",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35245",
  },
  {
    city_short: "BANDAR LAMPUNG",
    province: "LAMPUNG",
    postal_code: "35246",
  },
  {
    city_short: "LAMPUNG SELATAN",
    province: "LAMPUNG",
    postal_code: "35353",
  },
  {
    city_short: "PESAWARAN",
    province: "LAMPUNG",
    postal_code: "35353",
  },
  {
    city_short: "LAMPUNG SELATAN",
    province: "LAMPUNG",
    postal_code: "35356",
  },
  {
    city_short: "LAMPUNG SELATAN",
    province: "LAMPUNG",
    postal_code: "35357",
  },
  {
    city_short: "LAMPUNG SELATAN",
    province: "LAMPUNG",
    postal_code: "35361",
  },
  {
    city_short: "LAMPUNG SELATAN",
    province: "LAMPUNG",
    postal_code: "35362",
  },
  {
    city_short: "PESAWARAN",
    province: "LAMPUNG",
    postal_code: "35363",
  },
  {
    city_short: "LAMPUNG SELATAN",
    province: "LAMPUNG",
    postal_code: "35365",
  },
  {
    city_short: "PESAWARAN",
    province: "LAMPUNG",
    postal_code: "35366",
  },
  {
    city_short: "PESAWARAN",
    province: "LAMPUNG",
    postal_code: "35367",
  },
  {
    city_short: "PESAWARAN",
    province: "LAMPUNG",
    postal_code: "35368",
  },
  {
    city_short: "PRINGSEWU",
    province: "LAMPUNG",
    postal_code: "35372",
  },
  {
    city_short: "PRINGSEWU",
    province: "LAMPUNG",
    postal_code: "35373",
  },
  {
    city_short: "TANGGAMUS",
    province: "LAMPUNG",
    postal_code: "35374",
  },
  {
    city_short: "PRINGSEWU",
    province: "LAMPUNG",
    postal_code: "35375",
  },
  {
    city_short: "PRINGSEWU",
    province: "LAMPUNG",
    postal_code: "35376",
  },
  {
    city_short: "TANGGAMUS",
    province: "LAMPUNG",
    postal_code: "35377",
  },
  {
    city_short: "TANGGAMUS",
    province: "LAMPUNG",
    postal_code: "35378",
  },
  {
    city_short: "TANGGAMUS",
    province: "LAMPUNG",
    postal_code: "35379",
  },
  {
    city_short: "TANGGAMUS",
    province: "LAMPUNG",
    postal_code: "35382",
  },
  {
    city_short: "TANGGAMUS",
    province: "LAMPUNG",
    postal_code: "35384",
  },
  {
    city_short: "TANGGAMUS",
    province: "LAMPUNG",
    postal_code: "35386",
  },
  {
    city_short: "TANGGAMUS",
    province: "LAMPUNG",
    postal_code: "35387",
  },
  {
    city_short: "PESAWARAN",
    province: "LAMPUNG",
    postal_code: "35451",
  },
  {
    city_short: "LAMPUNG SELATAN",
    province: "LAMPUNG",
    postal_code: "35452",
  },
  {
    city_short: "PESAWARAN",
    province: "LAMPUNG",
    postal_code: "35453",
  },
  {
    city_short: "LAMPUNG TENGAH",
    province: "LAMPUNG",
    postal_code: "35513",
  },
  {
    city_short: "LAMPUNG SELATAN",
    province: "LAMPUNG",
    postal_code: "35551",
  },
  {
    city_short: "LAMPUNG SELATAN",
    province: "LAMPUNG",
    postal_code: "35552",
  },
  {
    city_short: "LAMPUNG SELATAN",
    province: "LAMPUNG",
    postal_code: "35592",
  },
  {
    city_short: "LAMPUNG SELATAN",
    province: "LAMPUNG",
    postal_code: "35594",
  },
  {
    city_short: "LAMPUNG SELATAN",
    province: "LAMPUNG",
    postal_code: "35596",
  },
  {
    city_short: "LAMPUNG SELATAN",
    province: "LAMPUNG",
    postal_code: "35597",
  },
  {
    city_short: "TANGGAMUS",
    province: "LAMPUNG",
    postal_code: "35611",
  },
  {
    city_short: "TANGGAMUS",
    province: "LAMPUNG",
    postal_code: "35613",
  },
  {
    city_short: "PRINGSEWU",
    province: "LAMPUNG",
    postal_code: "35674",
  },
  {
    city_short: "TANGGAMUS",
    province: "LAMPUNG",
    postal_code: "35675",
  },
  {
    city_short: "TANGGAMUS",
    province: "LAMPUNG",
    postal_code: "35679",
  },
  {
    city_short: "PRINGSEWU",
    province: "LAMPUNG",
    postal_code: "35682",
  },
  {
    city_short: "TANGGAMUS",
    province: "LAMPUNG",
    postal_code: "35682",
  },
  {
    city_short: "TANGGAMUS",
    province: "LAMPUNG",
    postal_code: "35683",
  },
  {
    city_short: "TANGGAMUS",
    province: "LAMPUNG",
    postal_code: "35684",
  },
  {
    city_short: "TANGGAMUS",
    province: "LAMPUNG",
    postal_code: "35686",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36111",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36112",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36121",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36122",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36123",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36124",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36125",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36126",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36127",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36128",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36129",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36131",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36132",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36133",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36134",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36135",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36136",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36137",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36138",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36139",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36141",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36142",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36143",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36144",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36145",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36146",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36147",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36148",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36149",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36251",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36252",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36253",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36254",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36255",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36256",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36261",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36262",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36263",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36264",
  },
  {
    city_short: "JAMBI",
    province: "JAMBI",
    postal_code: "36265",
  },
  {
    city_short: "MUARO JAMBI",
    province: "JAMBI",
    postal_code: "36361",
  },
  {
    city_short: "MUARO JAMBI",
    province: "JAMBI",
    postal_code: "36364",
  },
  {
    city_short: "MUARO JAMBI",
    province: "JAMBI",
    postal_code: "36365",
  },
  {
    city_short: "MUARO JAMBI",
    province: "JAMBI",
    postal_code: "36371",
  },
  {
    city_short: "MUARO JAMBI",
    province: "JAMBI",
    postal_code: "36373",
  },
  {
    city_short: "MUARO JAMBI",
    province: "JAMBI",
    postal_code: "36381",
  },
  {
    city_short: "MUARO JAMBI",
    province: "JAMBI",
    postal_code: "36382",
  },
  {
    city_short: "TANJAB BARAT",
    province: "JAMBI",
    postal_code: "36511",
  },
  {
    city_short: "TANJAB BARAT",
    province: "JAMBI",
    postal_code: "36514",
  },
  {
    city_short: "TANJAB BARAT",
    province: "JAMBI",
    postal_code: "36552",
  },
  {
    city_short: "TANJAB BARAT",
    province: "JAMBI",
    postal_code: "36553",
  },
  {
    city_short: "TANJAB BARAT",
    province: "JAMBI",
    postal_code: "36554",
  },
  {
    city_short: "TANJAB BARAT",
    province: "JAMBI",
    postal_code: "36555",
  },
  {
    city_short: "TANJAB TIMUR",
    province: "JAMBI",
    postal_code: "36572",
  },
  {
    city_short: "BATANG HARI",
    province: "JAMBI",
    postal_code: "36611",
  },
  {
    city_short: "BATANG HARI",
    province: "JAMBI",
    postal_code: "36612",
  },
  {
    city_short: "BATANG HARI",
    province: "JAMBI",
    postal_code: "36613",
  },
  {
    city_short: "BATANG HARI",
    province: "JAMBI",
    postal_code: "36614",
  },
  {
    city_short: "BATANG HARI",
    province: "JAMBI",
    postal_code: "36653",
  },
  {
    city_short: "BATANG HARI",
    province: "JAMBI",
    postal_code: "36654",
  },
  {
    city_short: "BATANG HARI",
    province: "JAMBI",
    postal_code: "36655",
  },
  {
    city_short: "BATANG HARI",
    province: "JAMBI",
    postal_code: "36656",
  },
  {
    city_short: "BATANG HARI",
    province: "JAMBI",
    postal_code: "36657",
  },
  {
    city_short: "TANJAB TIMUR",
    province: "JAMBI",
    postal_code: "36761",
  },
  {
    city_short: "TANJAB TIMUR",
    province: "JAMBI",
    postal_code: "36763",
  },
  {
    city_short: "TANJAB TIMUR",
    province: "JAMBI",
    postal_code: "36764",
  },
  {
    city_short: "TANJAB TIMUR",
    province: "JAMBI",
    postal_code: "36771",
  },
  {
    city_short: "TANJAB TIMUR",
    province: "JAMBI",
    postal_code: "36772",
  },
  {
    city_short: "TANJAB TIMUR",
    province: "JAMBI",
    postal_code: "36773",
  },
  {
    city_short: "SUNGAIPENUH",
    province: "JAMBI",
    postal_code: "37111",
  },
  {
    city_short: "SUNGAIPENUH",
    province: "JAMBI",
    postal_code: "37112",
  },
  {
    city_short: "SUNGAIPENUH",
    province: "JAMBI",
    postal_code: "37113",
  },
  {
    city_short: "SUNGAIPENUH",
    province: "JAMBI",
    postal_code: "37114",
  },
  {
    city_short: "KERINCI",
    province: "JAMBI",
    postal_code: "37152",
  },
  {
    city_short: "SUNGAIPENUH",
    province: "JAMBI",
    postal_code: "37152",
  },
  {
    city_short: "KERINCI",
    province: "JAMBI",
    postal_code: "37161",
  },
  {
    city_short: "KERINCI",
    province: "JAMBI",
    postal_code: "37162",
  },
  {
    city_short: "KERINCI",
    province: "JAMBI",
    postal_code: "37163",
  },
  {
    city_short: "KERINCI",
    province: "JAMBI",
    postal_code: "37171",
  },
  {
    city_short: "SUNGAIPENUH",
    province: "JAMBI",
    postal_code: "37171",
  },
  {
    city_short: "KERINCI",
    province: "JAMBI",
    postal_code: "37172",
  },
  {
    city_short: "KERINCI",
    province: "JAMBI",
    postal_code: "37173",
  },
  {
    city_short: "KERINCI",
    province: "JAMBI",
    postal_code: "37174",
  },
  {
    city_short: "KERINCI",
    province: "JAMBI",
    postal_code: "37175",
  },
  {
    city_short: "BUNGO",
    province: "JAMBI",
    postal_code: "37211",
  },
  {
    city_short: "BUNGO",
    province: "JAMBI",
    postal_code: "37216",
  },
  {
    city_short: "BUNGO",
    province: "JAMBI",
    postal_code: "37252",
  },
  {
    city_short: "BUNGO",
    province: "JAMBI",
    postal_code: "37255",
  },
  {
    city_short: "BUNGO",
    province: "JAMBI",
    postal_code: "37257",
  },
  {
    city_short: "TEBO",
    province: "JAMBI",
    postal_code: "37259",
  },
  {
    city_short: "BUNGO",
    province: "JAMBI",
    postal_code: "37261",
  },
  {
    city_short: "BUNGO",
    province: "JAMBI",
    postal_code: "37262",
  },
  {
    city_short: "BUNGO",
    province: "JAMBI",
    postal_code: "37263",
  },
  {
    city_short: "MERANGIN",
    province: "JAMBI",
    postal_code: "37311",
  },
  {
    city_short: "MERANGIN",
    province: "JAMBI",
    postal_code: "37312",
  },
  {
    city_short: "MERANGIN",
    province: "JAMBI",
    postal_code: "37313",
  },
  {
    city_short: "MERANGIN",
    province: "JAMBI",
    postal_code: "37314",
  },
  {
    city_short: "MERANGIN",
    province: "JAMBI",
    postal_code: "37352",
  },
  {
    city_short: "MERANGIN",
    province: "JAMBI",
    postal_code: "37353",
  },
  {
    city_short: "MERANGIN",
    province: "JAMBI",
    postal_code: "37354",
  },
  {
    city_short: "MERANGIN",
    province: "JAMBI",
    postal_code: "37356",
  },
  {
    city_short: "MERANGIN",
    province: "JAMBI",
    postal_code: "37361",
  },
  {
    city_short: "MERANGIN",
    province: "JAMBI",
    postal_code: "37371",
  },
  {
    city_short: "MERANGIN",
    province: "JAMBI",
    postal_code: "37372",
  },
  {
    city_short: "SAROLANGUN",
    province: "JAMBI",
    postal_code: "37382",
  },
  {
    city_short: "SAROLANGUN",
    province: "JAMBI",
    postal_code: "37481",
  },
  {
    city_short: "SAROLANGUN",
    province: "JAMBI",
    postal_code: "37482",
  },
  {
    city_short: "SAROLANGUN",
    province: "JAMBI",
    postal_code: "37485",
  },
  {
    city_short: "SAROLANGUN",
    province: "JAMBI",
    postal_code: "37491",
  },
  {
    city_short: "SAROLANGUN",
    province: "JAMBI",
    postal_code: "37492",
  },
  {
    city_short: "TEBO",
    province: "JAMBI",
    postal_code: "37553",
  },
  {
    city_short: "TEBO",
    province: "JAMBI",
    postal_code: "37554",
  },
  {
    city_short: "TEBO",
    province: "JAMBI",
    postal_code: "37571",
  },
  {
    city_short: "TEBO",
    province: "JAMBI",
    postal_code: "37572",
  },
  {
    city_short: "TEBO",
    province: "JAMBI",
    postal_code: "37573",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38113",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38114",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38115",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38116",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38117",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38118",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38119",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38121",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38122",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38125",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38126",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38211",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38213",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38214",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38215",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38216",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38221",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38222",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38223",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38224",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38225",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38226",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38227",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38228",
  },
  {
    city_short: "BENGKULU",
    province: "BENGKULU",
    postal_code: "38229",
  },
  {
    city_short: "BENGKULU UTARA",
    province: "BENGKULU",
    postal_code: "38326",
  },
  {
    city_short: "BENGKULU UTARA",
    province: "BENGKULU",
    postal_code: "38361",
  },
  {
    city_short: "BENGKULU UTARA",
    province: "BENGKULU",
    postal_code: "38363",
  },
  {
    city_short: "BENGKULU TENGAH",
    province: "BENGKULU",
    postal_code: "38371",
  },
  {
    city_short: "BENGKULU TENGAH",
    province: "BENGKULU",
    postal_code: "38372",
  },
  {
    city_short: "BENGKULU UTARA",
    province: "BENGKULU",
    postal_code: "38373",
  },
  {
    city_short: "BENGKULU UTARA",
    province: "BENGKULU",
    postal_code: "38374",
  },
  {
    city_short: "BENGKULU TENGAH",
    province: "BENGKULU",
    postal_code: "38375",
  },
  {
    city_short: "BENGKULU TENGAH",
    province: "BENGKULU",
    postal_code: "38376",
  },
  {
    city_short: "BENGKULU TENGAH",
    province: "BENGKULU",
    postal_code: "38377",
  },
  {
    city_short: "BENGKULU TENGAH",
    province: "BENGKULU",
    postal_code: "38378",
  },
  {
    city_short: "BENGKULU TENGAH",
    province: "BENGKULU",
    postal_code: "38379",
  },
  {
    city_short: "BENGKULU TENGAH",
    province: "BENGKULU",
    postal_code: "38382",
  },
  {
    city_short: "BENGKULU TENGAH",
    province: "BENGKULU",
    postal_code: "38383",
  },
  {
    city_short: "BENGKULU TENGAH",
    province: "BENGKULU",
    postal_code: "38385",
  },
  {
    city_short: "BENGKULU TENGAH",
    province: "BENGKULU",
    postal_code: "38386",
  },
  {
    city_short: "BENGKULU UTARA",
    province: "BENGKULU",
    postal_code: "38387",
  },
  {
    city_short: "BENGKULU SEL",
    province: "BENGKULU",
    postal_code: "38511",
  },
  {
    city_short: "BENGKULU SEL",
    province: "BENGKULU",
    postal_code: "38512",
  },
  {
    city_short: "BENGKULU SEL",
    province: "BENGKULU",
    postal_code: "38513",
  },
  {
    city_short: "BENGKULU SEL",
    province: "BENGKULU",
    postal_code: "38514",
  },
  {
    city_short: "BENGKULU SEL",
    province: "BENGKULU",
    postal_code: "38515",
  },
  {
    city_short: "BENGKULU SEL",
    province: "BENGKULU",
    postal_code: "38516",
  },
  {
    city_short: "BENGKULU SEL",
    province: "BENGKULU",
    postal_code: "38517",
  },
  {
    city_short: "BENGKULU SEL",
    province: "BENGKULU",
    postal_code: "38518",
  },
  {
    city_short: "BENGKULU SEL",
    province: "BENGKULU",
    postal_code: "38552",
  },
  {
    city_short: "BENGKULU SEL",
    province: "BENGKULU",
    postal_code: "38553",
  },
  {
    city_short: "BENGKULU SEL",
    province: "BENGKULU",
    postal_code: "38571",
  },
  {
    city_short: "BENGKULU UTARA",
    province: "BENGKULU",
    postal_code: "38575",
  },
  {
    city_short: "BENGKULU UTARA",
    province: "BENGKULU",
    postal_code: "38611",
  },
  {
    city_short: "BENGKULU UTARA",
    province: "BENGKULU",
    postal_code: "38612",
  },
  {
    city_short: "BENGKULU UTARA",
    province: "BENGKULU",
    postal_code: "38614",
  },
  {
    city_short: "BENGKULU UTARA",
    province: "BENGKULU",
    postal_code: "38617",
  },
  {
    city_short: "BENGKULU UTARA",
    province: "BENGKULU",
    postal_code: "38618",
  },
  {
    city_short: "BENGKULU UTARA",
    province: "BENGKULU",
    postal_code: "38619",
  },
  {
    city_short: "BENGKULU UTARA",
    province: "BENGKULU",
    postal_code: "38653",
  },
  {
    city_short: "BENGKULU UTARA",
    province: "BENGKULU",
    postal_code: "38655",
  },
  {
    city_short: "BENGKULU UTARA",
    province: "BENGKULU",
    postal_code: "38656",
  },
  {
    city_short: "BENGKULU UTARA",
    province: "BENGKULU",
    postal_code: "38657",
  },
  {
    city_short: "MUKO MUKO",
    province: "BENGKULU",
    postal_code: "38711",
  },
  {
    city_short: "MUKO MUKO",
    province: "BENGKULU",
    postal_code: "38713",
  },
  {
    city_short: "MUKO MUKO",
    province: "BENGKULU",
    postal_code: "38714",
  },
  {
    city_short: "MUKO MUKO",
    province: "BENGKULU",
    postal_code: "38764",
  },
  {
    city_short: "MUKO MUKO",
    province: "BENGKULU",
    postal_code: "38765",
  },
  {
    city_short: "MUKO MUKO",
    province: "BENGKULU",
    postal_code: "38766",
  },
  {
    city_short: "MUKO MUKO",
    province: "BENGKULU",
    postal_code: "38767",
  },
  {
    city_short: "MUKO MUKO",
    province: "BENGKULU",
    postal_code: "38768",
  },
  {
    city_short: "SELUMA",
    province: "BENGKULU",
    postal_code: "38873",
  },
  {
    city_short: "SELUMA",
    province: "BENGKULU",
    postal_code: "38874",
  },
  {
    city_short: "SELUMA",
    province: "BENGKULU",
    postal_code: "38875",
  },
  {
    city_short: "SELUMA",
    province: "BENGKULU",
    postal_code: "38876",
  },
  {
    city_short: "SELUMA",
    province: "BENGKULU",
    postal_code: "38877",
  },
  {
    city_short: "SELUMA",
    province: "BENGKULU",
    postal_code: "38878",
  },
  {
    city_short: "SELUMA",
    province: "BENGKULU",
    postal_code: "38881",
  },
  {
    city_short: "SELUMA",
    province: "BENGKULU",
    postal_code: "38882",
  },
  {
    city_short: "SELUMA",
    province: "BENGKULU",
    postal_code: "38883",
  },
  {
    city_short: "SELUMA",
    province: "BENGKULU",
    postal_code: "38884",
  },
  {
    city_short: "SELUMA",
    province: "BENGKULU",
    postal_code: "38885",
  },
  {
    city_short: "SELUMA",
    province: "BENGKULU",
    postal_code: "38886",
  },
  {
    city_short: "SELUMA",
    province: "BENGKULU",
    postal_code: "38887",
  },
  {
    city_short: "SELUMA",
    province: "BENGKULU",
    postal_code: "38888",
  },
  {
    city_short: "KAUR",
    province: "BENGKULU",
    postal_code: "38955",
  },
  {
    city_short: "KAUR",
    province: "BENGKULU",
    postal_code: "38956",
  },
  {
    city_short: "KAUR",
    province: "BENGKULU",
    postal_code: "38961",
  },
  {
    city_short: "KAUR",
    province: "BENGKULU",
    postal_code: "38962",
  },
  {
    city_short: "KAUR",
    province: "BENGKULU",
    postal_code: "38963",
  },
  {
    city_short: "KAUR",
    province: "BENGKULU",
    postal_code: "38964",
  },
  {
    city_short: "KAUR",
    province: "BENGKULU",
    postal_code: "38965",
  },
  {
    city_short: "REJANG LEBONG",
    province: "BENGKULU",
    postal_code: "39111",
  },
  {
    city_short: "REJANG LEBONG",
    province: "BENGKULU",
    postal_code: "39112",
  },
  {
    city_short: "REJANG LEBONG",
    province: "BENGKULU",
    postal_code: "39113",
  },
  {
    city_short: "REJANG LEBONG",
    province: "BENGKULU",
    postal_code: "39114",
  },
  {
    city_short: "REJANG LEBONG",
    province: "BENGKULU",
    postal_code: "39115",
  },
  {
    city_short: "REJANG LEBONG",
    province: "BENGKULU",
    postal_code: "39116",
  },
  {
    city_short: "REJANG LEBONG",
    province: "BENGKULU",
    postal_code: "39117",
  },
  {
    city_short: "REJANG LEBONG",
    province: "BENGKULU",
    postal_code: "39118",
  },
  {
    city_short: "REJANG LEBONG",
    province: "BENGKULU",
    postal_code: "39119",
  },
  {
    city_short: "REJANG LEBONG",
    province: "BENGKULU",
    postal_code: "39121",
  },
  {
    city_short: "REJANG LEBONG",
    province: "BENGKULU",
    postal_code: "39123",
  },
  {
    city_short: "REJANG LEBONG",
    province: "BENGKULU",
    postal_code: "39124",
  },
  {
    city_short: "REJANG LEBONG",
    province: "BENGKULU",
    postal_code: "39125",
  },
  {
    city_short: "REJANG LEBONG",
    province: "BENGKULU",
    postal_code: "39152",
  },
  {
    city_short: "REJANG LEBONG",
    province: "BENGKULU",
    postal_code: "39153",
  },
  {
    city_short: "REJANG LEBONG",
    province: "BENGKULU",
    postal_code: "39182",
  },
  {
    city_short: "REJANG LEBONG",
    province: "BENGKULU",
    postal_code: "39183",
  },
  {
    city_short: "LEBONG",
    province: "BENGKULU",
    postal_code: "39261",
  },
  {
    city_short: "LEBONG",
    province: "BENGKULU",
    postal_code: "39262",
  },
  {
    city_short: "LEBONG",
    province: "BENGKULU",
    postal_code: "39263",
  },
  {
    city_short: "LEBONG",
    province: "BENGKULU",
    postal_code: "39264",
  },
  {
    city_short: "LEBONG",
    province: "BENGKULU",
    postal_code: "39265",
  },
  {
    city_short: "LEBONG",
    province: "BENGKULU",
    postal_code: "39267",
  },
  {
    city_short: "LEBONG",
    province: "BENGKULU",
    postal_code: "39268",
  },
  {
    city_short: "LEBONG",
    province: "BENGKULU",
    postal_code: "39269",
  },
  {
    city_short: "KEPAHIANG",
    province: "BENGKULU",
    postal_code: "39371",
  },
  {
    city_short: "KEPAHIANG",
    province: "BENGKULU",
    postal_code: "39372",
  },
  {
    city_short: "KEPAHIANG",
    province: "BENGKULU",
    postal_code: "39373",
  },
  {
    city_short: "KEPAHIANG",
    province: "BENGKULU",
    postal_code: "39374",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40111",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40112",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40113",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40114",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40115",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40116",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40117",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40121",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40122",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40123",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40124",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40125",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40131",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40132",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40133",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40134",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40135",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40141",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40142",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40143",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40151",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40152",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40153",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40154",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40161",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40162",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40163",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40164",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40171",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40172",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40173",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40174",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40175",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40181",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40182",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40183",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40184",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40191",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40192",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40193",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40195",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40196",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40197",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40198",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40211",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40212",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40213",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40214",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40215",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40216",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40217",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40218",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40221",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40222",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40223",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40224",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40225",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40226",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40227",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40228",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40229",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40231",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40232",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40233",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40234",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40235",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40236",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40237",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40238",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40239",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40241",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40242",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40243",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40251",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40252",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40253",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40254",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40255",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40256",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40257",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40258",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40261",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40262",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40263",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40264",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40265",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40266",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40267",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40271",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40272",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40273",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40274",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40275",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40281",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40282",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40283",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40284",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40285",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40286",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40287",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40288",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40291",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40292",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40293",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40294",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40295",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40374",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40375",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40376",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40377",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40378",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40379",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40381",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40382",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40383",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40384",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40385",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40386",
  },
  {
    city_short: "BANDUNG BARAT",
    province: "JAWA BARAT",
    postal_code: "40391",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40394",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40395",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40396",
  },
  {
    city_short: "CIMAHI",
    province: "JAWA BARAT",
    postal_code: "40511",
  },
  {
    city_short: "CIMAHI",
    province: "JAWA BARAT",
    postal_code: "40512",
  },
  {
    city_short: "CIMAHI",
    province: "JAWA BARAT",
    postal_code: "40513",
  },
  {
    city_short: "CIMAHI",
    province: "JAWA BARAT",
    postal_code: "40514",
  },
  {
    city_short: "CIMAHI",
    province: "JAWA BARAT",
    postal_code: "40521",
  },
  {
    city_short: "CIMAHI",
    province: "JAWA BARAT",
    postal_code: "40522",
  },
  {
    city_short: "CIMAHI",
    province: "JAWA BARAT",
    postal_code: "40523",
  },
  {
    city_short: "CIMAHI",
    province: "JAWA BARAT",
    postal_code: "40524",
  },
  {
    city_short: "CIMAHI",
    province: "JAWA BARAT",
    postal_code: "40525",
  },
  {
    city_short: "CIMAHI",
    province: "JAWA BARAT",
    postal_code: "40526",
  },
  {
    city_short: "CIMAHI",
    province: "JAWA BARAT",
    postal_code: "40531",
  },
  {
    city_short: "CIMAHI",
    province: "JAWA BARAT",
    postal_code: "40532",
  },
  {
    city_short: "CIMAHI",
    province: "JAWA BARAT",
    postal_code: "40533",
  },
  {
    city_short: "CIMAHI",
    province: "JAWA BARAT",
    postal_code: "40534",
  },
  {
    city_short: "CIMAHI",
    province: "JAWA BARAT",
    postal_code: "40535",
  },
  {
    city_short: "BANDUNG BARAT",
    province: "JAWA BARAT",
    postal_code: "40551",
  },
  {
    city_short: "BANDUNG BARAT",
    province: "JAWA BARAT",
    postal_code: "40552",
  },
  {
    city_short: "BANDUNG BARAT",
    province: "JAWA BARAT",
    postal_code: "40553",
  },
  {
    city_short: "BANDUNG BARAT",
    province: "JAWA BARAT",
    postal_code: "40554",
  },
  {
    city_short: "BANDUNG BARAT",
    province: "JAWA BARAT",
    postal_code: "40556",
  },
  {
    city_short: "BANDUNG BARAT",
    province: "JAWA BARAT",
    postal_code: "40558",
  },
  {
    city_short: "BANDUNG BARAT",
    province: "JAWA BARAT",
    postal_code: "40559",
  },
  {
    city_short: "BANDUNG BARAT",
    province: "JAWA BARAT",
    postal_code: "40561",
  },
  {
    city_short: "BANDUNG BARAT",
    province: "JAWA BARAT",
    postal_code: "40562",
  },
  {
    city_short: "BANDUNG BARAT",
    province: "JAWA BARAT",
    postal_code: "40563",
  },
  {
    city_short: "BANDUNG BARAT",
    province: "JAWA BARAT",
    postal_code: "40564",
  },
  {
    city_short: "BANDUNG BARAT",
    province: "JAWA BARAT",
    postal_code: "40565",
  },
  {
    city_short: "BANDUNG BARAT",
    province: "JAWA BARAT",
    postal_code: "40566",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40611",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40614",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40615",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40616",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40617",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40618",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40619",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40621",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40622",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40623",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40624",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40625",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40626",
  },
  {
    city_short: "BANDUNG BARAT",
    province: "JAWA BARAT",
    postal_code: "40791",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40911",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40912",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40913",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40914",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40915",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40921",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40972",
  },
  {
    city_short: "BANDUNG",
    province: "JAWA BARAT",
    postal_code: "40973",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41111",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41112",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41113",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41114",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41115",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41116",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41117",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41118",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41119",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41151",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41152",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41161",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41162",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41163",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41164",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41165",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41166",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41167",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41171",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41172",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41174",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41175",
  },
  {
    city_short: "PURWAKARTA",
    province: "JAWA BARAT",
    postal_code: "41181",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41211",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41212",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41213",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41215",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41251",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41252",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41253",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41254",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41255",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41256",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41257",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41258",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41259",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41261",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41262",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41263",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41266",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41271",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41272",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41281",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41282",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41283",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41284",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41285",
  },
  {
    city_short: "SUBANG",
    province: "JAWA BARAT",
    postal_code: "41286",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41311",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41312",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41314",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41315",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41316",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41352",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41353",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41354",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41355",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41356",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41357",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41358",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41361",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41362",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41363",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41371",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41372",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41373",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41374",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41381",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41382",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41383",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41384",
  },
  {
    city_short: "KARAWANG",
    province: "JAWA BARAT",
    postal_code: "41385",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42111",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42112",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42113",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42114",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42115",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42116",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42117",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42118",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42119",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42121",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42122",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42123",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42124",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42125",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42126",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42127",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42128",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42161",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42162",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42163",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42164",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42165",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42166",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42167",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42168",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42171",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42172",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42173",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42174",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42175",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42176",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42177",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42178",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42181",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42182",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42183",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42184",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42185",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42186",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42191",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42192",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42193",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42194",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42195",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42196",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42211",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42212",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42213",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42214",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42215",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42216",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42217",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42218",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42219",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42251",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42252",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42253",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42261",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42262",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42263",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42264",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42265",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42271",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42272",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42273",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42274",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42275",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42276",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42277",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42281",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42282",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42283",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42284",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42285",
  },
  {
    city_short: "PANDEGLANG",
    province: "BANTEN",
    postal_code: "42286",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42311",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42312",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42313",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42314",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42315",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42316",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42317",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42318",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42319",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42352",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42353",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42354",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42355",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42356",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42357",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42361",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42362",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42363",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42364",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42371",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42372",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42381",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42391",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42392",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42393",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42394",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42395",
  },
  {
    city_short: "LEBAK",
    province: "BANTEN",
    postal_code: "42396",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42411",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42412",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42413",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42414",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42415",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42416",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42417",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42418",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42419",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42422",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42423",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42424",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42425",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42426",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42427",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42431",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42433",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42434",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42436",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42437",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42438",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42439",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42441",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42442",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42443",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42444",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42445",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42446",
  },
  {
    city_short: "CILEGON",
    province: "BANTEN",
    postal_code: "42447",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42453",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42454",
  },
  {
    city_short: "SERANG",
    province: "BANTEN",
    postal_code: "42455",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43111",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43112",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43113",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43114",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43115",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43116",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43121",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43122",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43123",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43131",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43132",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43133",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43134",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43135",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43141",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43142",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43143",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43144",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43145",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43151",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43152",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43153",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43154",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43155",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43156",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43157",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43161",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43162",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43165",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43166",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43167",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43168",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43169",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43171",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43172",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43173",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43174",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43175",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43176",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43177",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43178",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43179",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43181",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43182",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43183",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43184",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43185",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43186",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43187",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43191",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43192",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43193",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43194",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43196",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43197",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43211",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43212",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43213",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43214",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43215",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43216",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43252",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43253",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43254",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43261",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43262",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43263",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43264",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43265",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43266",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43267",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43268",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43269",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43271",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43272",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43273",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43274",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43275",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43281",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43282",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43283",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43284",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43285",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43291",
  },
  {
    city_short: "CIANJUR",
    province: "JAWA BARAT",
    postal_code: "43292",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43351",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43353",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43354",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43355",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43356",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43357",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43358",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43359",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43361",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43362",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43363",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43364",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43365",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43366",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43367",
  },
  {
    city_short: "SUKABUMI",
    province: "JAWA BARAT",
    postal_code: "43368",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44111",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44112",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44113",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44114",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44115",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44116",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44117",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44118",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44119",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44151",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44152",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44153",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44161",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44162",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44163",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44164",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44165",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44166",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44167",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44168",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44171",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44172",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44173",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44174",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44175",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44176",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44177",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44178",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44181",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44182",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44183",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44184",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44185",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44186",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44187",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44188",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44191",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44192",
  },
  {
    city_short: "GARUT",
    province: "JAWA BARAT",
    postal_code: "44193",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45111",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45112",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45113",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45114",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45115",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45116",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45117",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45118",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45121",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45122",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45123",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45131",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45132",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45133",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45134",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45141",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45142",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45143",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45144",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45145",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45151",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45152",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45153",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45154",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45155",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45156",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45161",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45162",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45163",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45164",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45165",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45166",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45167",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45171",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45172",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45173",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45181",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45182",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45183",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45185",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45186",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45187",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45188",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45189",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45191",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45192",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45193",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45211",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45212",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45213",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45214",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45215",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45216",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45217",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45218",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45219",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45221",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45222",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45223",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45224",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45225",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45226",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45227",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45228",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45229",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45252",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45253",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45254",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45255",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45256",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45257",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45258",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45261",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45262",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45263",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45264",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45265",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45271",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45272",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45273",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45274",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45281",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45282",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45283",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45284",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45285",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45311",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45313",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45314",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45315",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45321",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45322",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45323",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45353",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45354",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45355",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45356",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45361",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45362",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45363",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45364",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45365",
  },
  {
    city_short: "INDRAMAYU",
    province: "JAWA BARAT",
    postal_code: "45365",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45366",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45371",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45372",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45373",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45375",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45376",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45377",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45381",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45382",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45383",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45391",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45392",
  },
  {
    city_short: "SUMEDANG",
    province: "JAWA BARAT",
    postal_code: "45393",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45411",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45412",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45414",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45415",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45416",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45417",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45418",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45419",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45452",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45453",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45454",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45455",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45456",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45457",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45458",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45459",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45461",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45462",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45463",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45464",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45465",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45466",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45467",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45468",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45471",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45472",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45473",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45474",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45475",
  },
  {
    city_short: "MAJALENGKA",
    province: "JAWA BARAT",
    postal_code: "45476",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45511",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45512",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45513",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45514",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45515",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45516",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45517",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45518",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45521",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45552",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45553",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45554",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45555",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45556",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45557",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45558",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45559",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45561",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45562",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45563",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45564",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45565",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45566",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45571",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45572",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45573",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45574",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45575",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45576",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45581",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45582",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45583",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45584",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45585",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45586",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45587",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45588",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45591",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45592",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45593",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45594",
  },
  {
    city_short: "KUNINGAN",
    province: "JAWA BARAT",
    postal_code: "45595",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45611",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45612",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45613",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45643",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45651",
  },
  {
    city_short: "CIREBON",
    province: "JAWA BARAT",
    postal_code: "45652",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46111",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46112",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46113",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46114",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46115",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46121",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46122",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46123",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46124",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46125",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46126",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46131",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46132",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46133",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46134",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46151",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46153",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46155",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46156",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46158",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46168",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46175",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46181",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46182",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46183",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46184",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46185",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46186",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46187",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46188",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46189",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46192",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46193",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46194",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46195",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46196",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46197",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46198",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46211",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46212",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46213",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46214",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46215",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46216",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46217",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46218",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46219",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46252",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46253",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46254",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46255",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46256",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46258",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46261",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46262",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46263",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46264",
  },
  {
    city_short: "PANGANDARAN",
    province: "JAWA BARAT",
    postal_code: "46267",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46268",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46271",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46272",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46273",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46274",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46311",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46312",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46313",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46314",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46315",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46316",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46317",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46321",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46322",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46323",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46324",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46325",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46326",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46327",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46331",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46332",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46333",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46334",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46335",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46342",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46343",
  },
  {
    city_short: "BANJAR",
    province: "JAWA BARAT",
    postal_code: "46344",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46352",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46361",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46365",
  },
  {
    city_short: "PANGANDARAN",
    province: "JAWA BARAT",
    postal_code: "46365",
  },
  {
    city_short: "PANGANDARAN",
    province: "JAWA BARAT",
    postal_code: "46371",
  },
  {
    city_short: "PANGANDARAN",
    province: "JAWA BARAT",
    postal_code: "46372",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46381",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46382",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46383",
  },
  {
    city_short: "PANGANDARAN",
    province: "JAWA BARAT",
    postal_code: "46384",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46385",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46386",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46387",
  },
  {
    city_short: "CIAMIS",
    province: "JAWA BARAT",
    postal_code: "46388",
  },
  {
    city_short: "PANGANDARAN",
    province: "JAWA BARAT",
    postal_code: "46391",
  },
  {
    city_short: "PANGANDARAN",
    province: "JAWA BARAT",
    postal_code: "46392",
  },
  {
    city_short: "PANGANDARAN",
    province: "JAWA BARAT",
    postal_code: "46393",
  },
  {
    city_short: "PANGANDARAN",
    province: "JAWA BARAT",
    postal_code: "46394",
  },
  {
    city_short: "PANGANDARAN",
    province: "JAWA BARAT",
    postal_code: "46395",
  },
  {
    city_short: "PANGANDARAN",
    province: "JAWA BARAT",
    postal_code: "46396",
  },
  {
    city_short: "PANGANDARAN",
    province: "JAWA BARAT",
    postal_code: "46397",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46411",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46412",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46413",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46414",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46415",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46416",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46417",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46418",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46461",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46462",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46463",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46464",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46465",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46466",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46471",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46473",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46474",
  },
  {
    city_short: "TASIKMALAYA",
    province: "JAWA BARAT",
    postal_code: "46475",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50111",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50112",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50113",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50115",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50116",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50117",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50118",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50122",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50123",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50124",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50125",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50126",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50131",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50132",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50133",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50134",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50135",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50137",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50138",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50139",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50141",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50144",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50145",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50146",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50147",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50148",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50149",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50151",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50152",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50154",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50155",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50156",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50162",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50163",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50164",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50166",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50171",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50172",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50173",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50174",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50175",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50176",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50177",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50178",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50179",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50181",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50182",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50183",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50184",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50185",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50186",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50187",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50188",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50189",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50192",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50194",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50196",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50197",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50198",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50199",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50211",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50212",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50213",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50214",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50215",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50216",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50217",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50218",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50219",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50221",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50222",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50223",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50224",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50225",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50226",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50227",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50228",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50229",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50231",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50232",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50233",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50235",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50237",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50241",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50242",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50244",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50245",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50246",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50248",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50249",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50252",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50253",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50254",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50255",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50256",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50257",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50261",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50262",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50263",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50264",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50265",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50266",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50267",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50268",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50269",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50271",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50272",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50273",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50274",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50275",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50276",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50277",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50278",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50279",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50511",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50512",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50513",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50514",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50515",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50516",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50517",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50518",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50519",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50551",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50552",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50611",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50612",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50613",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50614",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50661",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50662",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50663",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50664",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50711",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50712",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50713",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50714",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50715",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50716",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50721",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50722",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50723",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50724",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50732",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50733",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50734",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50735",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50736",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50741",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50742",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50743",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50744",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50745",
  },
  {
    city_short: "SALATIGA",
    province: "JAWA TENGAH",
    postal_code: "50746",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50771",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50772",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50773",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50774",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50775",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50776",
  },
  {
    city_short: "SEMARANG",
    province: "JAWA TENGAH",
    postal_code: "50777",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51111",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51112",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51113",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51116",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51117",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51118",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51119",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51122",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51123",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51124",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51126",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51127",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51128",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51129",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51132",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51133",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51134",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51135",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51136",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51137",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51138",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51139",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51141",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51143",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51144",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51145",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51146",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51147",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51148",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51149",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51151",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51152",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51153",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51155",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51156",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51161",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51162",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51163",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51164",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51171",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51173",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51174",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51181",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51182",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51183",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51191",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51192",
  },
  {
    city_short: "PEKALONGAN",
    province: "JAWA TENGAH",
    postal_code: "51193",
  },
  {
    city_short: "BATANG",
    province: "JAWA TENGAH",
    postal_code: "51211",
  },
  {
    city_short: "BATANG",
    province: "JAWA TENGAH",
    postal_code: "51212",
  },
  {
    city_short: "BATANG",
    province: "JAWA TENGAH",
    postal_code: "51214",
  },
  {
    city_short: "BATANG",
    province: "JAWA TENGAH",
    postal_code: "51215",
  },
  {
    city_short: "BATANG",
    province: "JAWA TENGAH",
    postal_code: "51216",
  },
  {
    city_short: "BATANG",
    province: "JAWA TENGAH",
    postal_code: "51252",
  },
  {
    city_short: "BATANG",
    province: "JAWA TENGAH",
    postal_code: "51253",
  },
  {
    city_short: "BATANG",
    province: "JAWA TENGAH",
    postal_code: "51254",
  },
  {
    city_short: "BATANG",
    province: "JAWA TENGAH",
    postal_code: "51255",
  },
  {
    city_short: "BATANG",
    province: "JAWA TENGAH",
    postal_code: "51261",
  },
  {
    city_short: "BATANG",
    province: "JAWA TENGAH",
    postal_code: "51262",
  },
  {
    city_short: "BATANG",
    province: "JAWA TENGAH",
    postal_code: "51271",
  },
  {
    city_short: "BATANG",
    province: "JAWA TENGAH",
    postal_code: "51272",
  },
  {
    city_short: "BATANG",
    province: "JAWA TENGAH",
    postal_code: "51273",
  },
  {
    city_short: "BATANG",
    province: "JAWA TENGAH",
    postal_code: "51274",
  },
  {
    city_short: "BATANG",
    province: "JAWA TENGAH",
    postal_code: "51281",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51311",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51312",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51313",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51314",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51315",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51316",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51317",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51318",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51319",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51351",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51352",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51353",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51354",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51355",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51356",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51357",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51361",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51362",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51363",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51364",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51371",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51372",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51381",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51382",
  },
  {
    city_short: "KENDAL",
    province: "JAWA TENGAH",
    postal_code: "51383",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52111",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52112",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52114",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52115",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52117",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52121",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52122",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52123",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52124",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52125",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52131",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52132",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52133",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52134",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52135",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52136",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52137",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52138",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52141",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52143",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52144",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52146",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52147",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52181",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52182",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52183",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52184",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52192",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52193",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52194",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52211",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52212",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52213",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52214",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52215",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52216",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52217",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52218",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52219",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52221",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52222",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52252",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52253",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52254",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52255",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52261",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52262",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52263",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52264",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52265",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52266",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52271",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52272",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52273",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52274",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52275",
  },
  {
    city_short: "BREBES",
    province: "JAWA TENGAH",
    postal_code: "52276",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52311",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52312",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52313",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52314",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52315",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52316",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52317",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52318",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52319",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52352",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52353",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52354",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52355",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52356",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52357",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52361",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52362",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52363",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52364",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52365",
  },
  {
    city_short: "PEMALANG",
    province: "JAWA TENGAH",
    postal_code: "52371",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52411",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52412",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52413",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52414",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52415",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52416",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52418",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52419",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52451",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52461",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52462",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52463",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52464",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52465",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52466",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52471",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52472",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52473",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52484",
  },
  {
    city_short: "TEGAL",
    province: "JAWA TENGAH",
    postal_code: "52492",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53111",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53112",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53113",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53114",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53115",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53116",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53121",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53122",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53123",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53124",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53125",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53126",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53127",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53131",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53132",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53133",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53134",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53135",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53136",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53137",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53141",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53142",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53144",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53145",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53146",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53147",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53151",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53152",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53161",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53162",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53163",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53164",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53165",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53171",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53172",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53173",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53174",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53175",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53176",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53177",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53181",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53182",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53183",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53191",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53192",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53193",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53194",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53195",
  },
  {
    city_short: "BANYUMAS",
    province: "JAWA TENGAH",
    postal_code: "53196",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53211",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53212",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53213",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53215",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53221",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53222",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53223",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53224",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53225",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53231",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53232",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53233",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53234",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53235",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53252",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53253",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53254",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53255",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53256",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53257",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53261",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53262",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53263",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53264",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53265",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53266",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53271",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53272",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53273",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53274",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53281",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53282",
  },
  {
    city_short: "CILACAP",
    province: "JAWA TENGAH",
    postal_code: "53283",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53311",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53312",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53313",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53314",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53315",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53316",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53317",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53318",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53319",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53321",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53331",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53352",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53353",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53354",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53355",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53356",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53357",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53361",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53362",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53371",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53372",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53381",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53382",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53391",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53392",
  },
  {
    city_short: "PURBALINGGA",
    province: "JAWA TENGAH",
    postal_code: "53393",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53411",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53412",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53413",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53414",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53416",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53417",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53418",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53452",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53453",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53454",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53455",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53456",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53457",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53458",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53461",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53462",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53463",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53471",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53472",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53473",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53474",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53475",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53481",
  },
  {
    city_short: "BANJARNEGARA",
    province: "JAWA TENGAH",
    postal_code: "53482",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54112",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54113",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54114",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54115",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54116",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54117",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54118",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54119",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54151",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54171",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54172",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54173",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54174",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54175",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54181",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54183",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54191",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54211",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54212",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54214",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54215",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54222",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54223",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54224",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54251",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54261",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54262",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54263",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54264",
  },
  {
    city_short: "PURWOREJO",
    province: "JAWA TENGAH",
    postal_code: "54265",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54311",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54312",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54313",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54314",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54315",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54316",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54317",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54352",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54353",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54361",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54362",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54363",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54364",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54365",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54366",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54381",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54382",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54383",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54391",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54392",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54393",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54394",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54395",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54411",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54412",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54413",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54414",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54416",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54421",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54472",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54473",
  },
  {
    city_short: "KEBUMEN",
    province: "JAWA TENGAH",
    postal_code: "54474",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55111",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55112",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55121",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55122",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55131",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55132",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55133",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55141",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55142",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55143",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55151",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55152",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55153",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55161",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55162",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55163",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55164",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55165",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55166",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55167",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55171",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55172",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55173",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55181",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55182",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55183",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55184",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55185",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55186",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55188",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55191",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55192",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55193",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55194",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55195",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55196",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55197",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55198",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55211",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55212",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55213",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55221",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55222",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55223",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55224",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55225",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55231",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55232",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55233",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55241",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55242",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55243",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55244",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55251",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55252",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55253",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55261",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55262",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55264",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55271",
  },
  {
    city_short: "YOGYAKARTA",
    province: "DI YOGYAKARTA",
    postal_code: "55272",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55281",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55282",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55283",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55284",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55285",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55286",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55287",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55288",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55291",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55293",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55294",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55295",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55511",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55512",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55513",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55514",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55515",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55551",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55552",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55561",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55562",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55563",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55571",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55572",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55573",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55581",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55582",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55583",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55584",
  },
  {
    city_short: "SLEMAN",
    province: "DI YOGYAKARTA",
    postal_code: "55592",
  },
  {
    city_short: "KULON PROGO",
    province: "DI YOGYAKARTA",
    postal_code: "55651",
  },
  {
    city_short: "KULON PROGO",
    province: "DI YOGYAKARTA",
    postal_code: "55652",
  },
  {
    city_short: "KULON PROGO",
    province: "DI YOGYAKARTA",
    postal_code: "55653",
  },
  {
    city_short: "KULON PROGO",
    province: "DI YOGYAKARTA",
    postal_code: "55654",
  },
  {
    city_short: "KULON PROGO",
    province: "DI YOGYAKARTA",
    postal_code: "55655",
  },
  {
    city_short: "KULON PROGO",
    province: "DI YOGYAKARTA",
    postal_code: "55661",
  },
  {
    city_short: "KULON PROGO",
    province: "DI YOGYAKARTA",
    postal_code: "55663",
  },
  {
    city_short: "KULON PROGO",
    province: "DI YOGYAKARTA",
    postal_code: "55664",
  },
  {
    city_short: "KULON PROGO",
    province: "DI YOGYAKARTA",
    postal_code: "55671",
  },
  {
    city_short: "KULON PROGO",
    province: "DI YOGYAKARTA",
    postal_code: "55672",
  },
  {
    city_short: "KULON PROGO",
    province: "DI YOGYAKARTA",
    postal_code: "55673",
  },
  {
    city_short: "KULON PROGO",
    province: "DI YOGYAKARTA",
    postal_code: "55674",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55711",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55712",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55713",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55714",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55715",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55751",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55752",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55761",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55762",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55763",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55764",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55771",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55772",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55781",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55782",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55783",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55791",
  },
  {
    city_short: "BANTUL",
    province: "DI YOGYAKARTA",
    postal_code: "55792",
  },
  {
    city_short: "GUNUNG KIDUL",
    province: "DI YOGYAKARTA",
    postal_code: "55811",
  },
  {
    city_short: "GUNUNG KIDUL",
    province: "DI YOGYAKARTA",
    postal_code: "55813",
  },
  {
    city_short: "GUNUNG KIDUL",
    province: "DI YOGYAKARTA",
    postal_code: "55851",
  },
  {
    city_short: "GUNUNG KIDUL",
    province: "DI YOGYAKARTA",
    postal_code: "55852",
  },
  {
    city_short: "GUNUNG KIDUL",
    province: "DI YOGYAKARTA",
    postal_code: "55853",
  },
  {
    city_short: "GUNUNG KIDUL",
    province: "DI YOGYAKARTA",
    postal_code: "55854",
  },
  {
    city_short: "GUNUNG KIDUL",
    province: "DI YOGYAKARTA",
    postal_code: "55861",
  },
  {
    city_short: "GUNUNG KIDUL",
    province: "DI YOGYAKARTA",
    postal_code: "55862",
  },
  {
    city_short: "GUNUNG KIDUL",
    province: "DI YOGYAKARTA",
    postal_code: "55863",
  },
  {
    city_short: "GUNUNG KIDUL",
    province: "DI YOGYAKARTA",
    postal_code: "55871",
  },
  {
    city_short: "GUNUNG KIDUL",
    province: "DI YOGYAKARTA",
    postal_code: "55872",
  },
  {
    city_short: "GUNUNG KIDUL",
    province: "DI YOGYAKARTA",
    postal_code: "55881",
  },
  {
    city_short: "GUNUNG KIDUL",
    province: "DI YOGYAKARTA",
    postal_code: "55883",
  },
  {
    city_short: "GUNUNG KIDUL",
    province: "DI YOGYAKARTA",
    postal_code: "55891",
  },
  {
    city_short: "GUNUNG KIDUL",
    province: "DI YOGYAKARTA",
    postal_code: "55892",
  },
  {
    city_short: "GUNUNG KIDUL",
    province: "DI YOGYAKARTA",
    postal_code: "55893",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56111",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56112",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56113",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56114",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56115",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56116",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56117",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56121",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56122",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56123",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56124",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56125",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56126",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56127",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56151",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56152",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56153",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56161",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56162",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56163",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56172",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56191",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56192",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56193",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56194",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56195",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56196",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56211",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56212",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56213",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56214",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56215",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56216",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56217",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56218",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56221",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56222",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56223",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56224",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56225",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56226",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56227",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56228",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56229",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56252",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56253",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56254",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56255",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56256",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56257",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56258",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56259",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56261",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56262",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56263",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56264",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56265",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56266",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56271",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56272",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56281",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56282",
  },
  {
    city_short: "TEMANGGUNG",
    province: "JAWA TENGAH",
    postal_code: "56283",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56311",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56312",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56313",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56314",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56315",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56316",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56317",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56318",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56319",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56351",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56352",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56353",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56354",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56361",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56362",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56364",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56365",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56371",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56372",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56373",
  },
  {
    city_short: "WONOSOBO",
    province: "JAWA TENGAH",
    postal_code: "56374",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56411",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56412",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56413",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56414",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56415",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56481",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56482",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56483",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56484",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56485",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56511",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56512",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56553",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56562",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56572",
  },
  {
    city_short: "MAGELANG",
    province: "JAWA TENGAH",
    postal_code: "56592",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57116",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57118",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57121",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57122",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57125",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57126",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57127",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57128",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57129",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57131",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57132",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57133",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57134",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57135",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57136",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57137",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57138",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57139",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57141",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57142",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57143",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57144",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57145",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57146",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57147",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57148",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57149",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57151",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57152",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57153",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57154",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57155",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57156",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57157",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57161",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57162",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57163",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57164",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57165",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57166",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57168",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57169",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57171",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57172",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57173",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57174",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57175",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57176",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57177",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57178",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57179",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57181",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57188",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57191",
  },
  {
    city_short: "SOLO",
    province: "JAWA TENGAH",
    postal_code: "57199",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57211",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57212",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57213",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57214",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57215",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57216",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57221",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57222",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57252",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57253",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57254",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57256",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57261",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57262",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57263",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57271",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57272",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57274",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57275",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57276",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57277",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57281",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57282",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57283",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57292",
  },
  {
    city_short: "SRAGEN",
    province: "JAWA TENGAH",
    postal_code: "57293",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57311",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57312",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57313",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57314",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57315",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57316",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57321",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57322",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57323",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57331",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57352",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57362",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57363",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57372",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57373",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57374",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57375",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57376",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57377",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57378",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57381",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57382",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57383",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57384",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57385",
  },
  {
    city_short: "BOYOLALI",
    province: "JAWA TENGAH",
    postal_code: "57391",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57411",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57412",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57413",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57414",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57415",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57416",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57417",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57418",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57419",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57421",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57422",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57423",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57424",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57425",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57426",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57432",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57433",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57434",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57435",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57437",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57438",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57451",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57452",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57454",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57455",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57461",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57462",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57463",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57464",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57465",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57466",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57467",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57468",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57471",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57472",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57473",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57474",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57475",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57481",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57482",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57483",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57484",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57485",
  },
  {
    city_short: "KLATEN",
    province: "JAWA TENGAH",
    postal_code: "57486",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57511",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57512",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57513",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57514",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57516",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57519",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57521",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57524",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57527",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57528",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57551",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57552",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57554",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57555",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57556",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57557",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57561",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57562",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57563",
  },
  {
    city_short: "SUKOHARJO",
    province: "JAWA TENGAH",
    postal_code: "57571",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57611",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57612",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57613",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57614",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57615",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57652",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57661",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57662",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57663",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57664",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57671",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57672",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57673",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57674",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57675",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57677",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57678",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57681",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57682",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57683",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57691",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57692",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57693",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57694",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57695",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57696",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57697",
  },
  {
    city_short: "WONOGIRI",
    province: "JAWA TENGAH",
    postal_code: "57698",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57711",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57712",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57713",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57714",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57715",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57716",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57721",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57722",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57731",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57752",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57753",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57762",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57771",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57781",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57782",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57783",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57784",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57785",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57791",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57792",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57793",
  },
  {
    city_short: "KARANGANYAR",
    province: "JAWA TENGAH",
    postal_code: "57794",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58111",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58112",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58113",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58114",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58152",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58153",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58154",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58161",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58162",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58163",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58164",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58165",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58166",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58167",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58171",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58172",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58181",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58182",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58183",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58191",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58192",
  },
  {
    city_short: "GROBOGAN",
    province: "JAWA TENGAH",
    postal_code: "58193",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58211",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58212",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58213",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58214",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58215",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58216",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58217",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58218",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58219",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58252",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58253",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58254",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58255",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58256",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58257",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58261",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58262",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58311",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58312",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58313",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58314",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58315",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58371",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58372",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58381",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58382",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58383",
  },
  {
    city_short: "BLORA",
    province: "JAWA TENGAH",
    postal_code: "58384",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59111",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59112",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59113",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59114",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59115",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59116",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59117",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59118",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59119",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59152",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59153",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59154",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59155",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59156",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59157",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59158",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59161",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59162",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59163",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59171",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59172",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59173",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59174",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59181",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59182",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59183",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59184",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59185",
  },
  {
    city_short: "PATI",
    province: "JAWA TENGAH",
    postal_code: "59186",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59211",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59212",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59213",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59214",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59215",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59217",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59218",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59219",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59252",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59253",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59254",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59255",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59261",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59262",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59263",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59264",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59265",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59271",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59272",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59273",
  },
  {
    city_short: "REMBANG",
    province: "JAWA TENGAH",
    postal_code: "59274",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59311",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59312",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59313",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59314",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59315",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59316",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59317",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59318",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59319",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59321",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59322",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59323",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59324",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59325",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59326",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59327",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59332",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59333",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59341",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59342",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59343",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59344",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59346",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59347",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59348",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59349",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59353",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59372",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59381",
  },
  {
    city_short: "KUDUS",
    province: "JAWA TENGAH",
    postal_code: "59382",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59411",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59412",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59413",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59414",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59415",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59416",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59417",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59418",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59419",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59421",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59422",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59423",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59424",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59425",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59426",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59427",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59428",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59429",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59431",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59432",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59451",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59452",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59453",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59454",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59455",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59461",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59462",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59463",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59464",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59465",
  },
  {
    city_short: "JEPARA",
    province: "JAWA TENGAH",
    postal_code: "59466",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59511",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59512",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59513",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59514",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59515",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59516",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59517",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59552",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59554",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59561",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59563",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59565",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59566",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59567",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59571",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59573",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59581",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59582",
  },
  {
    city_short: "DEMAK",
    province: "JAWA TENGAH",
    postal_code: "59583",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60111",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60112",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60113",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60114",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60115",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60116",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60117",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60118",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60119",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60121",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60122",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60123",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60124",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60125",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60126",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60127",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60128",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60129",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60131",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60132",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60133",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60134",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60135",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60136",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60137",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60138",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60141",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60142",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60143",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60144",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60145",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60151",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60152",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60153",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60154",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60155",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60161",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60162",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60163",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60164",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60165",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60171",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60172",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60173",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60174",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60175",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60176",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60177",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60178",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60179",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60182",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60183",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60184",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60185",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60186",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60187",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60188",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60189",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60191",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60192",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60193",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60195",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60196",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60197",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60198",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60199",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60211",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60212",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60213",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60214",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60215",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60216",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60217",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60218",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60219",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60221",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60222",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60223",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60224",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60225",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60226",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60227",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60228",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60229",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60231",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60232",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60233",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60234",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60235",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60236",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60237",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60238",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60239",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60241",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60242",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60243",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60244",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60245",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60246",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60251",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60252",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60253",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60254",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60255",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60256",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60261",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60262",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60263",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60264",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60265",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60271",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60272",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60273",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60274",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60275",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60281",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60282",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60283",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60284",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60285",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60286",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60291",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60292",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60293",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60294",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60295",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60296",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60297",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60298",
  },
  {
    city_short: "SURABAYA",
    province: "JAWA TIMUR",
    postal_code: "60299",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61111",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61112",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61113",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61114",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61115",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61116",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61117",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61118",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61119",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61121",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61122",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61123",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61124",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61151",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61152",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61153",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61154",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61155",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61156",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61162",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61171",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61172",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61173",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61174",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61175",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61176",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61177",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61181",
  },
  {
    city_short: "GRESIK",
    province: "JAWA TIMUR",
    postal_code: "61182",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61212",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61213",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61214",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61215",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61216",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61217",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61218",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61219",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61223",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61224",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61225",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61226",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61228",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61231",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61233",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61234",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61252",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61253",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61254",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61256",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61257",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61258",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61261",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61262",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61263",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61264",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61265",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61271",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61272",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61273",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61274",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61275",
  },
  {
    city_short: "SIDOARJO",
    province: "JAWA TIMUR",
    postal_code: "61276",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61311",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61312",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61313",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61314",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61315",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61316",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61317",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61318",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61319",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61321",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61322",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61323",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61324",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61325",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61326",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61327",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61328",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61351",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61352",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61353",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61354",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61361",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61362",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61363",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61364",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61371",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61372",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61373",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61374",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61375",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61381",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61382",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61383",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61384",
  },
  {
    city_short: "MOJOKERTO",
    province: "JAWA TIMUR",
    postal_code: "61385",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61411",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61412",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61413",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61415",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61416",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61417",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61418",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61419",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61452",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61453",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61454",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61455",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61456",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61457",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61461",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61462",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61463",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61471",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61473",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61474",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61475",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61476",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61481",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61482",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61483",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61484",
  },
  {
    city_short: "JOMBANG",
    province: "JAWA TIMUR",
    postal_code: "61485",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62111",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62112",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62113",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62114",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62115",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62118",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62119",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62152",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62153",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62154",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62155",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62161",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62162",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62164",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62165",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62166",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62167",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62168",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62171",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62172",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62181",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62182",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62183",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62184",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62191",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62192",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62193",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62194",
  },
  {
    city_short: "BOJONEGORO",
    province: "JAWA TIMUR",
    postal_code: "62195",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62211",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62212",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62213",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62214",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62215",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62216",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62217",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62218",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62252",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62253",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62254",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62255",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62256",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62257",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62261",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62262",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62263",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62264",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62265",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62271",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62272",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62273",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62274",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62275",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62276",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62281",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62282",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62283",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62284",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62291",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62292",
  },
  {
    city_short: "LAMONGAN",
    province: "JAWA TIMUR",
    postal_code: "62293",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62311",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62312",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62313",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62314",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62315",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62316",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62317",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62318",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62319",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62352",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62353",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62354",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62355",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62356",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62357",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62361",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62362",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62363",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62364",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62365",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62366",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62371",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62372",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62381",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62382",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62383",
  },
  {
    city_short: "TUBAN",
    province: "JAWA TIMUR",
    postal_code: "62391",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63111",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63112",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63113",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63117",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63118",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63119",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63121",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63122",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63123",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63125",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63126",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63127",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63128",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63129",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63131",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63132",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63133",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63134",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63135",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63136",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63137",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63137",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63138",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63139",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63151",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63152",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63153",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63154",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63155",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63156",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63157",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63161",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63162",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63171",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63172",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63173",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63174",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63181",
  },
  {
    city_short: "MADIUN",
    province: "JAWA TIMUR",
    postal_code: "63182",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63211",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63212",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63214",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63215",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63216",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63217",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63218",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63252",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63253",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63254",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63256",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63257",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63261",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63262",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63263",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63264",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63271",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63281",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63282",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63283",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63284",
  },
  {
    city_short: "NGAWI",
    province: "JAWA TIMUR",
    postal_code: "63285",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63311",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63312",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63313",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63315",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63316",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63317",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63318",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63319",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63351",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63352",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63361",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63362",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63371",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63372",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63382",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63383",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63384",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63391",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63392",
  },
  {
    city_short: "MAGETAN",
    province: "JAWA TIMUR",
    postal_code: "63395",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63411",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63412",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63413",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63414",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63415",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63416",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63417",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63418",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63419",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63451",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63453",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63454",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63455",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63456",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63461",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63462",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63463",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63464",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63471",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63472",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63473",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63474",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63475",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63481",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63482",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63491",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63492",
  },
  {
    city_short: "PONOROGO",
    province: "JAWA TIMUR",
    postal_code: "63493",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63511",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63512",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63513",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63514",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63515",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63516",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63517",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63518",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63552",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63553",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63554",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63561",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63571",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63572",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63573",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63581",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63582",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63583",
  },
  {
    city_short: "PACITAN",
    province: "JAWA TIMUR",
    postal_code: "63584",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64111",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64112",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64113",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64114",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64115",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64116",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64117",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64118",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64119",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64121",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64122",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64123",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64124",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64125",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64126",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64127",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64128",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64129",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64131",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64132",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64133",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64134",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64135",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64136",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64137",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64138",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64139",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64151",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64152",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64153",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64154",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64155",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64156",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64157",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64161",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64162",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64171",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64172",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64173",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64174",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64175",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64176",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64181",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64182",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64183",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64211",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64212",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64213",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64214",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64215",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64216",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64217",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64218",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64219",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64221",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64222",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64223",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64224",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64225",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64226",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64227",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64228",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64229",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64291",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64292",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64293",
  },
  {
    city_short: "KEDIRI",
    province: "JAWA TIMUR",
    postal_code: "64294",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64311",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64312",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64313",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64314",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64315",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64391",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64392",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64393",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64394",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64395",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64411",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64413",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64415",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64416",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64417",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64418",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64419",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64451",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64452",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64453",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64461",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64462",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64471",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64472",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64473",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64474",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64475",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64481",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64482",
  },
  {
    city_short: "NGANJUK",
    province: "JAWA TIMUR",
    postal_code: "64484",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65111",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65112",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65113",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65115",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65116",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65117",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65118",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65119",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65121",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65122",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65123",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65124",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65125",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65126",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65132",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65133",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65134",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65135",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65136",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65137",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65138",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65139",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65141",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65142",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65143",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65144",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65145",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65146",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65147",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65148",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65149",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65151",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65152",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65153",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65154",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65155",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65156",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65157",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65158",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65162",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65163",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65164",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65165",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65166",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65167",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65168",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65171",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65172",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65173",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65174",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65175",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65176",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65178",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65179",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65181",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65182",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65183",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65211",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65213",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65214",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65215",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65216",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65311",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65312",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65313",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65314",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65315",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65316",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65317",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65318",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65321",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65322",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65323",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65324",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65325",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65326",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65327",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65331",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65332",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65333",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65334",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65335",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65336",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65337",
  },
  {
    city_short: "BATU",
    province: "JAWA TIMUR",
    postal_code: "65338",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65391",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65392",
  },
  {
    city_short: "MALANG",
    province: "JAWA TIMUR",
    postal_code: "65393",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66113",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66114",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66115",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66116",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66117",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66121",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66122",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66124",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66125",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66126",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66133",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66134",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66135",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66136",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66137",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66151",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66152",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66153",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66154",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66155",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66161",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66163",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66171",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66172",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66173",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66174",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66181",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66182",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66183",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66184",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66186",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66187",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66191",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66192",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66193",
  },
  {
    city_short: "BLITAR",
    province: "JAWA TIMUR",
    postal_code: "66194",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66212",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66213",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66214",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66215",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66216",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66217",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66218",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66219",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66221",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66222",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66223",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66224",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66225",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66226",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66227",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66228",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66229",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66231",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66232",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66233",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66234",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66235",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66252",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66253",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66254",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66261",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66262",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66263",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66272",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66273",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66274",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66275",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66281",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66283",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66284",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66291",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66292",
  },
  {
    city_short: "TULUNGAGUNG",
    province: "JAWA TIMUR",
    postal_code: "66293",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66311",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66312",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66313",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66314",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66315",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66316",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66317",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66318",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66319",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66351",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66352",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66361",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66362",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66363",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66364",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66365",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66371",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66372",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66373",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66381",
  },
  {
    city_short: "TRENGGALEK",
    province: "JAWA TIMUR",
    postal_code: "66382",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67111",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67112",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67113",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67114",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67115",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67116",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67117",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67118",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67123",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67124",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67125",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67126",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67127",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67128",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67129",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67131",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67132",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67133",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67134",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67135",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67136",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67137",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67138",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67139",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67151",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67152",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67153",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67154",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67155",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67156",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67157",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67161",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67162",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67163",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67165",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67171",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67172",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67173",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67174",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67175",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67176",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67177",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67181",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67182",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67183",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67184",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67185",
  },
  {
    city_short: "PASURUAN",
    province: "JAWA TIMUR",
    postal_code: "67186",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67211",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67212",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67213",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67214",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67215",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67216",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67217",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67218",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67219",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67221",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67222",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67223",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67224",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67225",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67226",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67227",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67228",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67229",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67231",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67232",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67233",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67236",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67237",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67238",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67239",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67251",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67252",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67253",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67254",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67255",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67261",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67262",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67263",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67271",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67272",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67273",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67274",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67275",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67276",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67281",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67282",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67283",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67284",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67287",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67288",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67291",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67292",
  },
  {
    city_short: "PROBOLINGGO",
    province: "JAWA TIMUR",
    postal_code: "67293",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67311",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67312",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67313",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67314",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67315",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67316",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67352",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67353",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67354",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67355",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67356",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67357",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67358",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67359",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67361",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67371",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67372",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67373",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67374",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67375",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67381",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67382",
  },
  {
    city_short: "LUMAJANG",
    province: "JAWA TIMUR",
    postal_code: "67383",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68111",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68112",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68113",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68114",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68116",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68117",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68118",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68121",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68122",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68124",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68125",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68126",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68131",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68132",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68133",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68135",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68136",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68137",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68151",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68152",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68153",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68154",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68155",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68156",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68157",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68161",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68162",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68164",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68165",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68166",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68167",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68168",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68171",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68172",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68173",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68174",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68175",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68181",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68182",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68184",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68191",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68192",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68193",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68194",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68195",
  },
  {
    city_short: "JEMBER",
    province: "JAWA TIMUR",
    postal_code: "68196",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68211",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68212",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68213",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68214",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68215",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68216",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68217",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68218",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68219",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68251",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68252",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68253",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68261",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68262",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68263",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68271",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68272",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68281",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68282",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68283",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68284",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68285",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68286",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68287",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68288",
  },
  {
    city_short: "BONDOWOSO",
    province: "JAWA TIMUR",
    postal_code: "68291",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68311",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68312",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68313",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68314",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68315",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68316",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68321",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68322",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68323",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68351",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68352",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68353",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68354",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68355",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68356",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68357",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68358",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68359",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68362",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68363",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68371",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68372",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68373",
  },
  {
    city_short: "SITUBONDO",
    province: "JAWA TIMUR",
    postal_code: "68374",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68411",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68412",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68413",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68414",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68415",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68416",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68417",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68418",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68419",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68421",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68422",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68423",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68424",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68425",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68431",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68432",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68453",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68454",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68455",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68461",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68462",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68463",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68464",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68465",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68466",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68467",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68468",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68471",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68472",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68482",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68483",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68484",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68485",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68486",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68487",
  },
  {
    city_short: "BANYUWANGI",
    province: "JAWA TIMUR",
    postal_code: "68488",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69112",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69113",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69114",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69115",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69116",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69118",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69119",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69121",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69151",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69152",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69153",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69154",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69155",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69156",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69161",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69162",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69163",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69165",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69166",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69172",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69173",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69174",
  },
  {
    city_short: "BANGKALAN",
    province: "JAWA TIMUR",
    postal_code: "69175",
  },
  {
    city_short: "SAMPANG",
    province: "JAWA TIMUR",
    postal_code: "69212",
  },
  {
    city_short: "SAMPANG",
    province: "JAWA TIMUR",
    postal_code: "69215",
  },
  {
    city_short: "SAMPANG",
    province: "JAWA TIMUR",
    postal_code: "69216",
  },
  {
    city_short: "SAMPANG",
    province: "JAWA TIMUR",
    postal_code: "69252",
  },
  {
    city_short: "SAMPANG",
    province: "JAWA TIMUR",
    postal_code: "69253",
  },
  {
    city_short: "SAMPANG",
    province: "JAWA TIMUR",
    postal_code: "69254",
  },
  {
    city_short: "SAMPANG",
    province: "JAWA TIMUR",
    postal_code: "69261",
  },
  {
    city_short: "SAMPANG",
    province: "JAWA TIMUR",
    postal_code: "69262",
  },
  {
    city_short: "SAMPANG",
    province: "JAWA TIMUR",
    postal_code: "69263",
  },
  {
    city_short: "SAMPANG",
    province: "JAWA TIMUR",
    postal_code: "69271",
  },
  {
    city_short: "SAMPANG",
    province: "JAWA TIMUR",
    postal_code: "69272",
  },
  {
    city_short: "SAMPANG",
    province: "JAWA TIMUR",
    postal_code: "69273",
  },
  {
    city_short: "SAMPANG",
    province: "JAWA TIMUR",
    postal_code: "69281",
  },
  {
    city_short: "SAMPANG",
    province: "JAWA TIMUR",
    postal_code: "69291",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69311",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69312",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69314",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69316",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69317",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69321",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69323",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69352",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69353",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69354",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69355",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69356",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69361",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69362",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69363",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69371",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69382",
  },
  {
    city_short: "PAMEKASAN",
    province: "JAWA TIMUR",
    postal_code: "69383",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69412",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69413",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69414",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69415",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69416",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69417",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69451",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69452",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69453",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69454",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69455",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69456",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69457",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69461",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69462",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69463",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69465",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69466",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69467",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69471",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69472",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69473",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69474",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69481",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69482",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69483",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69484",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69485",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69491",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69492",
  },
  {
    city_short: "SUMENEP",
    province: "JAWA TIMUR",
    postal_code: "69493",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70111",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70112",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70113",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70114",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70115",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70116",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70117",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70118",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70119",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70121",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70122",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70123",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70124",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70125",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70126",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70127",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70128",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70129",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70231",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70233",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70234",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70235",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70236",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70237",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70238",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70239",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70241",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70242",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70243",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70244",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70245",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70246",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70247",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70248",
  },
  {
    city_short: "BANJARMASIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "70249",
  },
  {
    city_short: "BARITO KUALA",
    province: "KALIMANTAN SELATAN",
    postal_code: "70511",
  },
  {
    city_short: "BARITO KUALA",
    province: "KALIMANTAN SELATAN",
    postal_code: "70512",
  },
  {
    city_short: "BARITO KUALA",
    province: "KALIMANTAN SELATAN",
    postal_code: "70513",
  },
  {
    city_short: "BARITO KUALA",
    province: "KALIMANTAN SELATAN",
    postal_code: "70552",
  },
  {
    city_short: "BARITO KUALA",
    province: "KALIMANTAN SELATAN",
    postal_code: "70553",
  },
  {
    city_short: "BARITO KUALA",
    province: "KALIMANTAN SELATAN",
    postal_code: "70561",
  },
  {
    city_short: "BARITO KUALA",
    province: "KALIMANTAN SELATAN",
    postal_code: "70562",
  },
  {
    city_short: "BARITO KUALA",
    province: "KALIMANTAN SELATAN",
    postal_code: "70563",
  },
  {
    city_short: "BARITO KUALA",
    province: "KALIMANTAN SELATAN",
    postal_code: "70564",
  },
  {
    city_short: "BARITO KUALA",
    province: "KALIMANTAN SELATAN",
    postal_code: "70565",
  },
  {
    city_short: "BARITO KUALA",
    province: "KALIMANTAN SELATAN",
    postal_code: "70566",
  },
  {
    city_short: "BARITO KUALA",
    province: "KALIMANTAN SELATAN",
    postal_code: "70567",
  },
  {
    city_short: "BARITO KUALA",
    province: "KALIMANTAN SELATAN",
    postal_code: "70568",
  },
  {
    city_short: "BARITO KUALA",
    province: "KALIMANTAN SELATAN",
    postal_code: "70571",
  },
  {
    city_short: "BARITO KUALA",
    province: "KALIMANTAN SELATAN",
    postal_code: "70581",
  },
  {
    city_short: "BARITO KUALA",
    province: "KALIMANTAN SELATAN",
    postal_code: "70582",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70611",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70612",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70613",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70614",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70615",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70616",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70617",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70618",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70619",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70652",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70653",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70654",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70655",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70661",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70671",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70672",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70673",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70674",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "70675",
  },
  {
    city_short: "BANJARBARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "70713",
  },
  {
    city_short: "BANJARBARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "70714",
  },
  {
    city_short: "BANJARBARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "70721",
  },
  {
    city_short: "BANJARBARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "70722",
  },
  {
    city_short: "BANJARBARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "70723",
  },
  {
    city_short: "BANJARBARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "70724",
  },
  {
    city_short: "BANJARBARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "70731",
  },
  {
    city_short: "BANJARBARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "70732",
  },
  {
    city_short: "BANJARBARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "70733",
  },
  {
    city_short: "BANJARBARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "70734",
  },
  {
    city_short: "TANAH LAUT",
    province: "KALIMANTAN SELATAN",
    postal_code: "70812",
  },
  {
    city_short: "TANAH LAUT",
    province: "KALIMANTAN SELATAN",
    postal_code: "70814",
  },
  {
    city_short: "TANAH LAUT",
    province: "KALIMANTAN SELATAN",
    postal_code: "70815",
  },
  {
    city_short: "TANAH LAUT",
    province: "KALIMANTAN SELATAN",
    postal_code: "70852",
  },
  {
    city_short: "TANAH LAUT",
    province: "KALIMANTAN SELATAN",
    postal_code: "70853",
  },
  {
    city_short: "TANAH LAUT",
    province: "KALIMANTAN SELATAN",
    postal_code: "70854",
  },
  {
    city_short: "TANAH LAUT",
    province: "KALIMANTAN SELATAN",
    postal_code: "70861",
  },
  {
    city_short: "TANAH LAUT",
    province: "KALIMANTAN SELATAN",
    postal_code: "70871",
  },
  {
    city_short: "TANAH LAUT",
    province: "KALIMANTAN SELATAN",
    postal_code: "70881",
  },
  {
    city_short: "TANAH LAUT",
    province: "KALIMANTAN SELATAN",
    postal_code: "70882",
  },
  {
    city_short: "TANAH LAUT",
    province: "KALIMANTAN SELATAN",
    postal_code: "70883",
  },
  {
    city_short: "TAPIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71111",
  },
  {
    city_short: "TAPIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71112",
  },
  {
    city_short: "TAPIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71113",
  },
  {
    city_short: "TAPIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71114",
  },
  {
    city_short: "TAPIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71152",
  },
  {
    city_short: "TAPIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71153",
  },
  {
    city_short: "TAPIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71154",
  },
  {
    city_short: "TAPIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71161",
  },
  {
    city_short: "TAPIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71162",
  },
  {
    city_short: "TAPIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71171",
  },
  {
    city_short: "TAPIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71181",
  },
  {
    city_short: "TAPIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71183",
  },
  {
    city_short: "TAPIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71184",
  },
  {
    city_short: "TAPIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71185",
  },
  {
    city_short: "TAPIN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71191",
  },
  {
    city_short: "HULU SUNGAI SEL",
    province: "KALIMANTAN SELATAN",
    postal_code: "71211",
  },
  {
    city_short: "BANJAR",
    province: "KALIMANTAN SELATAN",
    postal_code: "71213",
  },
  {
    city_short: "HULU SUNGAI SEL",
    province: "KALIMANTAN SELATAN",
    postal_code: "71213",
  },
  {
    city_short: "HULU SUNGAI SEL",
    province: "KALIMANTAN SELATAN",
    postal_code: "71214",
  },
  {
    city_short: "HULU SUNGAI SEL",
    province: "KALIMANTAN SELATAN",
    postal_code: "71215",
  },
  {
    city_short: "HULU SUNGAI SEL",
    province: "KALIMANTAN SELATAN",
    postal_code: "71216",
  },
  {
    city_short: "HULU SUNGAI SEL",
    province: "KALIMANTAN SELATAN",
    postal_code: "71217",
  },
  {
    city_short: "HULU SUNGAI SEL",
    province: "KALIMANTAN SELATAN",
    postal_code: "71252",
  },
  {
    city_short: "HULU SUNGAI SEL",
    province: "KALIMANTAN SELATAN",
    postal_code: "71253",
  },
  {
    city_short: "HULU SUNGAI SEL",
    province: "KALIMANTAN SELATAN",
    postal_code: "71261",
  },
  {
    city_short: "HULU SUNGAI SEL",
    province: "KALIMANTAN SELATAN",
    postal_code: "71262",
  },
  {
    city_short: "HULU SUNGAI SEL",
    province: "KALIMANTAN SELATAN",
    postal_code: "71271",
  },
  {
    city_short: "HULU SUNGAI SEL",
    province: "KALIMANTAN SELATAN",
    postal_code: "71281",
  },
  {
    city_short: "HULU SUNGAI SEL",
    province: "KALIMANTAN SELATAN",
    postal_code: "71282",
  },
  {
    city_short: "HULU SUNGAI SEL",
    province: "KALIMANTAN SELATAN",
    postal_code: "71291",
  },
  {
    city_short: "HULU SUNGAI SEL",
    province: "KALIMANTAN SELATAN",
    postal_code: "71292",
  },
  {
    city_short: "HULU SUNGAI TEN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71311",
  },
  {
    city_short: "HULU SUNGAI TEN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71312",
  },
  {
    city_short: "HULU SUNGAI TEN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71313",
  },
  {
    city_short: "HULU SUNGAI TEN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71314",
  },
  {
    city_short: "HULU SUNGAI TEN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71315",
  },
  {
    city_short: "HULU SUNGAI TEN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71352",
  },
  {
    city_short: "HULU SUNGAI TEN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71361",
  },
  {
    city_short: "HULU SUNGAI TEN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71362",
  },
  {
    city_short: "HULU SUNGAI TEN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71363",
  },
  {
    city_short: "HULU SUNGAI TEN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71371",
  },
  {
    city_short: "HULU SUNGAI TEN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71372",
  },
  {
    city_short: "HULU SUNGAI TEN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71381",
  },
  {
    city_short: "HULU SUNGAI TEN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71382",
  },
  {
    city_short: "HULU SUNGAI TEN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71391",
  },
  {
    city_short: "HULU SUNGAI UTA",
    province: "KALIMANTAN SELATAN",
    postal_code: "71412",
  },
  {
    city_short: "HULU SUNGAI UTA",
    province: "KALIMANTAN SELATAN",
    postal_code: "71413",
  },
  {
    city_short: "HULU SUNGAI UTA",
    province: "KALIMANTAN SELATAN",
    postal_code: "71414",
  },
  {
    city_short: "HULU SUNGAI UTA",
    province: "KALIMANTAN SELATAN",
    postal_code: "71416",
  },
  {
    city_short: "HULU SUNGAI UTA",
    province: "KALIMANTAN SELATAN",
    postal_code: "71417",
  },
  {
    city_short: "HULU SUNGAI UTA",
    province: "KALIMANTAN SELATAN",
    postal_code: "71418",
  },
  {
    city_short: "HULU SUNGAI UTA",
    province: "KALIMANTAN SELATAN",
    postal_code: "71419",
  },
  {
    city_short: "HULU SUNGAI UTA",
    province: "KALIMANTAN SELATAN",
    postal_code: "71452",
  },
  {
    city_short: "HULU SUNGAI UTA",
    province: "KALIMANTAN SELATAN",
    postal_code: "71453",
  },
  {
    city_short: "HULU SUNGAI UTA",
    province: "KALIMANTAN SELATAN",
    postal_code: "71454",
  },
  {
    city_short: "HULU SUNGAI UTA",
    province: "KALIMANTAN SELATAN",
    postal_code: "71455",
  },
  {
    city_short: "HULU SUNGAI UTA",
    province: "KALIMANTAN SELATAN",
    postal_code: "71471",
  },
  {
    city_short: "TABALONG",
    province: "KALIMANTAN SELATAN",
    postal_code: "71512",
  },
  {
    city_short: "TABALONG",
    province: "KALIMANTAN SELATAN",
    postal_code: "71513",
  },
  {
    city_short: "TABALONG",
    province: "KALIMANTAN SELATAN",
    postal_code: "71514",
  },
  {
    city_short: "TABALONG",
    province: "KALIMANTAN SELATAN",
    postal_code: "71515",
  },
  {
    city_short: "TABALONG",
    province: "KALIMANTAN SELATAN",
    postal_code: "71552",
  },
  {
    city_short: "TABALONG",
    province: "KALIMANTAN SELATAN",
    postal_code: "71553",
  },
  {
    city_short: "TABALONG",
    province: "KALIMANTAN SELATAN",
    postal_code: "71554",
  },
  {
    city_short: "TABALONG",
    province: "KALIMANTAN SELATAN",
    postal_code: "71555",
  },
  {
    city_short: "TABALONG",
    province: "KALIMANTAN SELATAN",
    postal_code: "71561",
  },
  {
    city_short: "TABALONG",
    province: "KALIMANTAN SELATAN",
    postal_code: "71571",
  },
  {
    city_short: "TABALONG",
    province: "KALIMANTAN SELATAN",
    postal_code: "71572",
  },
  {
    city_short: "TABALONG",
    province: "KALIMANTAN SELATAN",
    postal_code: "71573",
  },
  {
    city_short: "TABALONG",
    province: "KALIMANTAN SELATAN",
    postal_code: "71574",
  },
  {
    city_short: "TABALONG",
    province: "KALIMANTAN SELATAN",
    postal_code: "71575",
  },
  {
    city_short: "BALANGAN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71614",
  },
  {
    city_short: "BALANGAN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71616",
  },
  {
    city_short: "BALANGAN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71617",
  },
  {
    city_short: "BALANGAN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71618",
  },
  {
    city_short: "BALANGAN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71661",
  },
  {
    city_short: "BALANGAN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71662",
  },
  {
    city_short: "BALANGAN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71663",
  },
  {
    city_short: "BALANGAN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71664",
  },
  {
    city_short: "BALANGAN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71665",
  },
  {
    city_short: "BALANGAN",
    province: "KALIMANTAN SELATAN",
    postal_code: "71666",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72111",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72112",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72113",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72114",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72115",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72116",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72117",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72152",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72153",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72154",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72155",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72156",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72161",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72162",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72163",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72164",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72165",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72166",
  },
  {
    city_short: "TABALONG",
    province: "KALIMANTAN SELATAN",
    postal_code: "72167",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72167",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72168",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72169",
  },
  {
    city_short: "KOTABARU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72181",
  },
  {
    city_short: "TANAH BUMBU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72211",
  },
  {
    city_short: "TANAH BUMBU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72212",
  },
  {
    city_short: "TANAH BUMBU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72213",
  },
  {
    city_short: "TANAH BUMBU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72214",
  },
  {
    city_short: "TANAH BUMBU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72215",
  },
  {
    city_short: "TANAH BUMBU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72216",
  },
  {
    city_short: "TANAH BUMBU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72217",
  },
  {
    city_short: "TANAH BUMBU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72218",
  },
  {
    city_short: "TANAH BUMBU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72271",
  },
  {
    city_short: "TANAH BUMBU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72272",
  },
  {
    city_short: "TANAH BUMBU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72273",
  },
  {
    city_short: "TANAH BUMBU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72274",
  },
  {
    city_short: "TANAH BUMBU",
    province: "KALIMANTAN SELATAN",
    postal_code: "72275",
  },
  {
    city_short: "PALANGKA RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73111",
  },
  {
    city_short: "PALANGKA RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73112",
  },
  {
    city_short: "PALANGKA RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73113",
  },
  {
    city_short: "PALANGKA RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73114",
  },
  {
    city_short: "PALANGKA RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73118",
  },
  {
    city_short: "PALANGKA RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73221",
  },
  {
    city_short: "PALANGKA RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73222",
  },
  {
    city_short: "PALANGKA RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73223",
  },
  {
    city_short: "PALANGKA RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73224",
  },
  {
    city_short: "PALANGKA RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73225",
  },
  {
    city_short: "PALANGKA RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73226",
  },
  {
    city_short: "PALANGKA RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73227",
  },
  {
    city_short: "PALANGKA RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73228",
  },
  {
    city_short: "PALANGKA RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73229",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73511",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73512",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73513",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73514",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73515",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73516",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73521",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73522",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73523",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73524",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73525",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73552",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73553",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73554",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73555",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73564",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73581",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73583",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73592",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "73593",
  },
  {
    city_short: "BARITO TIMUR",
    province: "KALIMANTAN TENGAH",
    postal_code: "73612",
  },
  {
    city_short: "BARITO TIMUR",
    province: "KALIMANTAN TENGAH",
    postal_code: "73613",
  },
  {
    city_short: "BARITO TIMUR",
    province: "KALIMANTAN TENGAH",
    postal_code: "73614",
  },
  {
    city_short: "BARITO TIMUR",
    province: "KALIMANTAN TENGAH",
    postal_code: "73615",
  },
  {
    city_short: "BARITO TIMUR",
    province: "KALIMANTAN TENGAH",
    postal_code: "73617",
  },
  {
    city_short: "BARITO TIMUR",
    province: "KALIMANTAN TENGAH",
    postal_code: "73618",
  },
  {
    city_short: "BARITO TIMUR",
    province: "KALIMANTAN TENGAH",
    postal_code: "73652",
  },
  {
    city_short: "BARITO TIMUR",
    province: "KALIMANTAN TENGAH",
    postal_code: "73653",
  },
  {
    city_short: "BARITO TIMUR",
    province: "KALIMANTAN TENGAH",
    postal_code: "73661",
  },
  {
    city_short: "BARITO TIMUR",
    province: "KALIMANTAN TENGAH",
    postal_code: "73671",
  },
  {
    city_short: "BARITO TIMUR",
    province: "KALIMANTAN TENGAH",
    postal_code: "73681",
  },
  {
    city_short: "BARITO SELATAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "73711",
  },
  {
    city_short: "BARITO SELATAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "73712",
  },
  {
    city_short: "BARITO SELATAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "73713",
  },
  {
    city_short: "BARITO SELATAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "73751",
  },
  {
    city_short: "BARITO SELATAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "73752",
  },
  {
    city_short: "BARITO SELATAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "73753",
  },
  {
    city_short: "BARITO SELATAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "73761",
  },
  {
    city_short: "BARITO SELATAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "73762",
  },
  {
    city_short: "BARITO SELATAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "73763",
  },
  {
    city_short: "BARITO UTARA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73811",
  },
  {
    city_short: "BARITO UTARA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73812",
  },
  {
    city_short: "BARITO UTARA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73813",
  },
  {
    city_short: "BARITO UTARA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73814",
  },
  {
    city_short: "BARITO UTARA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73852",
  },
  {
    city_short: "BARITO UTARA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73861",
  },
  {
    city_short: "BARITO UTARA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73862",
  },
  {
    city_short: "BARITO UTARA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73871",
  },
  {
    city_short: "BARITO UTARA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73881",
  },
  {
    city_short: "MURUNG RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73911",
  },
  {
    city_short: "MURUNG RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73961",
  },
  {
    city_short: "MURUNG RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73971",
  },
  {
    city_short: "MURUNG RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73981",
  },
  {
    city_short: "MURUNG RAYA",
    province: "KALIMANTAN TENGAH",
    postal_code: "73991",
  },
  {
    city_short: "KOTAWARINGIN BA",
    province: "KALIMANTAN TENGAH",
    postal_code: "74111",
  },
  {
    city_short: "KOTAWARINGIN BA",
    province: "KALIMANTAN TENGAH",
    postal_code: "74112",
  },
  {
    city_short: "KOTAWARINGIN BA",
    province: "KALIMANTAN TENGAH",
    postal_code: "74113",
  },
  {
    city_short: "KOTAWARINGIN BA",
    province: "KALIMANTAN TENGAH",
    postal_code: "74114",
  },
  {
    city_short: "KOTAWARINGIN BA",
    province: "KALIMANTAN TENGAH",
    postal_code: "74115",
  },
  {
    city_short: "KOTAWARINGIN BA",
    province: "KALIMANTAN TENGAH",
    postal_code: "74116",
  },
  {
    city_short: "KOTAWARINGIN BA",
    province: "KALIMANTAN TENGAH",
    postal_code: "74117",
  },
  {
    city_short: "KOTAWARINGIN BA",
    province: "KALIMANTAN TENGAH",
    postal_code: "74152",
  },
  {
    city_short: "KOTAWARINGIN BA",
    province: "KALIMANTAN TENGAH",
    postal_code: "74161",
  },
  {
    city_short: "LAMANDAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74162",
  },
  {
    city_short: "SUKAMARA",
    province: "KALIMANTAN TENGAH",
    postal_code: "74171",
  },
  {
    city_short: "SUKAMARA",
    province: "KALIMANTAN TENGAH",
    postal_code: "74172",
  },
  {
    city_short: "SUKAMARA",
    province: "KALIMANTAN TENGAH",
    postal_code: "74173",
  },
  {
    city_short: "KOTAWARINGIN BA",
    province: "KALIMANTAN TENGAH",
    postal_code: "74181",
  },
  {
    city_short: "KOTAWARINGIN BA",
    province: "KALIMANTAN TENGAH",
    postal_code: "74183",
  },
  {
    city_short: "KOTAWARINGIN BA",
    province: "KALIMANTAN TENGAH",
    postal_code: "74184",
  },
  {
    city_short: "SERUYAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "74213",
  },
  {
    city_short: "SERUYAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "74214",
  },
  {
    city_short: "SERUYAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "74215",
  },
  {
    city_short: "SERUYAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "74261",
  },
  {
    city_short: "SERUYAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "74271",
  },
  {
    city_short: "SERUYAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "74281",
  },
  {
    city_short: "SERUYAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "74291",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74311",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74312",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74313",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74314",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74315",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74316",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74321",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74322",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74323",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74324",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74325",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74326",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74352",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74353",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74354",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74355",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74356",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74361",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74362",
  },
  {
    city_short: "KOTAWARINGIN TI",
    province: "KALIMANTAN TENGAH",
    postal_code: "74363",
  },
  {
    city_short: "KATINGAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "74413",
  },
  {
    city_short: "KATINGAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "74452",
  },
  {
    city_short: "KATINGAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "74453",
  },
  {
    city_short: "KATINGAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "74454",
  },
  {
    city_short: "KATINGAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "74455",
  },
  {
    city_short: "KATINGAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "74456",
  },
  {
    city_short: "KATINGAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "74457",
  },
  {
    city_short: "KATINGAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "74461",
  },
  {
    city_short: "KATINGAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "74462",
  },
  {
    city_short: "KATINGAN",
    province: "KALIMANTAN TENGAH",
    postal_code: "74463",
  },
  {
    city_short: "GUNUNG MAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "74511",
  },
  {
    city_short: "GUNUNG MAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "74552",
  },
  {
    city_short: "GUNUNG MAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "74553",
  },
  {
    city_short: "GUNUNG MAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "74561",
  },
  {
    city_short: "GUNUNG MAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "74562",
  },
  {
    city_short: "GUNUNG MAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "74571",
  },
  {
    city_short: "KAPUAS",
    province: "KALIMANTAN TENGAH",
    postal_code: "74581",
  },
  {
    city_short: "LAMANDAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74611",
  },
  {
    city_short: "LAMANDAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74612",
  },
  {
    city_short: "LAMANDAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74663",
  },
  {
    city_short: "LAMANDAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74664",
  },
  {
    city_short: "PULANG PISAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74812",
  },
  {
    city_short: "PULANG PISAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74813",
  },
  {
    city_short: "PULANG PISAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74816",
  },
  {
    city_short: "PULANG PISAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74821",
  },
  {
    city_short: "PULANG PISAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74831",
  },
  {
    city_short: "PULANG PISAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74841",
  },
  {
    city_short: "PULANG PISAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74861",
  },
  {
    city_short: "PULANG PISAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74862",
  },
  {
    city_short: "PULANG PISAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74863",
  },
  {
    city_short: "PULANG PISAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74871",
  },
  {
    city_short: "PULANG PISAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74872",
  },
  {
    city_short: "PULANG PISAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74873",
  },
  {
    city_short: "PULANG PISAU",
    province: "KALIMANTAN TENGAH",
    postal_code: "74874",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75111",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75112",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75113",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75114",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75115",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75116",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75117",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75118",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75119",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75121",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75122",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75123",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75124",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75125",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75126",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75127",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75128",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75131",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75133",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75241",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75242",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75243",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75251",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "75253",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75254",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75256",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75261",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75262",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75263",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75264",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75265",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75266",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75267",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75271",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75273",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75274",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75276",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75277",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75279",
  },
  {
    city_short: "BONTANG",
    province: "KALIMANTAN TIMUR",
    postal_code: "75311",
  },
  {
    city_short: "BONTANG",
    province: "KALIMANTAN TIMUR",
    postal_code: "75312",
  },
  {
    city_short: "BONTANG",
    province: "KALIMANTAN TIMUR",
    postal_code: "75313",
  },
  {
    city_short: "BONTANG",
    province: "KALIMANTAN TIMUR",
    postal_code: "75314",
  },
  {
    city_short: "BONTANG",
    province: "KALIMANTAN TIMUR",
    postal_code: "75321",
  },
  {
    city_short: "BONTANG",
    province: "KALIMANTAN TIMUR",
    postal_code: "75324",
  },
  {
    city_short: "BONTANG",
    province: "KALIMANTAN TIMUR",
    postal_code: "75325",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75381",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75382",
  },
  {
    city_short: "BONTANG",
    province: "KALIMANTAN TIMUR",
    postal_code: "75383",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75385",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75391",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75511",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75512",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75513",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75514",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75515",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75517",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75552",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75553",
  },
  {
    city_short: "KUTAI TIMUR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75555",
  },
  {
    city_short: "KUTAI TIMUR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75556",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75557",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75558",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75559",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75561",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75562",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75564",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75571",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75572",
  },
  {
    city_short: "KUTAI BARAT",
    province: "KALIMANTAN TIMUR",
    postal_code: "75576",
  },
  {
    city_short: "KUTAI TIMUR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75618",
  },
  {
    city_short: "KUTAI TIMUR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75619",
  },
  {
    city_short: "KUTAI TIMUR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75654",
  },
  {
    city_short: "KUTAI TIMUR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75655",
  },
  {
    city_short: "KUTAI TIMUR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75656",
  },
  {
    city_short: "KUTAI TIMUR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75683",
  },
  {
    city_short: "KUTAI TIMUR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75684",
  },
  {
    city_short: "KUTAI TIMUR",
    province: "KALIMANTAN TIMUR",
    postal_code: "75685",
  },
  {
    city_short: "KUTAI BARAT",
    province: "KALIMANTAN TIMUR",
    postal_code: "75763",
  },
  {
    city_short: "KUTAI BARAT",
    province: "KALIMANTAN TIMUR",
    postal_code: "75765",
  },
  {
    city_short: "KUTAI BARAT",
    province: "KALIMANTAN TIMUR",
    postal_code: "75766",
  },
  {
    city_short: "KUTAI BARAT",
    province: "KALIMANTAN TIMUR",
    postal_code: "75767",
  },
  {
    city_short: "KUTAI BARAT",
    province: "KALIMANTAN TIMUR",
    postal_code: "75768",
  },
  {
    city_short: "KUTAI BARAT",
    province: "KALIMANTAN TIMUR",
    postal_code: "75769",
  },
  {
    city_short: "KUTAI BARAT",
    province: "KALIMANTAN TIMUR",
    postal_code: "75772",
  },
  {
    city_short: "KUTAI BARAT",
    province: "KALIMANTAN TIMUR",
    postal_code: "75773",
  },
  {
    city_short: "KUTAI BARAT",
    province: "KALIMANTAN TIMUR",
    postal_code: "75774",
  },
  {
    city_short: "KUTAI BARAT",
    province: "KALIMANTAN TIMUR",
    postal_code: "75775",
  },
  {
    city_short: "KUTAI BARAT",
    province: "KALIMANTAN TIMUR",
    postal_code: "75776",
  },
  {
    city_short: "KUTAI BARAT",
    province: "KALIMANTAN TIMUR",
    postal_code: "75777",
  },
  {
    city_short: "KUTAI BARAT",
    province: "KALIMANTAN TIMUR",
    postal_code: "75778",
  },
  {
    city_short: "KUTAI BARAT",
    province: "KALIMANTAN TIMUR",
    postal_code: "75779",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76111",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76112",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76113",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76114",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76115",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76116",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76117",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76118",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76121",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76122",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76123",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76124",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76125",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76127",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76128",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76129",
  },
  {
    city_short: "KUKAR",
    province: "KALIMANTAN TIMUR",
    postal_code: "76131",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76131",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76132",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76133",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76134",
  },
  {
    city_short: "BALIKPAPAN",
    province: "KALIMANTAN TIMUR",
    postal_code: "76136",
  },
  {
    city_short: "PENAJAM PASER U",
    province: "KALIMANTAN TIMUR",
    postal_code: "76141",
  },
  {
    city_short: "PENAJAM PASER U",
    province: "KALIMANTAN TIMUR",
    postal_code: "76142",
  },
  {
    city_short: "PENAJAM PASER U",
    province: "KALIMANTAN TIMUR",
    postal_code: "76143",
  },
  {
    city_short: "PENAJAM PASER U",
    province: "KALIMANTAN TIMUR",
    postal_code: "76144",
  },
  {
    city_short: "PENAJAM PASER U",
    province: "KALIMANTAN TIMUR",
    postal_code: "76145",
  },
  {
    city_short: "PENAJAM PASER U",
    province: "KALIMANTAN TIMUR",
    postal_code: "76146",
  },
  {
    city_short: "PENAJAM PASER U",
    province: "KALIMANTAN TIMUR",
    postal_code: "76147",
  },
  {
    city_short: "PENAJAM PASER U",
    province: "KALIMANTAN TIMUR",
    postal_code: "76148",
  },
  {
    city_short: "PENAJAM PASER U",
    province: "KALIMANTAN TIMUR",
    postal_code: "76149",
  },
  {
    city_short: "PASER",
    province: "KALIMANTAN TIMUR",
    postal_code: "76251",
  },
  {
    city_short: "PASER",
    province: "KALIMANTAN TIMUR",
    postal_code: "76252",
  },
  {
    city_short: "PASER",
    province: "KALIMANTAN TIMUR",
    postal_code: "76253",
  },
  {
    city_short: "PASER",
    province: "KALIMANTAN TIMUR",
    postal_code: "76261",
  },
  {
    city_short: "PASER",
    province: "KALIMANTAN TIMUR",
    postal_code: "76271",
  },
  {
    city_short: "PASER",
    province: "KALIMANTAN TIMUR",
    postal_code: "76281",
  },
  {
    city_short: "PASER",
    province: "KALIMANTAN TIMUR",
    postal_code: "76282",
  },
  {
    city_short: "PASER",
    province: "KALIMANTAN TIMUR",
    postal_code: "76283",
  },
  {
    city_short: "PENAJAM PASER U",
    province: "KALIMANTAN TIMUR",
    postal_code: "76284",
  },
  {
    city_short: "PENAJAM PASER U",
    province: "KALIMANTAN TIMUR",
    postal_code: "76285",
  },
  {
    city_short: "SAMARINDA",
    province: "KALIMANTAN TIMUR",
    postal_code: "77111",
  },
  {
    city_short: "TARAKAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77111",
  },
  {
    city_short: "TARAKAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77112",
  },
  {
    city_short: "TARAKAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77113",
  },
  {
    city_short: "TARAKAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77114",
  },
  {
    city_short: "TARAKAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77115",
  },
  {
    city_short: "TARAKAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77116",
  },
  {
    city_short: "TARAKAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77123",
  },
  {
    city_short: "TARAKAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77124",
  },
  {
    city_short: "TARAKAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77125",
  },
  {
    city_short: "TARAKAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77126",
  },
  {
    city_short: "TANA TIDUNG",
    province: "KALIMANTAN UTARA",
    postal_code: "77152",
  },
  {
    city_short: "MALINAU",
    province: "KALIMANTAN UTARA",
    postal_code: "77155",
  },
  {
    city_short: "BULUNGAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77211",
  },
  {
    city_short: "BULUNGAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77212",
  },
  {
    city_short: "BULUNGAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77214",
  },
  {
    city_short: "BULUNGAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77215",
  },
  {
    city_short: "BULUNGAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77216",
  },
  {
    city_short: "BULUNGAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77217",
  },
  {
    city_short: "BULUNGAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77261",
  },
  {
    city_short: "BULUNGAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77263",
  },
  {
    city_short: "BULUNGAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77281",
  },
  {
    city_short: "BERAU",
    province: "KALIMANTAN TIMUR",
    postal_code: "77311",
  },
  {
    city_short: "BERAU",
    province: "KALIMANTAN TIMUR",
    postal_code: "77312",
  },
  {
    city_short: "BERAU",
    province: "KALIMANTAN TIMUR",
    postal_code: "77313",
  },
  {
    city_short: "BERAU",
    province: "KALIMANTAN TIMUR",
    postal_code: "77315",
  },
  {
    city_short: "BERAU",
    province: "KALIMANTAN TIMUR",
    postal_code: "77352",
  },
  {
    city_short: "BERAU",
    province: "KALIMANTAN TIMUR",
    postal_code: "77361",
  },
  {
    city_short: "BERAU",
    province: "KALIMANTAN TIMUR",
    postal_code: "77362",
  },
  {
    city_short: "BERAU",
    province: "KALIMANTAN TIMUR",
    postal_code: "77371",
  },
  {
    city_short: "BERAU",
    province: "KALIMANTAN TIMUR",
    postal_code: "77372",
  },
  {
    city_short: "BERAU",
    province: "KALIMANTAN TIMUR",
    postal_code: "77373",
  },
  {
    city_short: "BERAU",
    province: "KALIMANTAN TIMUR",
    postal_code: "77381",
  },
  {
    city_short: "TANA TIDUNG",
    province: "KALIMANTAN UTARA",
    postal_code: "77453",
  },
  {
    city_short: "NUNUKAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77453",
  },
  {
    city_short: "NUNUKAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77456",
  },
  {
    city_short: "NUNUKAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77457",
  },
  {
    city_short: "NUNUKAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77482",
  },
  {
    city_short: "NUNUKAN",
    province: "KALIMANTAN UTARA",
    postal_code: "77483",
  },
  {
    city_short: "MALINAU",
    province: "KALIMANTAN UTARA",
    postal_code: "77554",
  },
  {
    city_short: "MALINAU",
    province: "KALIMANTAN UTARA",
    postal_code: "77555",
  },
  {
    city_short: "MALINAU",
    province: "KALIMANTAN UTARA",
    postal_code: "77562",
  },
  {
    city_short: "MALINAU",
    province: "KALIMANTAN UTARA",
    postal_code: "77571",
  },
  {
    city_short: "MALINAU",
    province: "KALIMANTAN UTARA",
    postal_code: "77572",
  },
  {
    city_short: "MALINAU",
    province: "KALIMANTAN UTARA",
    postal_code: "77573",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78111",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78112",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78113",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78114",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78115",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78116",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78117",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78121",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78122",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78123",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78124",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78132",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78137",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78231",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78233",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78234",
  },
  {
    city_short: "KUBU RAYA",
    province: "KALIMANTAN BARAT",
    postal_code: "78234",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78235",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78236",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78241",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78242",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78243",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78244",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78351",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78353",
  },
  {
    city_short: "KUBU RAYA",
    province: "KALIMANTAN BARAT",
    postal_code: "78355",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78361",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78371",
  },
  {
    city_short: "KUBU RAYA",
    province: "KALIMANTAN BARAT",
    postal_code: "78381",
  },
  {
    city_short: "KUBU RAYA",
    province: "KALIMANTAN BARAT",
    postal_code: "78382",
  },
  {
    city_short: "KUBU RAYA",
    province: "KALIMANTAN BARAT",
    postal_code: "78383",
  },
  {
    city_short: "KUBU RAYA",
    province: "KALIMANTAN BARAT",
    postal_code: "78384",
  },
  {
    city_short: "KUBU RAYA",
    province: "KALIMANTAN BARAT",
    postal_code: "78385",
  },
  {
    city_short: "KUBU RAYA",
    province: "KALIMANTAN BARAT",
    postal_code: "78391",
  },
  {
    city_short: "KUBU RAYA",
    province: "KALIMANTAN BARAT",
    postal_code: "78392",
  },
  {
    city_short: "KUBU RAYA",
    province: "KALIMANTAN BARAT",
    postal_code: "78393",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78511",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78512",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78513",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78514",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78515",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78516",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78552",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78553",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78554",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78555",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78556",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78557",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78561",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78562",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78563",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78564",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78571",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78572",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78581",
  },
  {
    city_short: "SANGGAU",
    province: "KALIMANTAN BARAT",
    postal_code: "78591",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78611",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78612",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78613",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78614",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78615",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78616",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78617",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78618",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78619",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78652",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78653",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78654",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78655",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78656",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78661",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78662",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78663",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78683",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78684",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78691",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78693",
  },
  {
    city_short: "SINTANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78694",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78714",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78715",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78716",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78752",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78753",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78754",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78755",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78756",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78757",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78758",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78759",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78761",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78762",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78763",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78764",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78765",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78766",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78767",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78768",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78769",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78771",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78772",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78773",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78774",
  },
  {
    city_short: "KAPUAS HULU",
    province: "KALIMANTAN BARAT",
    postal_code: "78775",
  },
  {
    city_short: "KETAPANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78811",
  },
  {
    city_short: "KETAPANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78812",
  },
  {
    city_short: "KETAPANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78813",
  },
  {
    city_short: "KETAPANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78821",
  },
  {
    city_short: "KETAPANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78822",
  },
  {
    city_short: "KAYONG UTARA",
    province: "KALIMANTAN BARAT",
    postal_code: "78852",
  },
  {
    city_short: "KAYONG UTARA",
    province: "KALIMANTAN BARAT",
    postal_code: "78853",
  },
  {
    city_short: "KETAPANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78854",
  },
  {
    city_short: "KAYONG UTARA",
    province: "KALIMANTAN BARAT",
    postal_code: "78855",
  },
  {
    city_short: "KAYONG UTARA",
    province: "KALIMANTAN BARAT",
    postal_code: "78856",
  },
  {
    city_short: "KAYONG UTARA",
    province: "KALIMANTAN BARAT",
    postal_code: "78857",
  },
  {
    city_short: "KETAPANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78862",
  },
  {
    city_short: "KETAPANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78863",
  },
  {
    city_short: "KETAPANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78864",
  },
  {
    city_short: "KETAPANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78871",
  },
  {
    city_short: "KETAPANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78872",
  },
  {
    city_short: "KETAPANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78873",
  },
  {
    city_short: "KETAPANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78874",
  },
  {
    city_short: "KETAPANG",
    province: "KALIMANTAN BARAT",
    postal_code: "78876",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78911",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78912",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78913",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78914",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78915",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78916",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78917",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78918",
  },
  {
    city_short: "PONTIANAK",
    province: "KALIMANTAN BARAT",
    postal_code: "78919",
  },
  {
    city_short: "SINGKAWANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79111",
  },
  {
    city_short: "SINGKAWANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79112",
  },
  {
    city_short: "SINGKAWANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79113",
  },
  {
    city_short: "SINGKAWANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79114",
  },
  {
    city_short: "SINGKAWANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79115",
  },
  {
    city_short: "SINGKAWANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79116",
  },
  {
    city_short: "SINGKAWANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79121",
  },
  {
    city_short: "SINGKAWANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79122",
  },
  {
    city_short: "SINGKAWANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79123",
  },
  {
    city_short: "SINGKAWANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79124",
  },
  {
    city_short: "SINGKAWANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79151",
  },
  {
    city_short: "SAMBAS",
    province: "KALIMANTAN BARAT",
    postal_code: "79154",
  },
  {
    city_short: "SINGKAWANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79163",
  },
  {
    city_short: "BENGKAYANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79181",
  },
  {
    city_short: "BENGKAYANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79211",
  },
  {
    city_short: "BENGKAYANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79212",
  },
  {
    city_short: "BENGKAYANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79213",
  },
  {
    city_short: "BENGKAYANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79214",
  },
  {
    city_short: "SINGKAWANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79251",
  },
  {
    city_short: "BENGKAYANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79251",
  },
  {
    city_short: "BENGKAYANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79271",
  },
  {
    city_short: "BENGKAYANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79281",
  },
  {
    city_short: "BENGKAYANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79283",
  },
  {
    city_short: "BENGKAYANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79284",
  },
  {
    city_short: "BENGKAYANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79285",
  },
  {
    city_short: "BENGKAYANG",
    province: "KALIMANTAN BARAT",
    postal_code: "79286",
  },
  {
    city_short: "LANDAK",
    province: "KALIMANTAN BARAT",
    postal_code: "79355",
  },
  {
    city_short: "LANDAK",
    province: "KALIMANTAN BARAT",
    postal_code: "79356",
  },
  {
    city_short: "LANDAK",
    province: "KALIMANTAN BARAT",
    postal_code: "79357",
  },
  {
    city_short: "LANDAK",
    province: "KALIMANTAN BARAT",
    postal_code: "79358",
  },
  {
    city_short: "LANDAK",
    province: "KALIMANTAN BARAT",
    postal_code: "79362",
  },
  {
    city_short: "LANDAK",
    province: "KALIMANTAN BARAT",
    postal_code: "79363",
  },
  {
    city_short: "LANDAK",
    province: "KALIMANTAN BARAT",
    postal_code: "79364",
  },
  {
    city_short: "LANDAK",
    province: "KALIMANTAN BARAT",
    postal_code: "79365",
  },
  {
    city_short: "LANDAK",
    province: "KALIMANTAN BARAT",
    postal_code: "79366",
  },
  {
    city_short: "LANDAK",
    province: "KALIMANTAN BARAT",
    postal_code: "79367",
  },
  {
    city_short: "SAMBAS",
    province: "KALIMANTAN BARAT",
    postal_code: "79417",
  },
  {
    city_short: "SAMBAS",
    province: "KALIMANTAN BARAT",
    postal_code: "79452",
  },
  {
    city_short: "SAMBAS",
    province: "KALIMANTAN BARAT",
    postal_code: "79453",
  },
  {
    city_short: "SAMBAS",
    province: "KALIMANTAN BARAT",
    postal_code: "79454",
  },
  {
    city_short: "SAMBAS",
    province: "KALIMANTAN BARAT",
    postal_code: "79461",
  },
  {
    city_short: "SAMBAS",
    province: "KALIMANTAN BARAT",
    postal_code: "79462",
  },
  {
    city_short: "SAMBAS",
    province: "KALIMANTAN BARAT",
    postal_code: "79463",
  },
  {
    city_short: "SAMBAS",
    province: "KALIMANTAN BARAT",
    postal_code: "79465",
  },
  {
    city_short: "SAMBAS",
    province: "KALIMANTAN BARAT",
    postal_code: "79466",
  },
  {
    city_short: "SAMBAS",
    province: "KALIMANTAN BARAT",
    postal_code: "79467",
  },
  {
    city_short: "SEKADAU",
    province: "KALIMANTAN BARAT",
    postal_code: "79511",
  },
  {
    city_short: "SEKADAU",
    province: "KALIMANTAN BARAT",
    postal_code: "79512",
  },
  {
    city_short: "SEKADAU",
    province: "KALIMANTAN BARAT",
    postal_code: "79513",
  },
  {
    city_short: "SEKADAU",
    province: "KALIMANTAN BARAT",
    postal_code: "79514",
  },
  {
    city_short: "SEKADAU",
    province: "KALIMANTAN BARAT",
    postal_code: "79515",
  },
  {
    city_short: "SEKADAU",
    province: "KALIMANTAN BARAT",
    postal_code: "79516",
  },
  {
    city_short: "SEKADAU",
    province: "KALIMANTAN BARAT",
    postal_code: "79582",
  },
  {
    city_short: "SEKADAU",
    province: "KALIMANTAN BARAT",
    postal_code: "79583",
  },
  {
    city_short: "SEKADAU",
    province: "KALIMANTAN BARAT",
    postal_code: "79584",
  },
  {
    city_short: "SEKADAU",
    province: "KALIMANTAN BARAT",
    postal_code: "79585",
  },
  {
    city_short: "SEKADAU",
    province: "KALIMANTAN BARAT",
    postal_code: "79586",
  },
  {
    city_short: "SEKADAU",
    province: "KALIMANTAN BARAT",
    postal_code: "79587",
  },
  {
    city_short: "SEKADAU",
    province: "KALIMANTAN BARAT",
    postal_code: "79588",
  },
  {
    city_short: "MELAWI",
    province: "KALIMANTAN BARAT",
    postal_code: "79671",
  },
  {
    city_short: "MELAWI",
    province: "KALIMANTAN BARAT",
    postal_code: "79672",
  },
  {
    city_short: "MELAWI",
    province: "KALIMANTAN BARAT",
    postal_code: "79673",
  },
  {
    city_short: "MELAWI",
    province: "KALIMANTAN BARAT",
    postal_code: "79674",
  },
  {
    city_short: "MELAWI",
    province: "KALIMANTAN BARAT",
    postal_code: "79675",
  },
  {
    city_short: "MELAWI",
    province: "KALIMANTAN BARAT",
    postal_code: "79681",
  },
  {
    city_short: "MELAWI",
    province: "KALIMANTAN BARAT",
    postal_code: "79682",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80111",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80112",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80113",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80114",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80115",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80116",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80117",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80118",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80119",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80221",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80222",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80223",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80224",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80225",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80226",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80227",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80228",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80229",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80231",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80232",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80233",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80234",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80235",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80236",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80237",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80238",
  },
  {
    city_short: "DENPASAR",
    province: "BALI",
    postal_code: "80239",
  },
  {
    city_short: "BADUNG",
    province: "BALI",
    postal_code: "80351",
  },
  {
    city_short: "BADUNG",
    province: "BALI",
    postal_code: "80352",
  },
  {
    city_short: "BADUNG",
    province: "BALI",
    postal_code: "80353",
  },
  {
    city_short: "BADUNG",
    province: "BALI",
    postal_code: "80361",
  },
  {
    city_short: "GIANYAR",
    province: "BALI",
    postal_code: "80511",
  },
  {
    city_short: "GIANYAR",
    province: "BALI",
    postal_code: "80512",
  },
  {
    city_short: "GIANYAR",
    province: "BALI",
    postal_code: "80513",
  },
  {
    city_short: "GIANYAR",
    province: "BALI",
    postal_code: "80515",
  },
  {
    city_short: "GIANYAR",
    province: "BALI",
    postal_code: "80552",
  },
  {
    city_short: "GIANYAR",
    province: "BALI",
    postal_code: "80561",
  },
  {
    city_short: "GIANYAR",
    province: "BALI",
    postal_code: "80571",
  },
  {
    city_short: "GIANYAR",
    province: "BALI",
    postal_code: "80572",
  },
  {
    city_short: "GIANYAR",
    province: "BALI",
    postal_code: "80581",
  },
  {
    city_short: "GIANYAR",
    province: "BALI",
    postal_code: "80582",
  },
  {
    city_short: "BANGLI",
    province: "BALI",
    postal_code: "80611",
  },
  {
    city_short: "BANGLI",
    province: "BALI",
    postal_code: "80612",
  },
  {
    city_short: "BANGLI",
    province: "BALI",
    postal_code: "80613",
  },
  {
    city_short: "BANGLI",
    province: "BALI",
    postal_code: "80614",
  },
  {
    city_short: "BANGLI",
    province: "BALI",
    postal_code: "80652",
  },
  {
    city_short: "BANGLI",
    province: "BALI",
    postal_code: "80661",
  },
  {
    city_short: "BANGLI",
    province: "BALI",
    postal_code: "80671",
  },
  {
    city_short: "KLUNGKUNG",
    province: "BALI",
    postal_code: "80711",
  },
  {
    city_short: "KLUNGKUNG",
    province: "BALI",
    postal_code: "80712",
  },
  {
    city_short: "KLUNGKUNG",
    province: "BALI",
    postal_code: "80713",
  },
  {
    city_short: "KLUNGKUNG",
    province: "BALI",
    postal_code: "80716",
  },
  {
    city_short: "KLUNGKUNG",
    province: "BALI",
    postal_code: "80752",
  },
  {
    city_short: "KLUNGKUNG",
    province: "BALI",
    postal_code: "80761",
  },
  {
    city_short: "KLUNGKUNG",
    province: "BALI",
    postal_code: "80771",
  },
  {
    city_short: "KARANGASEM",
    province: "BALI",
    postal_code: "80811",
  },
  {
    city_short: "KARANGASEM",
    province: "BALI",
    postal_code: "80813",
  },
  {
    city_short: "KARANGASEM",
    province: "BALI",
    postal_code: "80852",
  },
  {
    city_short: "KARANGASEM",
    province: "BALI",
    postal_code: "80853",
  },
  {
    city_short: "KARANGASEM",
    province: "BALI",
    postal_code: "80861",
  },
  {
    city_short: "KARANGASEM",
    province: "BALI",
    postal_code: "80862",
  },
  {
    city_short: "KARANGASEM",
    province: "BALI",
    postal_code: "80863",
  },
  {
    city_short: "KARANGASEM",
    province: "BALI",
    postal_code: "80864",
  },
  {
    city_short: "KARANGASEM",
    province: "BALI",
    postal_code: "80871",
  },
  {
    city_short: "BULELENG",
    province: "BALI",
    postal_code: "81111",
  },
  {
    city_short: "BULELENG",
    province: "BALI",
    postal_code: "81112",
  },
  {
    city_short: "BULELENG",
    province: "BALI",
    postal_code: "81113",
  },
  {
    city_short: "BULELENG",
    province: "BALI",
    postal_code: "81114",
  },
  {
    city_short: "BULELENG",
    province: "BALI",
    postal_code: "81115",
  },
  {
    city_short: "BULELENG",
    province: "BALI",
    postal_code: "81116",
  },
  {
    city_short: "BULELENG",
    province: "BALI",
    postal_code: "81117",
  },
  {
    city_short: "BULELENG",
    province: "BALI",
    postal_code: "81118",
  },
  {
    city_short: "BULELENG",
    province: "BALI",
    postal_code: "81119",
  },
  {
    city_short: "BULELENG",
    province: "BALI",
    postal_code: "81152",
  },
  {
    city_short: "BULELENG",
    province: "BALI",
    postal_code: "81153",
  },
  {
    city_short: "BULELENG",
    province: "BALI",
    postal_code: "81154",
  },
  {
    city_short: "BULELENG",
    province: "BALI",
    postal_code: "81155",
  },
  {
    city_short: "BULELENG",
    province: "BALI",
    postal_code: "81161",
  },
  {
    city_short: "BULELENG",
    province: "BALI",
    postal_code: "81171",
  },
  {
    city_short: "BULELENG",
    province: "BALI",
    postal_code: "81172",
  },
  {
    city_short: "BULELENG",
    province: "BALI",
    postal_code: "81173",
  },
  {
    city_short: "TABANAN",
    province: "BALI",
    postal_code: "82111",
  },
  {
    city_short: "TABANAN",
    province: "BALI",
    postal_code: "82112",
  },
  {
    city_short: "TABANAN",
    province: "BALI",
    postal_code: "82113",
  },
  {
    city_short: "TABANAN",
    province: "BALI",
    postal_code: "82114",
  },
  {
    city_short: "TABANAN",
    province: "BALI",
    postal_code: "82115",
  },
  {
    city_short: "TABANAN",
    province: "BALI",
    postal_code: "82121",
  },
  {
    city_short: "TABANAN",
    province: "BALI",
    postal_code: "82123",
  },
  {
    city_short: "TABANAN",
    province: "BALI",
    postal_code: "82152",
  },
  {
    city_short: "TABANAN",
    province: "BALI",
    postal_code: "82161",
  },
  {
    city_short: "TABANAN",
    province: "BALI",
    postal_code: "82162",
  },
  {
    city_short: "TABANAN",
    province: "BALI",
    postal_code: "82163",
  },
  {
    city_short: "TABANAN",
    province: "BALI",
    postal_code: "82181",
  },
  {
    city_short: "TABANAN",
    province: "BALI",
    postal_code: "82191",
  },
  {
    city_short: "JEMBRANA",
    province: "BALI",
    postal_code: "82211",
  },
  {
    city_short: "JEMBRANA",
    province: "BALI",
    postal_code: "82212",
  },
  {
    city_short: "JEMBRANA",
    province: "BALI",
    postal_code: "82213",
  },
  {
    city_short: "JEMBRANA",
    province: "BALI",
    postal_code: "82214",
  },
  {
    city_short: "JEMBRANA",
    province: "BALI",
    postal_code: "82215",
  },
  {
    city_short: "JEMBRANA",
    province: "BALI",
    postal_code: "82216",
  },
  {
    city_short: "JEMBRANA",
    province: "BALI",
    postal_code: "82218",
  },
  {
    city_short: "JEMBRANA",
    province: "BALI",
    postal_code: "82252",
  },
  {
    city_short: "JEMBRANA",
    province: "BALI",
    postal_code: "82261",
  },
  {
    city_short: "JEMBRANA",
    province: "BALI",
    postal_code: "82262",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83112",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83113",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83114",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83115",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83116",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83117",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83118",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83121",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83122",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83123",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83124",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83125",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83126",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83127",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83232",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83233",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83236",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83237",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83238",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83239",
  },
  {
    city_short: "LOMBOK BARAT",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83351",
  },
  {
    city_short: "LOMBOK UTARA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83352",
  },
  {
    city_short: "LOMBOK UTARA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83353",
  },
  {
    city_short: "LOMBOK UTARA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83354",
  },
  {
    city_short: "LOMBOK BARAT",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83355",
  },
  {
    city_short: "LOMBOK BARAT",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83361",
  },
  {
    city_short: "LOMBOK BARAT",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83362",
  },
  {
    city_short: "LOMBOK BARAT",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83363",
  },
  {
    city_short: "LOMBOK BARAT",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83364",
  },
  {
    city_short: "LOMBOK BARAT",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83365",
  },
  {
    city_short: "LOMBOK BARAT",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83371",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83511",
  },
  {
    city_short: "MATARAM",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83511",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83512",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83513",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83514",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83515",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83516",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83518",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83519",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83521",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83522",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83523",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83552",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83553",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83554",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83561",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83562",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83571",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83572",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83573",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83581",
  },
  {
    city_short: "LOMBOK TENGAH",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83582",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83611",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83612",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83613",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83614",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83615",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83616",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83617",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83618",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83619",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83652",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83653",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83654",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83656",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83661",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83662",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83663",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83671",
  },
  {
    city_short: "LOMBOK TIMUR",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "83672",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84111",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84112",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84113",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84114",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84115",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84116",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84117",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84118",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84119",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84152",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84153",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84161",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84162",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84171",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84172",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84173",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84181",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84182",
  },
  {
    city_short: "BIMA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84191",
  },
  {
    city_short: "DOMPU",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84211",
  },
  {
    city_short: "DOMPU",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84212",
  },
  {
    city_short: "DOMPU",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84213",
  },
  {
    city_short: "DOMPU",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84214",
  },
  {
    city_short: "DOMPU",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84216",
  },
  {
    city_short: "DOMPU",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84217",
  },
  {
    city_short: "DOMPU",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84218",
  },
  {
    city_short: "DOMPU",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84219",
  },
  {
    city_short: "DOMPU",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84251",
  },
  {
    city_short: "DOMPU",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84252",
  },
  {
    city_short: "DOMPU",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84253",
  },
  {
    city_short: "DOMPU",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84261",
  },
  {
    city_short: "DOMPU",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84271",
  },
  {
    city_short: "DOMPU",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84272",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84311",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84312",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84313",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84314",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84315",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84316",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84317",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84318",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84352",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84353",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84361",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84371",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84372",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84373",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84381",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84382",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84383",
  },
  {
    city_short: "SUMBAWA",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84384",
  },
  {
    city_short: "SUMBAWA BARAT",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84454",
  },
  {
    city_short: "SUMBAWA BARAT",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84455",
  },
  {
    city_short: "SUMBAWA BARAT",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84456",
  },
  {
    city_short: "SUMBAWA BARAT",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84457",
  },
  {
    city_short: "SUMBAWA BARAT",
    province: "NUSA TENGGARA BARAT (NTB)",
    postal_code: "84458",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85111",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85112",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85116",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85118",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85119",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85141",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85142",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85143",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85144",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85146",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85147",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85148",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85221",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85223",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85225",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85226",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85227",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85228",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85229",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85231",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85232",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85233",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85234",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85235",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85236",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85237",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85238",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85239",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85351",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85353",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85361",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85362",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85363",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85364",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85365",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85367",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85368",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85369",
  },
  {
    city_short: "SABU RAIJUA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85391",
  },
  {
    city_short: "KUPANG",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85391",
  },
  {
    city_short: "SABU RAIJUA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85392",
  },
  {
    city_short: "SABU RAIJUA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85393",
  },
  {
    city_short: "TIMOR TENG SEL",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85511",
  },
  {
    city_short: "TIMOR TENG SEL",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85514",
  },
  {
    city_short: "TIMOR TENG SEL",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85515",
  },
  {
    city_short: "TIMOR TENG SEL",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85516",
  },
  {
    city_short: "TIMOR TENG SEL",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85517",
  },
  {
    city_short: "TIMOR TENG SEL",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85519",
  },
  {
    city_short: "TIMOR TENG SEL",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85551",
  },
  {
    city_short: "TIMOR TENG SEL",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85552",
  },
  {
    city_short: "TIMOR TENG SEL",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85561",
  },
  {
    city_short: "TIMOR TENG SEL",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85562",
  },
  {
    city_short: "TIMOR TENG SEL",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85563",
  },
  {
    city_short: "TIMOR TENG SEL",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85571",
  },
  {
    city_short: "TIMOR TENG SEL",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85572",
  },
  {
    city_short: "TIMOR TENG SEL",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85573",
  },
  {
    city_short: "TIMOR TENG SEL",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85574",
  },
  {
    city_short: "TIMOR TENG SEL",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85575",
  },
  {
    city_short: "TIMOR TENG UTA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85611",
  },
  {
    city_short: "TIMOR TENG UTA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85612",
  },
  {
    city_short: "TIMOR TENG UTA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85613",
  },
  {
    city_short: "TIMOR TENG UTA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85614",
  },
  {
    city_short: "TIMOR TENG UTA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85615",
  },
  {
    city_short: "TIMOR TENG UTA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85616",
  },
  {
    city_short: "TIMOR TENG UTA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85617",
  },
  {
    city_short: "TIMOR TENG UTA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85651",
  },
  {
    city_short: "TIMOR TENG UTA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85661",
  },
  {
    city_short: "TIMOR TENG UTA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85671",
  },
  {
    city_short: "TIMOR TENG UTA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85681",
  },
  {
    city_short: "TIMOR TENG UTA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85682",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85711",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85712",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85713",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85714",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85715",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85716",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85717",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85718",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85752",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85761",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85762",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85763",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85764",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85765",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85766",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85771",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85772",
  },
  {
    city_short: "BELU",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85773",
  },
  {
    city_short: "ALOR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85811",
  },
  {
    city_short: "ALOR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85812",
  },
  {
    city_short: "ALOR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85813",
  },
  {
    city_short: "ALOR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85814",
  },
  {
    city_short: "ALOR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85815",
  },
  {
    city_short: "ALOR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85816",
  },
  {
    city_short: "ALOR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85817",
  },
  {
    city_short: "ALOR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85819",
  },
  {
    city_short: "ALOR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85851",
  },
  {
    city_short: "ALOR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85861",
  },
  {
    city_short: "ALOR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85871",
  },
  {
    city_short: "ALOR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85872",
  },
  {
    city_short: "ALOR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85881",
  },
  {
    city_short: "ROTE NDAO",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85912",
  },
  {
    city_short: "ROTE NDAO",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85913",
  },
  {
    city_short: "ROTE NDAO",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85914",
  },
  {
    city_short: "ROTE NDAO",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85916",
  },
  {
    city_short: "ROTE NDAO",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85917",
  },
  {
    city_short: "ROTE NDAO",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85918",
  },
  {
    city_short: "ROTE NDAO",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85972",
  },
  {
    city_short: "ROTE NDAO",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85973",
  },
  {
    city_short: "ROTE NDAO",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85974",
  },
  {
    city_short: "ROTE NDAO",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85981",
  },
  {
    city_short: "ROTE NDAO",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85982",
  },
  {
    city_short: "ROTE NDAO",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "85983",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86111",
  },
  {
    city_short: "SIKKA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86111",
  },
  {
    city_short: "SIKKA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86112",
  },
  {
    city_short: "SIKKA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86113",
  },
  {
    city_short: "SIKKA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86114",
  },
  {
    city_short: "SIKKA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86115",
  },
  {
    city_short: "SIKKA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86116",
  },
  {
    city_short: "SIKKA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86118",
  },
  {
    city_short: "SIKKA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86152",
  },
  {
    city_short: "SIKKA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86153",
  },
  {
    city_short: "SIKKA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86161",
  },
  {
    city_short: "SIKKA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86171",
  },
  {
    city_short: "SIKKA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86181",
  },
  {
    city_short: "SIKKA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86183",
  },
  {
    city_short: "FLORES TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86211",
  },
  {
    city_short: "FLORES TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86212",
  },
  {
    city_short: "FLORES TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86213",
  },
  {
    city_short: "FLORES TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86214",
  },
  {
    city_short: "FLORES TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86215",
  },
  {
    city_short: "SIKKA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86215",
  },
  {
    city_short: "FLORES TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86216",
  },
  {
    city_short: "FLORES TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86217",
  },
  {
    city_short: "FLORES TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86219",
  },
  {
    city_short: "FLORES TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86252",
  },
  {
    city_short: "FLORES TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86253",
  },
  {
    city_short: "FLORES TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86261",
  },
  {
    city_short: "FLORES TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86262",
  },
  {
    city_short: "FLORES TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86271",
  },
  {
    city_short: "FLORES TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86272",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86312",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86313",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86314",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86315",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86316",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86317",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86318",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86319",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86352",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86353",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86361",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86362",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86371",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86372",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86374",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86375",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86376",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86377",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86378",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86379",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86381",
  },
  {
    city_short: "ENDE",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86382",
  },
  {
    city_short: "NGADA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86411",
  },
  {
    city_short: "NGADA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86412",
  },
  {
    city_short: "NGADA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86413",
  },
  {
    city_short: "NGADA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86414",
  },
  {
    city_short: "NGADA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86415",
  },
  {
    city_short: "NGADA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86416",
  },
  {
    city_short: "NGADA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86417",
  },
  {
    city_short: "NGADA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86418",
  },
  {
    city_short: "NGADA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86419",
  },
  {
    city_short: "NGADA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86452",
  },
  {
    city_short: "NGADA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86461",
  },
  {
    city_short: "NAGEKEO",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86462",
  },
  {
    city_short: "NAGEKEO",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86463",
  },
  {
    city_short: "NAGEKEO",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86464",
  },
  {
    city_short: "NAGEKEO",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86472",
  },
  {
    city_short: "MANGGARAI",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86511",
  },
  {
    city_short: "MANGGARAI",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86512",
  },
  {
    city_short: "MANGGARAI",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86513",
  },
  {
    city_short: "MANGGARAI",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86514",
  },
  {
    city_short: "MANGGARAI",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86515",
  },
  {
    city_short: "MANGGARAI",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86516",
  },
  {
    city_short: "MANGGARAI",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86517",
  },
  {
    city_short: "MANGGARAI",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86518",
  },
  {
    city_short: "MANGGARAI",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86519",
  },
  {
    city_short: "MANGGARAI",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86561",
  },
  {
    city_short: "MANGGARAI TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86571",
  },
  {
    city_short: "MANGGARAI TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86572",
  },
  {
    city_short: "MANGGARAI TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86581",
  },
  {
    city_short: "MANGGARAI TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86582",
  },
  {
    city_short: "MANGGARAI TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86583",
  },
  {
    city_short: "MANGGARAI TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86584",
  },
  {
    city_short: "MANGGARAI",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86591",
  },
  {
    city_short: "MANGGARAI",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86592",
  },
  {
    city_short: "LEMBATA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86611",
  },
  {
    city_short: "LEMBATA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86612",
  },
  {
    city_short: "LEMBATA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86613",
  },
  {
    city_short: "LEMBATA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86615",
  },
  {
    city_short: "LEMBATA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86616",
  },
  {
    city_short: "LEMBATA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86681",
  },
  {
    city_short: "LEMBATA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86682",
  },
  {
    city_short: "LEMBATA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86683",
  },
  {
    city_short: "LEMBATA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86684",
  },
  {
    city_short: "LEMBATA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86685",
  },
  {
    city_short: "LEMBATA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86691",
  },
  {
    city_short: "LEMBATA",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86692",
  },
  {
    city_short: "MANGGARAI BARAT",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86752",
  },
  {
    city_short: "MANGGARAI BARAT",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86753",
  },
  {
    city_short: "MANGGARAI BARAT",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86754",
  },
  {
    city_short: "MANGGARAI BARAT",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86756",
  },
  {
    city_short: "MANGGARAI BARAT",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "86757",
  },
  {
    city_short: "SUMBA TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87111",
  },
  {
    city_short: "SUMBA TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87112",
  },
  {
    city_short: "SUMBA TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87113",
  },
  {
    city_short: "SUMBA TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87114",
  },
  {
    city_short: "SUMBA TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87115",
  },
  {
    city_short: "SUMBA TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87116",
  },
  {
    city_short: "SUMBA TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87152",
  },
  {
    city_short: "SUMBA TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87153",
  },
  {
    city_short: "SUMBA TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87161",
  },
  {
    city_short: "SUMBA TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87171",
  },
  {
    city_short: "SUMBA TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87172",
  },
  {
    city_short: "SUMBA TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87181",
  },
  {
    city_short: "SUMBA TIMUR",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87182",
  },
  {
    city_short: "SUMBA BARAT",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87211",
  },
  {
    city_short: "SUMBA BARAT",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87212",
  },
  {
    city_short: "SUMBA BARAT",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87213",
  },
  {
    city_short: "SUMBA BARAT",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87214",
  },
  {
    city_short: "SUMBA BARAT",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87215",
  },
  {
    city_short: "SUMBA BARAT",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87216",
  },
  {
    city_short: "SUMBA BARAT",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87217",
  },
  {
    city_short: "SUMBA BD",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87252",
  },
  {
    city_short: "SUMBA BD",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87253",
  },
  {
    city_short: "SUMBA BD",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87254",
  },
  {
    city_short: "SUMBA BD",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87255",
  },
  {
    city_short: "SUMBA BARAT",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87257",
  },
  {
    city_short: "SUMBA TENGAH",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87258",
  },
  {
    city_short: "SUMBA BD",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87261",
  },
  {
    city_short: "SUMBA BD",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87262",
  },
  {
    city_short: "SUMBA BD",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87263",
  },
  {
    city_short: "SUMBA BARAT",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87271",
  },
  {
    city_short: "SUMBA BARAT",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87272",
  },
  {
    city_short: "SUMBA TENGAH",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87282",
  },
  {
    city_short: "SUMBA TENGAH",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87283",
  },
  {
    city_short: "SUMBA BARAT",
    province: "NUSA TENGGARA TIMUR (NTT)",
    postal_code: "87284",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90111",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90112",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90113",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90114",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90115",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90121",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90122",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90123",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90125",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90126",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90131",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90132",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90133",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90134",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90135",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90141",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90142",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90143",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90144",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90145",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90151",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90152",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90153",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90154",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90155",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90156",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90157",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90161",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90162",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90163",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90164",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90165",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90166",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90167",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90168",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90171",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90172",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90173",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90174",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90211",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90212",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90213",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90214",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90215",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90216",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90217",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90221",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90222",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90223",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90224",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "90225",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "90225",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90225",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90231",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90232",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90233",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90234",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90235",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90241",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90242",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90243",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90244",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "90244",
  },
  {
    city_short: "MAKASSAR",
    province: "SULAWESI SELATAN",
    postal_code: "90245",
  },
  {
    city_short: "MAROS",
    province: "SULAWESI SELATAN",
    postal_code: "90511",
  },
  {
    city_short: "MAROS",
    province: "SULAWESI SELATAN",
    postal_code: "90512",
  },
  {
    city_short: "MAROS",
    province: "SULAWESI SELATAN",
    postal_code: "90513",
  },
  {
    city_short: "MAROS",
    province: "SULAWESI SELATAN",
    postal_code: "90514",
  },
  {
    city_short: "MAROS",
    province: "SULAWESI SELATAN",
    postal_code: "90515",
  },
  {
    city_short: "MAROS",
    province: "SULAWESI SELATAN",
    postal_code: "90516",
  },
  {
    city_short: "MAROS",
    province: "SULAWESI SELATAN",
    postal_code: "90552",
  },
  {
    city_short: "MAROS",
    province: "SULAWESI SELATAN",
    postal_code: "90553",
  },
  {
    city_short: "MAROS",
    province: "SULAWESI SELATAN",
    postal_code: "90554",
  },
  {
    city_short: "MAROS",
    province: "SULAWESI SELATAN",
    postal_code: "90561",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90561",
  },
  {
    city_short: "MAROS",
    province: "SULAWESI SELATAN",
    postal_code: "90562",
  },
  {
    city_short: "MAROS",
    province: "SULAWESI SELATAN",
    postal_code: "90563",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90611",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90612",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90613",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90614",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90615",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90616",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90617",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90618",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90619",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90651",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90653",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90654",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90655",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90661",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90671",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90672",
  },
  {
    city_short: "PANGKAJENE KEP",
    province: "SULAWESI SELATAN",
    postal_code: "90673",
  },
  {
    city_short: "BARRU",
    province: "SULAWESI SELATAN",
    postal_code: "90711",
  },
  {
    city_short: "BARRU",
    province: "SULAWESI SELATAN",
    postal_code: "90712",
  },
  {
    city_short: "BARRU",
    province: "SULAWESI SELATAN",
    postal_code: "90752",
  },
  {
    city_short: "BARRU",
    province: "SULAWESI SELATAN",
    postal_code: "90753",
  },
  {
    city_short: "BARRU",
    province: "SULAWESI SELATAN",
    postal_code: "90761",
  },
  {
    city_short: "BARRU",
    province: "SULAWESI SELATAN",
    postal_code: "90762",
  },
  {
    city_short: "SOPPENG",
    province: "SULAWESI SELATAN",
    postal_code: "90811",
  },
  {
    city_short: "SOPPENG",
    province: "SULAWESI SELATAN",
    postal_code: "90812",
  },
  {
    city_short: "SOPPENG",
    province: "SULAWESI SELATAN",
    postal_code: "90813",
  },
  {
    city_short: "SOPPENG",
    province: "SULAWESI SELATAN",
    postal_code: "90814",
  },
  {
    city_short: "SOPPENG",
    province: "SULAWESI SELATAN",
    postal_code: "90852",
  },
  {
    city_short: "SOPPENG",
    province: "SULAWESI SELATAN",
    postal_code: "90853",
  },
  {
    city_short: "SOPPENG",
    province: "SULAWESI SELATAN",
    postal_code: "90861",
  },
  {
    city_short: "SOPPENG",
    province: "SULAWESI SELATAN",
    postal_code: "90862",
  },
  {
    city_short: "SOPPENG",
    province: "SULAWESI SELATAN",
    postal_code: "90871",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90911",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90912",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90913",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90914",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90915",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90916",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90917",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90918",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90951",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90952",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90953",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90954",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90961",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90971",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90981",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90982",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90983",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90984",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90991",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90992",
  },
  {
    city_short: "WAJO",
    province: "SULAWESI SELATAN",
    postal_code: "90993",
  },
  {
    city_short: "PAREPARE",
    province: "SULAWESI BARAT",
    postal_code: "91111",
  },
  {
    city_short: "PAREPARE",
    province: "SULAWESI BARAT",
    postal_code: "91112",
  },
  {
    city_short: "PAREPARE",
    province: "SULAWESI BARAT",
    postal_code: "91113",
  },
  {
    city_short: "PAREPARE",
    province: "SULAWESI BARAT",
    postal_code: "91114",
  },
  {
    city_short: "PAREPARE",
    province: "SULAWESI BARAT",
    postal_code: "91121",
  },
  {
    city_short: "PAREPARE",
    province: "SULAWESI BARAT",
    postal_code: "91122",
  },
  {
    city_short: "PAREPARE",
    province: "SULAWESI BARAT",
    postal_code: "91123",
  },
  {
    city_short: "PAREPARE",
    province: "SULAWESI BARAT",
    postal_code: "91125",
  },
  {
    city_short: "PAREPARE",
    province: "SULAWESI BARAT",
    postal_code: "91131",
  },
  {
    city_short: "PAREPARE",
    province: "SULAWESI BARAT",
    postal_code: "91132",
  },
  {
    city_short: "PAREPARE",
    province: "SULAWESI BARAT",
    postal_code: "91133",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91211",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91212",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91213",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91214",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91215",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91216",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91217",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91218",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91219",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91221",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91252",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91253",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91254",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91256",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91261",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91262",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91271",
  },
  {
    city_short: "PINRANG",
    province: "SULAWESI BARAT",
    postal_code: "91272",
  },
  {
    city_short: "POLEWALI MANDAR",
    province: "SULAWESI BARAT",
    postal_code: "91311",
  },
  {
    city_short: "POLEWALI MANDAR",
    province: "SULAWESI BARAT",
    postal_code: "91312",
  },
  {
    city_short: "POLEWALI MANDAR",
    province: "SULAWESI BARAT",
    postal_code: "91313",
  },
  {
    city_short: "POLEWALI MANDAR",
    province: "SULAWESI BARAT",
    postal_code: "91314",
  },
  {
    city_short: "POLEWALI MANDAR",
    province: "SULAWESI BARAT",
    postal_code: "91315",
  },
  {
    city_short: "POLEWALI MANDAR",
    province: "SULAWESI BARAT",
    postal_code: "91351",
  },
  {
    city_short: "POLEWALI MANDAR",
    province: "SULAWESI BARAT",
    postal_code: "91352",
  },
  {
    city_short: "MAMUJU",
    province: "SULAWESI BARAT",
    postal_code: "91352",
  },
  {
    city_short: "POLEWALI MANDAR",
    province: "SULAWESI BARAT",
    postal_code: "91353",
  },
  {
    city_short: "POLEWALI MANDAR",
    province: "SULAWESI BARAT",
    postal_code: "91354",
  },
  {
    city_short: "POLEWALI MANDAR",
    province: "SULAWESI BARAT",
    postal_code: "91355",
  },
  {
    city_short: "MAMASA",
    province: "SULAWESI BARAT",
    postal_code: "91361",
  },
  {
    city_short: "MAMASA",
    province: "SULAWESI BARAT",
    postal_code: "91362",
  },
  {
    city_short: "MAMASA",
    province: "SULAWESI BARAT",
    postal_code: "91363",
  },
  {
    city_short: "MAMASA",
    province: "SULAWESI BARAT",
    postal_code: "91364",
  },
  {
    city_short: "MAMASA",
    province: "SULAWESI BARAT",
    postal_code: "91365",
  },
  {
    city_short: "MAMASA",
    province: "SULAWESI BARAT",
    postal_code: "91366",
  },
  {
    city_short: "MAMASA",
    province: "SULAWESI BARAT",
    postal_code: "91371",
  },
  {
    city_short: "MAMASA",
    province: "SULAWESI BARAT",
    postal_code: "91372",
  },
  {
    city_short: "MAMASA",
    province: "SULAWESI BARAT",
    postal_code: "91373",
  },
  {
    city_short: "MAJENE",
    province: "SULAWESI BARAT",
    postal_code: "91411",
  },
  {
    city_short: "MAJENE",
    province: "SULAWESI BARAT",
    postal_code: "91412",
  },
  {
    city_short: "POLEWALI MANDAR",
    province: "SULAWESI BARAT",
    postal_code: "91412",
  },
  {
    city_short: "POLEWALI MANDAR",
    province: "SULAWESI BARAT",
    postal_code: "91413",
  },
  {
    city_short: "MAJENE",
    province: "SULAWESI BARAT",
    postal_code: "91413",
  },
  {
    city_short: "MAJENE",
    province: "SULAWESI BARAT",
    postal_code: "91414",
  },
  {
    city_short: "MAJENE",
    province: "SULAWESI BARAT",
    postal_code: "91415",
  },
  {
    city_short: "MAJENE",
    province: "SULAWESI BARAT",
    postal_code: "91451",
  },
  {
    city_short: "MAJENE",
    province: "SULAWESI BARAT",
    postal_code: "91452",
  },
  {
    city_short: "MAJENE",
    province: "SULAWESI BARAT",
    postal_code: "91453",
  },
  {
    city_short: "MAMUJU",
    province: "SULAWESI BARAT",
    postal_code: "91511",
  },
  {
    city_short: "MAMUJU UTARA",
    province: "SULAWESI BARAT",
    postal_code: "91512",
  },
  {
    city_short: "MAMUJU",
    province: "SULAWESI BARAT",
    postal_code: "91512",
  },
  {
    city_short: "MAMUJU",
    province: "SULAWESI BARAT",
    postal_code: "91513",
  },
  {
    city_short: "MAMUJU",
    province: "SULAWESI BARAT",
    postal_code: "91514",
  },
  {
    city_short: "MAMUJU",
    province: "SULAWESI BARAT",
    postal_code: "91515",
  },
  {
    city_short: "MAMUJU",
    province: "SULAWESI BARAT",
    postal_code: "91561",
  },
  {
    city_short: "MAMUJU",
    province: "SULAWESI BARAT",
    postal_code: "91562",
  },
  {
    city_short: "MAMUJU",
    province: "SULAWESI BARAT",
    postal_code: "91563",
  },
  {
    city_short: "MAMUJU UTARA",
    province: "SULAWESI BARAT",
    postal_code: "91571",
  },
  {
    city_short: "MAMUJU UTARA",
    province: "SULAWESI BARAT",
    postal_code: "91572",
  },
  {
    city_short: "MAMUJU UTARA",
    province: "SULAWESI BARAT",
    postal_code: "91573",
  },
  {
    city_short: "MAMUJU UTARA",
    province: "SULAWESI BARAT",
    postal_code: "91574",
  },
  {
    city_short: "SIDRAP",
    province: "SULAWESI SELATAN",
    postal_code: "91611",
  },
  {
    city_short: "SIDRAP",
    province: "SULAWESI SELATAN",
    postal_code: "91613",
  },
  {
    city_short: "SIDRAP",
    province: "SULAWESI SELATAN",
    postal_code: "91614",
  },
  {
    city_short: "SIDRAP",
    province: "SULAWESI SELATAN",
    postal_code: "91615",
  },
  {
    city_short: "SIDRAP",
    province: "SULAWESI SELATAN",
    postal_code: "91616",
  },
  {
    city_short: "SIDRAP",
    province: "SULAWESI SELATAN",
    postal_code: "91651",
  },
  {
    city_short: "SIDRAP",
    province: "SULAWESI SELATAN",
    postal_code: "91652",
  },
  {
    city_short: "SIDRAP",
    province: "SULAWESI SELATAN",
    postal_code: "91653",
  },
  {
    city_short: "SIDRAP",
    province: "SULAWESI SELATAN",
    postal_code: "91661",
  },
  {
    city_short: "SIDRAP",
    province: "SULAWESI SELATAN",
    postal_code: "91662",
  },
  {
    city_short: "SINJAI",
    province: "SULAWESI SELATAN",
    postal_code: "91671",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "91671",
  },
  {
    city_short: "SIDRAP",
    province: "SULAWESI SELATAN",
    postal_code: "91672",
  },
  {
    city_short: "SIDRAP",
    province: "SULAWESI SELATAN",
    postal_code: "91681",
  },
  {
    city_short: "SIDRAP",
    province: "SULAWESI SELATAN",
    postal_code: "91682",
  },
  {
    city_short: "SIDRAP",
    province: "SULAWESI SELATAN",
    postal_code: "91683",
  },
  {
    city_short: "SIDRAP",
    province: "SULAWESI SELATAN",
    postal_code: "91691",
  },
  {
    city_short: "ENREKANG",
    province: "SULAWESI SELATAN",
    postal_code: "91711",
  },
  {
    city_short: "ENREKANG",
    province: "SULAWESI SELATAN",
    postal_code: "91712",
  },
  {
    city_short: "ENREKANG",
    province: "SULAWESI SELATAN",
    postal_code: "91752",
  },
  {
    city_short: "ENREKANG",
    province: "SULAWESI SELATAN",
    postal_code: "91753",
  },
  {
    city_short: "ENREKANG",
    province: "SULAWESI SELATAN",
    postal_code: "91754",
  },
  {
    city_short: "ENREKANG",
    province: "SULAWESI SELATAN",
    postal_code: "91761",
  },
  {
    city_short: "TANA TORAJA",
    province: "SULAWESI SELATAN",
    postal_code: "91811",
  },
  {
    city_short: "TANA TORAJA",
    province: "SULAWESI SELATAN",
    postal_code: "91812",
  },
  {
    city_short: "TANA TORAJA",
    province: "SULAWESI SELATAN",
    postal_code: "91813",
  },
  {
    city_short: "TANA TORAJA",
    province: "SULAWESI SELATAN",
    postal_code: "91814",
  },
  {
    city_short: "TANA TORAJA",
    province: "SULAWESI SELATAN",
    postal_code: "91815",
  },
  {
    city_short: "TANA TORAJA",
    province: "SULAWESI SELATAN",
    postal_code: "91817",
  },
  {
    city_short: "TORAJA UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "91831",
  },
  {
    city_short: "TORAJA UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "91832",
  },
  {
    city_short: "TORAJA UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "91833",
  },
  {
    city_short: "TORAJA UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "91834",
  },
  {
    city_short: "TORAJA UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "91835",
  },
  {
    city_short: "TORAJA UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "91852",
  },
  {
    city_short: "TORAJA UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "91853",
  },
  {
    city_short: "TANA TORAJA",
    province: "SULAWESI SELATAN",
    postal_code: "91854",
  },
  {
    city_short: "TORAJA UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "91854",
  },
  {
    city_short: "LUWU UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "91854",
  },
  {
    city_short: "TORAJA UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "91855",
  },
  {
    city_short: "TANA TORAJA",
    province: "SULAWESI SELATAN",
    postal_code: "91856",
  },
  {
    city_short: "TANA TORAJA",
    province: "SULAWESI SELATAN",
    postal_code: "91861",
  },
  {
    city_short: "TANA TORAJA",
    province: "SULAWESI SELATAN",
    postal_code: "91862",
  },
  {
    city_short: "TORAJA UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "91862",
  },
  {
    city_short: "TANA TORAJA",
    province: "SULAWESI SELATAN",
    postal_code: "91871",
  },
  {
    city_short: "TANA TORAJA",
    province: "SULAWESI SELATAN",
    postal_code: "91872",
  },
  {
    city_short: "TANA TORAJA",
    province: "SULAWESI SELATAN",
    postal_code: "91873",
  },
  {
    city_short: "TANA TORAJA",
    province: "SULAWESI SELATAN",
    postal_code: "91881",
  },
  {
    city_short: "PALOPO",
    province: "SULAWESI SELATAN",
    postal_code: "91911",
  },
  {
    city_short: "PALOPO",
    province: "SULAWESI SELATAN",
    postal_code: "91912",
  },
  {
    city_short: "PALOPO",
    province: "SULAWESI SELATAN",
    postal_code: "91913",
  },
  {
    city_short: "PALOPO",
    province: "SULAWESI SELATAN",
    postal_code: "91914",
  },
  {
    city_short: "PALOPO",
    province: "SULAWESI SELATAN",
    postal_code: "91921",
  },
  {
    city_short: "LUWU",
    province: "SULAWESI SELATAN",
    postal_code: "91921",
  },
  {
    city_short: "PALOPO",
    province: "SULAWESI SELATAN",
    postal_code: "91922",
  },
  {
    city_short: "PALOPO",
    province: "SULAWESI SELATAN",
    postal_code: "91923",
  },
  {
    city_short: "PALOPO",
    province: "SULAWESI SELATAN",
    postal_code: "91924",
  },
  {
    city_short: "PALOPO",
    province: "SULAWESI SELATAN",
    postal_code: "91925",
  },
  {
    city_short: "PALOPO",
    province: "SULAWESI SELATAN",
    postal_code: "91926",
  },
  {
    city_short: "LUWU",
    province: "SULAWESI SELATAN",
    postal_code: "91951",
  },
  {
    city_short: "LUWU",
    province: "SULAWESI SELATAN",
    postal_code: "91952",
  },
  {
    city_short: "PALOPO",
    province: "SULAWESI SELATAN",
    postal_code: "91958",
  },
  {
    city_short: "PALOPO",
    province: "SULAWESI SELATAN",
    postal_code: "91959",
  },
  {
    city_short: "LUWU UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "91966",
  },
  {
    city_short: "LUWU TIMUR",
    province: "SULAWESI SELATAN",
    postal_code: "91981",
  },
  {
    city_short: "LUWU",
    province: "SULAWESI SELATAN",
    postal_code: "91991",
  },
  {
    city_short: "LUWU",
    province: "SULAWESI SELATAN",
    postal_code: "91992",
  },
  {
    city_short: "LUWU",
    province: "SULAWESI SELATAN",
    postal_code: "91993",
  },
  {
    city_short: "LUWU",
    province: "SULAWESI SELATAN",
    postal_code: "91994",
  },
  {
    city_short: "LUWU",
    province: "SULAWESI SELATAN",
    postal_code: "91995",
  },
  {
    city_short: "LUWU",
    province: "SULAWESI SELATAN",
    postal_code: "91996",
  },
  {
    city_short: "LUWU",
    province: "SULAWESI SELATAN",
    postal_code: "91997",
  },
  {
    city_short: "LUWU",
    province: "SULAWESI SELATAN",
    postal_code: "91998",
  },
  {
    city_short: "LUWU",
    province: "SULAWESI SELATAN",
    postal_code: "91999",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92111",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92112",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92113",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92114",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92115",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92116",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92117",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92118",
  },
  {
    city_short: "TORAJA UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "92119",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92119",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92152",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92153",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92161",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92171",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92173",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92174",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92175",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92176",
  },
  {
    city_short: "TAKALAR",
    province: "SULAWESI SELATAN",
    postal_code: "92211",
  },
  {
    city_short: "GOWA",
    province: "SULAWESI SELATAN",
    postal_code: "92215",
  },
  {
    city_short: "TAKALAR",
    province: "SULAWESI SELATAN",
    postal_code: "92221",
  },
  {
    city_short: "TAKALAR",
    province: "SULAWESI SELATAN",
    postal_code: "92231",
  },
  {
    city_short: "TAKALAR",
    province: "SULAWESI SELATAN",
    postal_code: "92232",
  },
  {
    city_short: "TAKALAR",
    province: "SULAWESI SELATAN",
    postal_code: "92252",
  },
  {
    city_short: "TAKALAR",
    province: "SULAWESI SELATAN",
    postal_code: "92254",
  },
  {
    city_short: "TAKALAR",
    province: "SULAWESI SELATAN",
    postal_code: "92255",
  },
  {
    city_short: "TAKALAR",
    province: "SULAWESI SELATAN",
    postal_code: "92261",
  },
  {
    city_short: "JENEPONTO",
    province: "SULAWESI SELATAN",
    postal_code: "92311",
  },
  {
    city_short: "JENEPONTO",
    province: "SULAWESI SELATAN",
    postal_code: "92312",
  },
  {
    city_short: "JENEPONTO",
    province: "SULAWESI SELATAN",
    postal_code: "92313",
  },
  {
    city_short: "JENEPONTO",
    province: "SULAWESI SELATAN",
    postal_code: "92314",
  },
  {
    city_short: "JENEPONTO",
    province: "SULAWESI SELATAN",
    postal_code: "92315",
  },
  {
    city_short: "JENEPONTO",
    province: "SULAWESI SELATAN",
    postal_code: "92316",
  },
  {
    city_short: "JENEPONTO",
    province: "SULAWESI SELATAN",
    postal_code: "92351",
  },
  {
    city_short: "JENEPONTO",
    province: "SULAWESI SELATAN",
    postal_code: "92352",
  },
  {
    city_short: "JENEPONTO",
    province: "SULAWESI SELATAN",
    postal_code: "92361",
  },
  {
    city_short: "JENEPONTO",
    province: "SULAWESI SELATAN",
    postal_code: "92371",
  },
  {
    city_short: "BANTAENG",
    province: "SULAWESI SELATAN",
    postal_code: "92411",
  },
  {
    city_short: "BANTAENG",
    province: "SULAWESI SELATAN",
    postal_code: "92412",
  },
  {
    city_short: "BANTAENG",
    province: "SULAWESI SELATAN",
    postal_code: "92413",
  },
  {
    city_short: "BANTAENG",
    province: "SULAWESI SELATAN",
    postal_code: "92414",
  },
  {
    city_short: "BANTAENG",
    province: "SULAWESI SELATAN",
    postal_code: "92415",
  },
  {
    city_short: "BANTAENG",
    province: "SULAWESI SELATAN",
    postal_code: "92451",
  },
  {
    city_short: "BANTAENG",
    province: "SULAWESI SELATAN",
    postal_code: "92461",
  },
  {
    city_short: "BULUKUMBA",
    province: "SULAWESI SELATAN",
    postal_code: "92511",
  },
  {
    city_short: "BULUKUMBA",
    province: "SULAWESI SELATAN",
    postal_code: "92513",
  },
  {
    city_short: "BULUKUMBA",
    province: "SULAWESI SELATAN",
    postal_code: "92514",
  },
  {
    city_short: "JENEPONTO",
    province: "SULAWESI SELATAN",
    postal_code: "92516",
  },
  {
    city_short: "BULUKUMBA",
    province: "SULAWESI SELATAN",
    postal_code: "92517",
  },
  {
    city_short: "BULUKUMBA",
    province: "SULAWESI SELATAN",
    postal_code: "92518",
  },
  {
    city_short: "BULUKUMBA",
    province: "SULAWESI SELATAN",
    postal_code: "92552",
  },
  {
    city_short: "BULUKUMBA",
    province: "SULAWESI SELATAN",
    postal_code: "92561",
  },
  {
    city_short: "BULUKUMBA",
    province: "SULAWESI SELATAN",
    postal_code: "92571",
  },
  {
    city_short: "JENEPONTO",
    province: "SULAWESI SELATAN",
    postal_code: "92572",
  },
  {
    city_short: "BULUKUMBA",
    province: "SULAWESI SELATAN",
    postal_code: "92572",
  },
  {
    city_short: "BULUKUMBA",
    province: "SULAWESI SELATAN",
    postal_code: "92573",
  },
  {
    city_short: "BULUKUMBA",
    province: "SULAWESI SELATAN",
    postal_code: "92574",
  },
  {
    city_short: "SINJAI",
    province: "SULAWESI SELATAN",
    postal_code: "92611",
  },
  {
    city_short: "SINJAI",
    province: "SULAWESI SELATAN",
    postal_code: "92612",
  },
  {
    city_short: "SINJAI",
    province: "SULAWESI SELATAN",
    postal_code: "92613",
  },
  {
    city_short: "SINJAI",
    province: "SULAWESI SELATAN",
    postal_code: "92614",
  },
  {
    city_short: "SINJAI",
    province: "SULAWESI SELATAN",
    postal_code: "92615",
  },
  {
    city_short: "SINJAI",
    province: "SULAWESI SELATAN",
    postal_code: "92616",
  },
  {
    city_short: "SINJAI",
    province: "SULAWESI SELATAN",
    postal_code: "92652",
  },
  {
    city_short: "SINJAI",
    province: "SULAWESI SELATAN",
    postal_code: "92653",
  },
  {
    city_short: "SINJAI",
    province: "SULAWESI SELATAN",
    postal_code: "92654",
  },
  {
    city_short: "SINJAI",
    province: "SULAWESI SELATAN",
    postal_code: "92661",
  },
  {
    city_short: "BULUKUMBA",
    province: "SULAWESI SELATAN",
    postal_code: "92661",
  },
  {
    city_short: "SINJAI",
    province: "SULAWESI SELATAN",
    postal_code: "92662",
  },
  {
    city_short: "SINJAI",
    province: "SULAWESI SELATAN",
    postal_code: "92671",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92711",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92712",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92713",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92714",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92715",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92716",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92717",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92718",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92719",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92721",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92731",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92732",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92733",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92734",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92735",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92752",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92753",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92754",
  },
  {
    city_short: "MAROS",
    province: "SULAWESI SELATAN",
    postal_code: "92754",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92755",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92761",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92762",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92763",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92764",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92765",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92766",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92767",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92768",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92771",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92772",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92773",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92774",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92775",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92776",
  },
  {
    city_short: "BONE",
    province: "SULAWESI SELATAN",
    postal_code: "92781",
  },
  {
    city_short: "KEP SELAYAR",
    province: "SULAWESI SELATAN",
    postal_code: "92811",
  },
  {
    city_short: "KEP SELAYAR",
    province: "SULAWESI SELATAN",
    postal_code: "92812",
  },
  {
    city_short: "KEP SELAYAR",
    province: "SULAWESI SELATAN",
    postal_code: "92851",
  },
  {
    city_short: "KEP SELAYAR",
    province: "SULAWESI SELATAN",
    postal_code: "92854",
  },
  {
    city_short: "KEP SELAYAR",
    province: "SULAWESI SELATAN",
    postal_code: "92855",
  },
  {
    city_short: "KEP SELAYAR",
    province: "SULAWESI SELATAN",
    postal_code: "92861",
  },
  {
    city_short: "KEP SELAYAR",
    province: "SULAWESI SELATAN",
    postal_code: "92862",
  },
  {
    city_short: "KEP SELAYAR",
    province: "SULAWESI SELATAN",
    postal_code: "92863",
  },
  {
    city_short: "LUWU UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "92912",
  },
  {
    city_short: "LUWU UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "92913",
  },
  {
    city_short: "LUWU UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "92914",
  },
  {
    city_short: "LUWU UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "92915",
  },
  {
    city_short: "LUWU UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "92916",
  },
  {
    city_short: "LUWU UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "92917",
  },
  {
    city_short: "LUWU TIMUR",
    province: "SULAWESI SELATAN",
    postal_code: "92932",
  },
  {
    city_short: "LUWU TIMUR",
    province: "SULAWESI SELATAN",
    postal_code: "92933",
  },
  {
    city_short: "LUWU TIMUR",
    province: "SULAWESI SELATAN",
    postal_code: "92935",
  },
  {
    city_short: "LUWU TIMUR",
    province: "SULAWESI SELATAN",
    postal_code: "92936",
  },
  {
    city_short: "LUWU TIMUR",
    province: "SULAWESI SELATAN",
    postal_code: "92937",
  },
  {
    city_short: "LUWU UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "92953",
  },
  {
    city_short: "LUWU UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "92954",
  },
  {
    city_short: "LUWU UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "92955",
  },
  {
    city_short: "LUWU UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "92956",
  },
  {
    city_short: "LUWU UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "92957",
  },
  {
    city_short: "LUWU UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "92961",
  },
  {
    city_short: "LUWU UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "92963",
  },
  {
    city_short: "LUWU UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "92964",
  },
  {
    city_short: "LUWU UTARA",
    province: "SULAWESI SELATAN",
    postal_code: "92965",
  },
  {
    city_short: "LUWU TIMUR",
    province: "SULAWESI SELATAN",
    postal_code: "92971",
  },
  {
    city_short: "LUWU TIMUR",
    province: "SULAWESI SELATAN",
    postal_code: "92972",
  },
  {
    city_short: "LUWU TIMUR",
    province: "SULAWESI SELATAN",
    postal_code: "92973",
  },
  {
    city_short: "LUWU TIMUR",
    province: "SULAWESI SELATAN",
    postal_code: "92975",
  },
  {
    city_short: "LUWU TIMUR",
    province: "SULAWESI SELATAN",
    postal_code: "92981",
  },
  {
    city_short: "LUWU TIMUR",
    province: "SULAWESI SELATAN",
    postal_code: "92982",
  },
  {
    city_short: "LUWU TIMUR",
    province: "SULAWESI SELATAN",
    postal_code: "92983",
  },
  {
    city_short: "LUWU TIMUR",
    province: "SULAWESI SELATAN",
    postal_code: "92985",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93111",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93112",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93113",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93114",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93115",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93116",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93117",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93118",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93121",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93122",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93123",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93124",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93125",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93126",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93127",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93128",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93129",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93231",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93232",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93233",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93234",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93235",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93236",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93237",
  },
  {
    city_short: "KENDARI",
    province: "SULAWESI TENGGARA",
    postal_code: "93238",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93351",
  },
  {
    city_short: "KONAWE UTARA",
    province: "SULAWESI TENGGARA",
    postal_code: "93352",
  },
  {
    city_short: "KONAWE UTARA",
    province: "SULAWESI TENGGARA",
    postal_code: "93353",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93353",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93354",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93393",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93395",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93411",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93412",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93413",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93414",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93415",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93416",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93417",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93418",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93419",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93452",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93461",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93463",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93464",
  },
  {
    city_short: "KOLAKA",
    province: "SULAWESI TENGGARA",
    postal_code: "93511",
  },
  {
    city_short: "KOLAKA",
    province: "SULAWESI TENGGARA",
    postal_code: "93512",
  },
  {
    city_short: "KOLAKA",
    province: "SULAWESI TENGGARA",
    postal_code: "93514",
  },
  {
    city_short: "KOLAKA",
    province: "SULAWESI TENGGARA",
    postal_code: "93515",
  },
  {
    city_short: "KOLAKA",
    province: "SULAWESI TENGGARA",
    postal_code: "93517",
  },
  {
    city_short: "KOLAKA",
    province: "SULAWESI TENGGARA",
    postal_code: "93518",
  },
  {
    city_short: "KOLAKA",
    province: "SULAWESI TENGGARA",
    postal_code: "93519",
  },
  {
    city_short: "KOLAKA",
    province: "SULAWESI TENGGARA",
    postal_code: "93552",
  },
  {
    city_short: "KOLAKA",
    province: "SULAWESI TENGGARA",
    postal_code: "93561",
  },
  {
    city_short: "KOLAKA",
    province: "SULAWESI TENGGARA",
    postal_code: "93562",
  },
  {
    city_short: "KOLAKA",
    province: "SULAWESI TENGGARA",
    postal_code: "93563",
  },
  {
    city_short: "KOLAKA",
    province: "SULAWESI TENGGARA",
    postal_code: "93571",
  },
  {
    city_short: "KOLAKA",
    province: "SULAWESI TENGGARA",
    postal_code: "93572",
  },
  {
    city_short: "KOLAKA",
    province: "SULAWESI TENGGARA",
    postal_code: "93573",
  },
  {
    city_short: "KOLAKA",
    province: "SULAWESI TENGGARA",
    postal_code: "93575",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93611",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93612",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93613",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93614",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93615",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93616",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93618",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93652",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93653",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93654",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93655",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93656",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93657",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93658",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93659",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93661",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93662",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93663",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93664",
  },
  {
    city_short: "BUTON UTARA",
    province: "SULAWESI TENGGARA",
    postal_code: "93671",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93671",
  },
  {
    city_short: "BUTON UTARA",
    province: "SULAWESI TENGGARA",
    postal_code: "93672",
  },
  {
    city_short: "BUTON UTARA",
    province: "SULAWESI TENGGARA",
    postal_code: "93673",
  },
  {
    city_short: "MUNA",
    province: "SULAWESI TENGGARA",
    postal_code: "93674",
  },
  {
    city_short: "BAU-BAU",
    province: "SULAWESI TENGGARA",
    postal_code: "93711",
  },
  {
    city_short: "BAU-BAU",
    province: "SULAWESI TENGGARA",
    postal_code: "93712",
  },
  {
    city_short: "BAU-BAU",
    province: "SULAWESI TENGGARA",
    postal_code: "93713",
  },
  {
    city_short: "BAU-BAU",
    province: "SULAWESI TENGGARA",
    postal_code: "93714",
  },
  {
    city_short: "BAU-BAU",
    province: "SULAWESI TENGGARA",
    postal_code: "93715",
  },
  {
    city_short: "BAU-BAU",
    province: "SULAWESI TENGGARA",
    postal_code: "93716",
  },
  {
    city_short: "BAU-BAU",
    province: "SULAWESI TENGGARA",
    postal_code: "93717",
  },
  {
    city_short: "BAU-BAU",
    province: "SULAWESI TENGGARA",
    postal_code: "93719",
  },
  {
    city_short: "BAU-BAU",
    province: "SULAWESI TENGGARA",
    postal_code: "93721",
  },
  {
    city_short: "BAU-BAU",
    province: "SULAWESI TENGGARA",
    postal_code: "93722",
  },
  {
    city_short: "BAU-BAU",
    province: "SULAWESI TENGGARA",
    postal_code: "93724",
  },
  {
    city_short: "BAU-BAU",
    province: "SULAWESI TENGGARA",
    postal_code: "93725",
  },
  {
    city_short: "BAU-BAU",
    province: "SULAWESI TENGGARA",
    postal_code: "93726",
  },
  {
    city_short: "BAU-BAU",
    province: "SULAWESI TENGGARA",
    postal_code: "93727",
  },
  {
    city_short: "BUTON",
    province: "SULAWESI TENGGARA",
    postal_code: "93752",
  },
  {
    city_short: "BUTON",
    province: "SULAWESI TENGGARA",
    postal_code: "93753",
  },
  {
    city_short: "BUTON",
    province: "SULAWESI TENGGARA",
    postal_code: "93754",
  },
  {
    city_short: "BUTON",
    province: "SULAWESI TENGGARA",
    postal_code: "93755",
  },
  {
    city_short: "BUTON",
    province: "SULAWESI TENGGARA",
    postal_code: "93756",
  },
  {
    city_short: "BAU-BAU",
    province: "SULAWESI TENGGARA",
    postal_code: "93757",
  },
  {
    city_short: "BAU-BAU",
    province: "SULAWESI TENGGARA",
    postal_code: "93758",
  },
  {
    city_short: "BUTON",
    province: "SULAWESI TENGGARA",
    postal_code: "93761",
  },
  {
    city_short: "BUTON",
    province: "SULAWESI TENGGARA",
    postal_code: "93762",
  },
  {
    city_short: "BUTON",
    province: "SULAWESI TENGGARA",
    postal_code: "93763",
  },
  {
    city_short: "BOMBANA",
    province: "SULAWESI TENGGARA",
    postal_code: "93771",
  },
  {
    city_short: "KONAWE",
    province: "SULAWESI TENGGARA",
    postal_code: "93771",
  },
  {
    city_short: "BOMBANA",
    province: "SULAWESI TENGGARA",
    postal_code: "93772",
  },
  {
    city_short: "BOMBANA",
    province: "SULAWESI TENGGARA",
    postal_code: "93773",
  },
  {
    city_short: "BOMBANA",
    province: "SULAWESI TENGGARA",
    postal_code: "93774",
  },
  {
    city_short: "BUTON",
    province: "SULAWESI TENGGARA",
    postal_code: "93781",
  },
  {
    city_short: "BOMBANA",
    province: "SULAWESI TENGGARA",
    postal_code: "93781",
  },
  {
    city_short: "BOMBANA",
    province: "SULAWESI TENGGARA",
    postal_code: "93783",
  },
  {
    city_short: "WAKATOBI",
    province: "SULAWESI TENGGARA",
    postal_code: "93791",
  },
  {
    city_short: "WAKATOBI",
    province: "SULAWESI TENGGARA",
    postal_code: "93792",
  },
  {
    city_short: "WAKATOBI",
    province: "SULAWESI TENGGARA",
    postal_code: "93793",
  },
  {
    city_short: "WAKATOBI",
    province: "SULAWESI TENGGARA",
    postal_code: "93794",
  },
  {
    city_short: "WAKATOBI",
    province: "SULAWESI TENGGARA",
    postal_code: "93795",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93811",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93812",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93813",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93814",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93815",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93816",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93818",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93819",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93871",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93873",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93874",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93875",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93881",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93883",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93884",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93885",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93891",
  },
  {
    city_short: "KONAWE SELATAN",
    province: "SULAWESI TENGGARA",
    postal_code: "93892",
  },
  {
    city_short: "KOLAKA UTARA",
    province: "SULAWESI TENGGARA",
    postal_code: "93911",
  },
  {
    city_short: "KOLAKA UTARA",
    province: "SULAWESI TENGGARA",
    postal_code: "93912",
  },
  {
    city_short: "KOLAKA UTARA",
    province: "SULAWESI TENGGARA",
    postal_code: "93913",
  },
  {
    city_short: "KOLAKA UTARA",
    province: "SULAWESI TENGGARA",
    postal_code: "93914",
  },
  {
    city_short: "KOLAKA",
    province: "SULAWESI TENGGARA",
    postal_code: "93915",
  },
  {
    city_short: "KOLAKA UTARA",
    province: "SULAWESI TENGGARA",
    postal_code: "93915",
  },
  {
    city_short: "KOLAKA UTARA",
    province: "SULAWESI TENGGARA",
    postal_code: "93916",
  },
  {
    city_short: "KOLAKA UTARA",
    province: "SULAWESI TENGGARA",
    postal_code: "93954",
  },
  {
    city_short: "KOLAKA UTARA",
    province: "SULAWESI TENGGARA",
    postal_code: "93955",
  },
  {
    city_short: "KOLAKA UTARA",
    province: "SULAWESI TENGGARA",
    postal_code: "93956",
  },
  {
    city_short: "KOLAKA UTARA",
    province: "SULAWESI TENGGARA",
    postal_code: "93957",
  },
  {
    city_short: "KOLAKA UTARA",
    province: "SULAWESI TENGGARA",
    postal_code: "93958",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94111",
  },
  {
    city_short: "SIGI",
    province: "SULAWESI TENGAH",
    postal_code: "94112",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94115",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94116",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94118",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94119",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94141",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94142",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94143",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94145",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94146",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94147",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94148",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94221",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94222",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94223",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94225",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94226",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94227",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94228",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94229",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94231",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94232",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94233",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94234",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94235",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94236",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94237",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94238",
  },
  {
    city_short: "PALU",
    province: "SULAWESI TENGAH",
    postal_code: "94239",
  },
  {
    city_short: "DONGGALA",
    province: "SULAWESI TENGAH",
    postal_code: "94351",
  },
  {
    city_short: "DONGGALA",
    province: "SULAWESI TENGAH",
    postal_code: "94352",
  },
  {
    city_short: "DONGGALA",
    province: "SULAWESI TENGAH",
    postal_code: "94353",
  },
  {
    city_short: "DONGGALA",
    province: "SULAWESI TENGAH",
    postal_code: "94354",
  },
  {
    city_short: "DONGGALA",
    province: "SULAWESI TENGAH",
    postal_code: "94355",
  },
  {
    city_short: "DONGGALA",
    province: "SULAWESI TENGAH",
    postal_code: "94356",
  },
  {
    city_short: "SIGI",
    province: "SULAWESI TENGAH",
    postal_code: "94361",
  },
  {
    city_short: "DONGGALA",
    province: "SULAWESI TENGAH",
    postal_code: "94362",
  },
  {
    city_short: "SIGI",
    province: "SULAWESI TENGAH",
    postal_code: "94362",
  },
  {
    city_short: "SIGI",
    province: "SULAWESI TENGAH",
    postal_code: "94363",
  },
  {
    city_short: "SIGI",
    province: "SULAWESI TENGAH",
    postal_code: "94364",
  },
  {
    city_short: "PARIGI MOUTONG",
    province: "SULAWESI TENGAH",
    postal_code: "94471",
  },
  {
    city_short: "PARIGI MOUTONG",
    province: "SULAWESI TENGAH",
    postal_code: "94473",
  },
  {
    city_short: "PARIGI MOUTONG",
    province: "SULAWESI TENGAH",
    postal_code: "94474",
  },
  {
    city_short: "PARIGI MOUTONG",
    province: "SULAWESI TENGAH",
    postal_code: "94475",
  },
  {
    city_short: "PARIGI MOUTONG",
    province: "SULAWESI TENGAH",
    postal_code: "94476",
  },
  {
    city_short: "PARIGI MOUTONG",
    province: "SULAWESI TENGAH",
    postal_code: "94479",
  },
  {
    city_short: "TOLI-TOLI",
    province: "SULAWESI TENGAH",
    postal_code: "94511",
  },
  {
    city_short: "TOLI-TOLI",
    province: "SULAWESI TENGAH",
    postal_code: "94512",
  },
  {
    city_short: "TOLI-TOLI",
    province: "SULAWESI TENGAH",
    postal_code: "94513",
  },
  {
    city_short: "TOLI-TOLI",
    province: "SULAWESI TENGAH",
    postal_code: "94514",
  },
  {
    city_short: "TOLI-TOLI",
    province: "SULAWESI TENGAH",
    postal_code: "94515",
  },
  {
    city_short: "TOLI-TOLI",
    province: "SULAWESI TENGAH",
    postal_code: "94516",
  },
  {
    city_short: "TOLI-TOLI",
    province: "SULAWESI TENGAH",
    postal_code: "94517",
  },
  {
    city_short: "TOLI-TOLI",
    province: "SULAWESI TENGAH",
    postal_code: "94518",
  },
  {
    city_short: "TOLI-TOLI",
    province: "SULAWESI TENGAH",
    postal_code: "94552",
  },
  {
    city_short: "TOLI-TOLI",
    province: "SULAWESI TENGAH",
    postal_code: "94553",
  },
  {
    city_short: "TOLI-TOLI",
    province: "SULAWESI TENGAH",
    postal_code: "94554",
  },
  {
    city_short: "TOLI-TOLI",
    province: "SULAWESI TENGAH",
    postal_code: "94561",
  },
  {
    city_short: "TOLI-TOLI",
    province: "SULAWESI TENGAH",
    postal_code: "94562",
  },
  {
    city_short: "BUOL",
    province: "SULAWESI TENGAH",
    postal_code: "94563",
  },
  {
    city_short: "BUOL",
    province: "SULAWESI TENGAH",
    postal_code: "94564",
  },
  {
    city_short: "BUOL",
    province: "SULAWESI TENGAH",
    postal_code: "94565",
  },
  {
    city_short: "BUOL",
    province: "SULAWESI TENGAH",
    postal_code: "94566",
  },
  {
    city_short: "BUOL",
    province: "SULAWESI TENGAH",
    postal_code: "94567",
  },
  {
    city_short: "BUOL",
    province: "SULAWESI TENGAH",
    postal_code: "94568",
  },
  {
    city_short: "POSO",
    province: "SULAWESI TENGAH",
    postal_code: "94611",
  },
  {
    city_short: "POSO",
    province: "SULAWESI TENGAH",
    postal_code: "94612",
  },
  {
    city_short: "POSO",
    province: "SULAWESI TENGAH",
    postal_code: "94613",
  },
  {
    city_short: "POSO",
    province: "SULAWESI TENGAH",
    postal_code: "94614",
  },
  {
    city_short: "POSO",
    province: "SULAWESI TENGAH",
    postal_code: "94615",
  },
  {
    city_short: "POSO",
    province: "SULAWESI TENGAH",
    postal_code: "94616",
  },
  {
    city_short: "POSO",
    province: "SULAWESI TENGAH",
    postal_code: "94617",
  },
  {
    city_short: "POSO",
    province: "SULAWESI TENGAH",
    postal_code: "94618",
  },
  {
    city_short: "POSO",
    province: "SULAWESI TENGAH",
    postal_code: "94619",
  },
  {
    city_short: "POSO",
    province: "SULAWESI TENGAH",
    postal_code: "94652",
  },
  {
    city_short: "POSO",
    province: "SULAWESI TENGAH",
    postal_code: "94653",
  },
  {
    city_short: "POSO",
    province: "SULAWESI TENGAH",
    postal_code: "94654",
  },
  {
    city_short: "POSO",
    province: "SULAWESI TENGAH",
    postal_code: "94661",
  },
  {
    city_short: "POSO",
    province: "SULAWESI TENGAH",
    postal_code: "94663",
  },
  {
    city_short: "POSO",
    province: "SULAWESI TENGAH",
    postal_code: "94664",
  },
  {
    city_short: "TOJO UNA-UNA",
    province: "SULAWESI TENGAH",
    postal_code: "94681",
  },
  {
    city_short: "TOJO UNA-UNA",
    province: "SULAWESI TENGAH",
    postal_code: "94682",
  },
  {
    city_short: "TOJO UNA-UNA",
    province: "SULAWESI TENGAH",
    postal_code: "94683",
  },
  {
    city_short: "TOJO UNA-UNA",
    province: "SULAWESI TENGAH",
    postal_code: "94684",
  },
  {
    city_short: "TOJO UNA-UNA",
    province: "SULAWESI TENGAH",
    postal_code: "94691",
  },
  {
    city_short: "TOJO UNA-UNA",
    province: "SULAWESI TENGAH",
    postal_code: "94692",
  },
  {
    city_short: "BANGGAI",
    province: "SULAWESI TENGAH",
    postal_code: "94711",
  },
  {
    city_short: "BANGGAI",
    province: "SULAWESI TENGAH",
    postal_code: "94712",
  },
  {
    city_short: "BANGGAI",
    province: "SULAWESI TENGAH",
    postal_code: "94713",
  },
  {
    city_short: "BANGGAI KEP",
    province: "SULAWESI TENGAH",
    postal_code: "94714",
  },
  {
    city_short: "BANGGAI",
    province: "SULAWESI TENGAH",
    postal_code: "94717",
  },
  {
    city_short: "BANGGAI",
    province: "SULAWESI TENGAH",
    postal_code: "94723",
  },
  {
    city_short: "BANGGAI",
    province: "SULAWESI TENGAH",
    postal_code: "94752",
  },
  {
    city_short: "BANGGAI",
    province: "SULAWESI TENGAH",
    postal_code: "94753",
  },
  {
    city_short: "BANGGAI",
    province: "SULAWESI TENGAH",
    postal_code: "94761",
  },
  {
    city_short: "BANGGAI",
    province: "SULAWESI TENGAH",
    postal_code: "94762",
  },
  {
    city_short: "BANGGAI",
    province: "SULAWESI TENGAH",
    postal_code: "94765",
  },
  {
    city_short: "BANGGAI",
    province: "SULAWESI TENGAH",
    postal_code: "94771",
  },
  {
    city_short: "BANGGAI",
    province: "SULAWESI TENGAH",
    postal_code: "94772",
  },
  {
    city_short: "BANGGAI",
    province: "SULAWESI TENGAH",
    postal_code: "94773",
  },
  {
    city_short: "BANGGAI KEP",
    province: "SULAWESI TENGAH",
    postal_code: "94881",
  },
  {
    city_short: "BANGGAI KEP",
    province: "SULAWESI TENGAH",
    postal_code: "94882",
  },
  {
    city_short: "BANGGAI KEP",
    province: "SULAWESI TENGAH",
    postal_code: "94883",
  },
  {
    city_short: "BANGGAI KEP",
    province: "SULAWESI TENGAH",
    postal_code: "94884",
  },
  {
    city_short: "BANGGAI KEP",
    province: "SULAWESI TENGAH",
    postal_code: "94885",
  },
  {
    city_short: "BANGGAI KEP",
    province: "SULAWESI TENGAH",
    postal_code: "94891",
  },
  {
    city_short: "BANGGAI KEP",
    province: "SULAWESI TENGAH",
    postal_code: "94892",
  },
  {
    city_short: "MOROWALI",
    province: "SULAWESI TENGAH",
    postal_code: "94965",
  },
  {
    city_short: "MOROWALI",
    province: "SULAWESI TENGAH",
    postal_code: "94966",
  },
  {
    city_short: "MOROWALI",
    province: "SULAWESI TENGAH",
    postal_code: "94971",
  },
  {
    city_short: "MOROWALI",
    province: "SULAWESI TENGAH",
    postal_code: "94972",
  },
  {
    city_short: "MOROWALI",
    province: "SULAWESI TENGAH",
    postal_code: "94973",
  },
  {
    city_short: "MOROWALI",
    province: "SULAWESI TENGAH",
    postal_code: "94974",
  },
  {
    city_short: "MOROWALI",
    province: "SULAWESI TENGAH",
    postal_code: "94975",
  },
  {
    city_short: "MOROWALI",
    province: "SULAWESI TENGAH",
    postal_code: "94976",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95111",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95112",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95113",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95114",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95115",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95116",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95117",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95118",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95119",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95121",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95122",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95123",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95124",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95125",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95126",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95127",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95128",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95129",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95161",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95162",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95163",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95231",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95232",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95234",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95238",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95239",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95246",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95249",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95251",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95252",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95253",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95254",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95256",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95257",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95258",
  },
  {
    city_short: "MANADO",
    province: "SULAWESI UTARA",
    postal_code: "95259",
  },
  {
    city_short: "MINAHASA SEL",
    province: "SULAWESI UTARA",
    postal_code: "95352",
  },
  {
    city_short: "MINAHASA SEL",
    province: "SULAWESI UTARA",
    postal_code: "95355",
  },
  {
    city_short: "MINAHASA SEL",
    province: "SULAWESI UTARA",
    postal_code: "95357",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95371",
  },
  {
    city_short: "MINAHASA UTARA",
    province: "SULAWESI UTARA",
    postal_code: "95371",
  },
  {
    city_short: "MINAHASA UTARA",
    province: "SULAWESI UTARA",
    postal_code: "95372",
  },
  {
    city_short: "MINAHASA UTARA",
    province: "SULAWESI UTARA",
    postal_code: "95373",
  },
  {
    city_short: "MINAHASA UTARA",
    province: "SULAWESI UTARA",
    postal_code: "95375",
  },
  {
    city_short: "MINAHASA UTARA",
    province: "SULAWESI UTARA",
    postal_code: "95376",
  },
  {
    city_short: "MINAHASA UTARA",
    province: "SULAWESI UTARA",
    postal_code: "95377",
  },
  {
    city_short: "MINAHASA UTARA",
    province: "SULAWESI UTARA",
    postal_code: "95378",
  },
  {
    city_short: "MINAHASA UTARA",
    province: "SULAWESI UTARA",
    postal_code: "95379",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95411",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95412",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95413",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95414",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95415",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95416",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95417",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95418",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95419",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95421",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95422",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95423",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95424",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95425",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95431",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95432",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95433",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95434",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95435",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95436",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95437",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95438",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95439",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95441",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95442",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95443",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95444",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95445",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95446",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95447",
  },
  {
    city_short: "TOMOHON",
    province: "SULAWESI UTARA",
    postal_code: "95449",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95511",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95512",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95513",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95514",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95515",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95516",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95521",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95522",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95523",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95524",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95525",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95526",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95527",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95528",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95529",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95531",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95532",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95533",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95535",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95536",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95537",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95538",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95539",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95541",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95542",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95543",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95544",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95545",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95546",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95547",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95551",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95552",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95553",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95554",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95555",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95556",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95557",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95558",
  },
  {
    city_short: "BITUNG",
    province: "SULAWESI UTARA",
    postal_code: "95559",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95611",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95612",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95613",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95614",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95615",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95616",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95617",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95618",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95619",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95651",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95661",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95681",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95682",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95683",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95684",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95691",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95692",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95693",
  },
  {
    city_short: "MINAHASA",
    province: "SULAWESI UTARA",
    postal_code: "95694",
  },
  {
    city_short: "KOTAMOBAGU",
    province: "SULAWESI UTARA",
    postal_code: "95711",
  },
  {
    city_short: "KOTAMOBAGU",
    province: "SULAWESI UTARA",
    postal_code: "95712",
  },
  {
    city_short: "KOTAMOBAGU",
    province: "SULAWESI UTARA",
    postal_code: "95713",
  },
  {
    city_short: "KOTAMOBAGU",
    province: "SULAWESI UTARA",
    postal_code: "95714",
  },
  {
    city_short: "KOTAMOBAGU",
    province: "SULAWESI UTARA",
    postal_code: "95715",
  },
  {
    city_short: "KOTAMOBAGU",
    province: "SULAWESI UTARA",
    postal_code: "95716",
  },
  {
    city_short: "KOTAMOBAGU",
    province: "SULAWESI UTARA",
    postal_code: "95717",
  },
  {
    city_short: "KOTAMOBAGU",
    province: "SULAWESI UTARA",
    postal_code: "95718",
  },
  {
    city_short: "KOTAMOBAGU",
    province: "SULAWESI UTARA",
    postal_code: "95719",
  },
  {
    city_short: "BOLMONG",
    province: "SULAWESI UTARA",
    postal_code: "95751",
  },
  {
    city_short: "BOLMONG",
    province: "SULAWESI UTARA",
    postal_code: "95752",
  },
  {
    city_short: "BOLMONG",
    province: "SULAWESI UTARA",
    postal_code: "95753",
  },
  {
    city_short: "BOLMONG",
    province: "SULAWESI UTARA",
    postal_code: "95761",
  },
  {
    city_short: "BOLMONG UTARA",
    province: "SULAWESI UTARA",
    postal_code: "95762",
  },
  {
    city_short: "BOLMONG",
    province: "SULAWESI UTARA",
    postal_code: "95762",
  },
  {
    city_short: "BOLMONG UTARA",
    province: "SULAWESI UTARA",
    postal_code: "95763",
  },
  {
    city_short: "BOLMONG UTARA",
    province: "SULAWESI UTARA",
    postal_code: "95764",
  },
  {
    city_short: "BOLMONG UTARA",
    province: "SULAWESI UTARA",
    postal_code: "95765",
  },
  {
    city_short: "BOLMONG",
    province: "SULAWESI UTARA",
    postal_code: "95771",
  },
  {
    city_short: "BOLMONG",
    province: "SULAWESI UTARA",
    postal_code: "95772",
  },
  {
    city_short: "BOLMONG",
    province: "SULAWESI UTARA",
    postal_code: "95773",
  },
  {
    city_short: "BOLMONG SELATAN",
    province: "SULAWESI UTARA",
    postal_code: "95774",
  },
  {
    city_short: "BOLMONG SELATAN",
    province: "SULAWESI UTARA",
    postal_code: "95775",
  },
  {
    city_short: "BOLMONG TIMUR",
    province: "SULAWESI UTARA",
    postal_code: "95775",
  },
  {
    city_short: "BOLMONG TIMUR",
    province: "SULAWESI UTARA",
    postal_code: "95781",
  },
  {
    city_short: "BOLMONG TIMUR",
    province: "SULAWESI UTARA",
    postal_code: "95782",
  },
  {
    city_short: "KEP SANGIHE",
    province: "SULAWESI UTARA",
    postal_code: "95811",
  },
  {
    city_short: "KEP SANGIHE",
    province: "SULAWESI UTARA",
    postal_code: "95812",
  },
  {
    city_short: "KEP SANGIHE",
    province: "SULAWESI UTARA",
    postal_code: "95813",
  },
  {
    city_short: "KEP SANGIHE",
    province: "SULAWESI UTARA",
    postal_code: "95814",
  },
  {
    city_short: "KEP SANGIHE",
    province: "SULAWESI UTARA",
    postal_code: "95815",
  },
  {
    city_short: "KEP SANGIHE",
    province: "SULAWESI UTARA",
    postal_code: "95816",
  },
  {
    city_short: "KEP SANGIHE",
    province: "SULAWESI UTARA",
    postal_code: "95817",
  },
  {
    city_short: "KEP SANGIHE",
    province: "SULAWESI UTARA",
    postal_code: "95818",
  },
  {
    city_short: "KEP SANGIHE",
    province: "SULAWESI UTARA",
    postal_code: "95852",
  },
  {
    city_short: "KEP SANGIHE",
    province: "SULAWESI UTARA",
    postal_code: "95853",
  },
  {
    city_short: "KEP SANGIHE",
    province: "SULAWESI UTARA",
    postal_code: "95854",
  },
  {
    city_short: "KEP SANGIHE",
    province: "SULAWESI UTARA",
    postal_code: "95855",
  },
  {
    city_short: "KEP SANGIHE",
    province: "SULAWESI UTARA",
    postal_code: "95856",
  },
  {
    city_short: "KEP SANGIHE",
    province: "SULAWESI UTARA",
    postal_code: "95857",
  },
  {
    city_short: "KEP SANGIHE",
    province: "SULAWESI UTARA",
    postal_code: "95858",
  },
  {
    city_short: "KEP SITARO",
    province: "SULAWESI UTARA",
    postal_code: "95861",
  },
  {
    city_short: "KEP SITARO",
    province: "SULAWESI UTARA",
    postal_code: "95862",
  },
  {
    city_short: "KEP SITARO",
    province: "SULAWESI UTARA",
    postal_code: "95863",
  },
  {
    city_short: "KEP SITARO",
    province: "SULAWESI UTARA",
    postal_code: "95864",
  },
  {
    city_short: "KEP TALAUD",
    province: "SULAWESI UTARA",
    postal_code: "95871",
  },
  {
    city_short: "KEP TALAUD",
    province: "SULAWESI UTARA",
    postal_code: "95872",
  },
  {
    city_short: "KEP TALAUD",
    province: "SULAWESI UTARA",
    postal_code: "95881",
  },
  {
    city_short: "KEP TALAUD",
    province: "SULAWESI UTARA",
    postal_code: "95882",
  },
  {
    city_short: "KEP TALAUD",
    province: "SULAWESI UTARA",
    postal_code: "95883",
  },
  {
    city_short: "KEP TALAUD",
    province: "SULAWESI UTARA",
    postal_code: "95884",
  },
  {
    city_short: "KEP TALAUD",
    province: "SULAWESI UTARA",
    postal_code: "95885",
  },
  {
    city_short: "MINAHASA SEL",
    province: "SULAWESI UTARA",
    postal_code: "95953",
  },
  {
    city_short: "MINAHASA SEL",
    province: "SULAWESI UTARA",
    postal_code: "95954",
  },
  {
    city_short: "MINAHASA SEL",
    province: "SULAWESI UTARA",
    postal_code: "95955",
  },
  {
    city_short: "MINAHASA SEL",
    province: "SULAWESI UTARA",
    postal_code: "95956",
  },
  {
    city_short: "MINAHASA SEL",
    province: "SULAWESI UTARA",
    postal_code: "95958",
  },
  {
    city_short: "MINAHASA SEL",
    province: "SULAWESI UTARA",
    postal_code: "95959",
  },
  {
    city_short: "MINAHASA TENG",
    province: "SULAWESI UTARA",
    postal_code: "95995",
  },
  {
    city_short: "MINAHASA TENG",
    province: "SULAWESI UTARA",
    postal_code: "95996",
  },
  {
    city_short: "MINAHASA TENG",
    province: "SULAWESI UTARA",
    postal_code: "95997",
  },
  {
    city_short: "MINAHASA TENG",
    province: "SULAWESI UTARA",
    postal_code: "95998",
  },
  {
    city_short: "MINAHASA SEL",
    province: "SULAWESI UTARA",
    postal_code: "95999",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96111",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96112",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96113",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96114",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96115",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96116",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96117",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96118",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96119",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96121",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96122",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96123",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96124",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96125",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96126",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96127",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96128",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96129",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96131",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96132",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96133",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96134",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96135",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96136",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96137",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96138",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96139",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96181",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96211",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96212",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96213",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96214",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96215",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96216",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96217",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96218",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96219",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96251",
  },
  {
    city_short: "GORONTALO UTARA",
    province: "GORONTALO",
    postal_code: "96252",
  },
  {
    city_short: "GORONTALO UTARA",
    province: "GORONTALO",
    postal_code: "96253",
  },
  {
    city_short: "GORONTALO UTARA",
    province: "GORONTALO",
    postal_code: "96254",
  },
  {
    city_short: "BOALEMO",
    province: "GORONTALO",
    postal_code: "96261",
  },
  {
    city_short: "BOALEMO",
    province: "GORONTALO",
    postal_code: "96262",
  },
  {
    city_short: "BOALEMO",
    province: "GORONTALO",
    postal_code: "96263",
  },
  {
    city_short: "BOALEMO",
    province: "GORONTALO",
    postal_code: "96264",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96264",
  },
  {
    city_short: "POHUWATO",
    province: "GORONTALO",
    postal_code: "96265",
  },
  {
    city_short: "BOALEMO",
    province: "GORONTALO",
    postal_code: "96265",
  },
  {
    city_short: "POHUWATO",
    province: "GORONTALO",
    postal_code: "96266",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96271",
  },
  {
    city_short: "GORONTALO",
    province: "GORONTALO",
    postal_code: "96272",
  },
  {
    city_short: "POLEWALI MANDAR",
    province: "GORONTALO",
    postal_code: "96365",
  },
  {
    city_short: "POHUWATO",
    province: "GORONTALO",
    postal_code: "96466",
  },
  {
    city_short: "POHUWATO",
    province: "GORONTALO",
    postal_code: "96467",
  },
  {
    city_short: "POHUWATO",
    province: "GORONTALO",
    postal_code: "96468",
  },
  {
    city_short: "POHUWATO",
    province: "GORONTALO",
    postal_code: "96469",
  },
  {
    city_short: "GORONTALO UTARA",
    province: "GORONTALO",
    postal_code: "96524",
  },
  {
    city_short: "GORONTALO UTARA",
    province: "GORONTALO",
    postal_code: "96525",
  },
  {
    city_short: "BONE BOLANGO",
    province: "GORONTALO",
    postal_code: "96582",
  },
  {
    city_short: "BONE BOLANGO",
    province: "GORONTALO",
    postal_code: "96583",
  },
  {
    city_short: "BONE BOLANGO",
    province: "GORONTALO",
    postal_code: "96584",
  },
  {
    city_short: "BONE BOLANGO",
    province: "GORONTALO",
    postal_code: "96585",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97111",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97112",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97113",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97114",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97115",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97116",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97117",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97118",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97121",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97122",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97123",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97124",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97125",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97126",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97127",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97128",
  },
  {
    city_short: "MALUKU BD",
    province: "MALUKU",
    postal_code: "97128",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97129",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97231",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97232",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97233",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97234",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97235",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97236",
  },
  {
    city_short: "AMBON",
    province: "MALUKU",
    postal_code: "97237",
  },
  {
    city_short: "MALUKU BD",
    province: "MALUKU",
    postal_code: "97452",
  },
  {
    city_short: "KEP TANIMBAR",
    province: "MALUKU",
    postal_code: "97453",
  },
  {
    city_short: "MALUKU BD",
    province: "MALUKU",
    postal_code: "97454",
  },
  {
    city_short: "KEP TANIMBAR",
    province: "MALUKU",
    postal_code: "97463",
  },
  {
    city_short: "KEP TANIMBAR",
    province: "MALUKU",
    postal_code: "97464",
  },
  {
    city_short: "MALUKU TENGAH",
    province: "MALUKU",
    postal_code: "97511",
  },
  {
    city_short: "MALUKU TENGAH",
    province: "MALUKU",
    postal_code: "97512",
  },
  {
    city_short: "BURU SELATAN",
    province: "MALUKU",
    postal_code: "97512",
  },
  {
    city_short: "MALUKU TENGAH",
    province: "MALUKU",
    postal_code: "97513",
  },
  {
    city_short: "MALUKU TENGAH",
    province: "MALUKU",
    postal_code: "97514",
  },
  {
    city_short: "MALUKU TENGAH",
    province: "MALUKU",
    postal_code: "97515",
  },
  {
    city_short: "MALUKU TENGAH",
    province: "MALUKU",
    postal_code: "97516",
  },
  {
    city_short: "MALUKU TENGAH",
    province: "MALUKU",
    postal_code: "97553",
  },
  {
    city_short: "SERAM BAG TIMUR",
    province: "MALUKU",
    postal_code: "97554",
  },
  {
    city_short: "SERAM BAG TIMUR",
    province: "MALUKU",
    postal_code: "97555",
  },
  {
    city_short: "MALUKU TENGAH",
    province: "MALUKU",
    postal_code: "97557",
  },
  {
    city_short: "MALUKU TENGAH",
    province: "MALUKU",
    postal_code: "97558",
  },
  {
    city_short: "SERAM BAG BARAT",
    province: "MALUKU",
    postal_code: "97561",
  },
  {
    city_short: "SERAM BAG BARAT",
    province: "MALUKU",
    postal_code: "97562",
  },
  {
    city_short: "SERAM BAG BARAT",
    province: "MALUKU",
    postal_code: "97566",
  },
  {
    city_short: "SERAM BAG BARAT",
    province: "MALUKU",
    postal_code: "97567",
  },
  {
    city_short: "BURU",
    province: "MALUKU",
    postal_code: "97571",
  },
  {
    city_short: "BURU SELATAN",
    province: "MALUKU",
    postal_code: "97572",
  },
  {
    city_short: "BURU",
    province: "MALUKU",
    postal_code: "97572",
  },
  {
    city_short: "BURU SELATAN",
    province: "MALUKU",
    postal_code: "97573",
  },
  {
    city_short: "BURU",
    province: "MALUKU",
    postal_code: "97574",
  },
  {
    city_short: "BURU SELATAN",
    province: "MALUKU",
    postal_code: "97574",
  },
  {
    city_short: "MALUKU TENGAH",
    province: "MALUKU",
    postal_code: "97581",
  },
  {
    city_short: "MALUKU TENGAH",
    province: "MALUKU",
    postal_code: "97582",
  },
  {
    city_short: "MALUKU TENGAH",
    province: "MALUKU",
    postal_code: "97591",
  },
  {
    city_short: "MALUKU TENGAH",
    province: "MALUKU",
    postal_code: "97592",
  },
  {
    city_short: "MALUKU TENGAH",
    province: "MALUKU",
    postal_code: "97593",
  },
  {
    city_short: "SERAM BAG TIMUR",
    province: "MALUKU",
    postal_code: "97594",
  },
  {
    city_short: "SERAM BAG TIMUR",
    province: "MALUKU",
    postal_code: "97595",
  },
  {
    city_short: "SERAM BAG TIMUR",
    province: "MALUKU",
    postal_code: "97596",
  },
  {
    city_short: "SERAM BAG TIMUR",
    province: "MALUKU",
    postal_code: "97597",
  },
  {
    city_short: "SERAM BAG TIMUR",
    province: "MALUKU",
    postal_code: "97598",
  },
  {
    city_short: "SERAM BAG TIMUR",
    province: "MALUKU",
    postal_code: "97599",
  },
  {
    city_short: "MALUKU TENGGARA",
    province: "MALUKU",
    postal_code: "97611",
  },
  {
    city_short: "TUAL",
    province: "MALUKU",
    postal_code: "97611",
  },
  {
    city_short: "MALUKU TENGGARA",
    province: "MALUKU",
    postal_code: "97615",
  },
  {
    city_short: "MALUKU BD",
    province: "MALUKU",
    postal_code: "97652",
  },
  {
    city_short: "TUAL",
    province: "MALUKU",
    postal_code: "97652",
  },
  {
    city_short: "MALUKU TENGGARA",
    province: "MALUKU",
    postal_code: "97661",
  },
  {
    city_short: "KEPULAUAN ARU",
    province: "MALUKU",
    postal_code: "97662",
  },
  {
    city_short: "KEPULAUAN ARU",
    province: "MALUKU",
    postal_code: "97663",
  },
  {
    city_short: "KEPULAUAN ARU",
    province: "MALUKU",
    postal_code: "97664",
  },
  {
    city_short: "KEPULAUAN ARU",
    province: "MALUKU",
    postal_code: "97665",
  },
  {
    city_short: "KEPULAUAN ARU",
    province: "MALUKU",
    postal_code: "97666",
  },
  {
    city_short: "KEPULAUAN ARU",
    province: "MALUKU",
    postal_code: "97667",
  },
  {
    city_short: "KEPULAUAN ARU",
    province: "MALUKU",
    postal_code: "97668",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97711",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97712",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97713",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97714",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97715",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97716",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97717",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97718",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97719",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97721",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97722",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97723",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97724",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97725",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97726",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97727",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97728",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97729",
  },
  {
    city_short: "TERNATE",
    province: "MALUKU UTARA",
    postal_code: "97751",
  },
  {
    city_short: "HALMAHERA BARAT",
    province: "MALUKU UTARA",
    postal_code: "97752",
  },
  {
    city_short: "HALMAHERA UTARA",
    province: "MALUKU UTARA",
    postal_code: "97752",
  },
  {
    city_short: "HALMAHERA BARAT",
    province: "MALUKU UTARA",
    postal_code: "97753",
  },
  {
    city_short: "HALMAHERA BARAT",
    province: "MALUKU UTARA",
    postal_code: "97754",
  },
  {
    city_short: "HALMAHERA UTARA",
    province: "MALUKU UTARA",
    postal_code: "97755",
  },
  {
    city_short: "HALMAHERA BARAT",
    province: "MALUKU UTARA",
    postal_code: "97755",
  },
  {
    city_short: "HALMAHERA SEL",
    province: "MALUKU UTARA",
    postal_code: "97756",
  },
  {
    city_short: "HALMAHERA UTARA",
    province: "MALUKU UTARA",
    postal_code: "97761",
  },
  {
    city_short: "HALMAHERA UTARA",
    province: "MALUKU UTARA",
    postal_code: "97762",
  },
  {
    city_short: "HALMAHERA UTARA",
    province: "MALUKU UTARA",
    postal_code: "97764",
  },
  {
    city_short: "PULAU MOROTAI",
    province: "MALUKU UTARA",
    postal_code: "97771",
  },
  {
    city_short: "PULAU MOROTAI",
    province: "MALUKU UTARA",
    postal_code: "97772",
  },
  {
    city_short: "PULAU MOROTAI",
    province: "MALUKU UTARA",
    postal_code: "97773",
  },
  {
    city_short: "PULAU MOROTAI",
    province: "MALUKU UTARA",
    postal_code: "97774",
  },
  {
    city_short: "PULAU MOROTAI",
    province: "MALUKU UTARA",
    postal_code: "97775",
  },
  {
    city_short: "PULAU MOROTAI",
    province: "MALUKU UTARA",
    postal_code: "97776",
  },
  {
    city_short: "PULAU MOROTAI",
    province: "MALUKU UTARA",
    postal_code: "97777",
  },
  {
    city_short: "HALMAHERA SEL",
    province: "MALUKU UTARA",
    postal_code: "97781",
  },
  {
    city_short: "HALMAHERA SEL",
    province: "MALUKU UTARA",
    postal_code: "97782",
  },
  {
    city_short: "HALMAHERA SEL",
    province: "MALUKU UTARA",
    postal_code: "97783",
  },
  {
    city_short: "HALMAHERA SEL",
    province: "MALUKU UTARA",
    postal_code: "97791",
  },
  {
    city_short: "HALMAHERA SEL",
    province: "MALUKU UTARA",
    postal_code: "97792",
  },
  {
    city_short: "KEPULAUAN SULA",
    province: "MALUKU UTARA",
    postal_code: "97792",
  },
  {
    city_short: "KEPULAUAN SULA",
    province: "MALUKU UTARA",
    postal_code: "97793",
  },
  {
    city_short: "KEPULAUAN SULA",
    province: "MALUKU UTARA",
    postal_code: "97794",
  },
  {
    city_short: "KEPULAUAN SULA",
    province: "MALUKU UTARA",
    postal_code: "97795",
  },
  {
    city_short: "TIDORE KEP",
    province: "MALUKU UTARA",
    postal_code: "97811",
  },
  {
    city_short: "TIDORE KEP",
    province: "MALUKU UTARA",
    postal_code: "97812",
  },
  {
    city_short: "TIDORE KEP",
    province: "MALUKU UTARA",
    postal_code: "97813",
  },
  {
    city_short: "TIDORE KEP",
    province: "MALUKU UTARA",
    postal_code: "97852",
  },
  {
    city_short: "HALMAHERA TENG",
    province: "MALUKU UTARA",
    postal_code: "97853",
  },
  {
    city_short: "HALMAHERA TENG",
    province: "MALUKU UTARA",
    postal_code: "97854",
  },
  {
    city_short: "HALMAHERA TIMUR",
    province: "MALUKU UTARA",
    postal_code: "97862",
  },
  {
    city_short: "HALMAHERA TIMUR",
    province: "MALUKU UTARA",
    postal_code: "97863",
  },
  {
    city_short: "BIAK NUMFOR",
    province: "PAPUA BARAT",
    postal_code: "98111",
  },
  {
    city_short: "BIAK NUMFOR",
    province: "PAPUA BARAT",
    postal_code: "98112",
  },
  {
    city_short: "BIAK NUMFOR",
    province: "PAPUA BARAT",
    postal_code: "98113",
  },
  {
    city_short: "BIAK NUMFOR",
    province: "PAPUA BARAT",
    postal_code: "98114",
  },
  {
    city_short: "BIAK NUMFOR",
    province: "PAPUA BARAT",
    postal_code: "98115",
  },
  {
    city_short: "BIAK NUMFOR",
    province: "PAPUA BARAT",
    postal_code: "98116",
  },
  {
    city_short: "BIAK NUMFOR",
    province: "PAPUA BARAT",
    postal_code: "98118",
  },
  {
    city_short: "BIAK NUMFOR",
    province: "PAPUA BARAT",
    postal_code: "98119",
  },
  {
    city_short: "BIAK NUMFOR",
    province: "PAPUA BARAT",
    postal_code: "98152",
  },
  {
    city_short: "BIAK NUMFOR",
    province: "PAPUA BARAT",
    postal_code: "98153",
  },
  {
    city_short: "BIAK NUMFOR",
    province: "PAPUA BARAT",
    postal_code: "98154",
  },
  {
    city_short: "BIAK NUMFOR",
    province: "PAPUA BARAT",
    postal_code: "98155",
  },
  {
    city_short: "BIAK NUMFOR",
    province: "PAPUA BARAT",
    postal_code: "98156",
  },
  {
    city_short: "BIAK NUMFOR",
    province: "PAPUA BARAT",
    postal_code: "98157",
  },
  {
    city_short: "BIAK NUMFOR",
    province: "PAPUA BARAT",
    postal_code: "98158",
  },
  {
    city_short: "SUPIORI",
    province: "PAPUA BARAT",
    postal_code: "98161",
  },
  {
    city_short: "SUPIORI",
    province: "PAPUA BARAT",
    postal_code: "98162",
  },
  {
    city_short: "BIAK NUMFOR",
    province: "PAPUA BARAT",
    postal_code: "98171",
  },
  {
    city_short: "BIAK NUMFOR",
    province: "PAPUA BARAT",
    postal_code: "98172",
  },
  {
    city_short: "KEP YAPEN",
    province: "PAPUA BARAT",
    postal_code: "98211",
  },
  {
    city_short: "KEP YAPEN",
    province: "PAPUA BARAT",
    postal_code: "98212",
  },
  {
    city_short: "KEP YAPEN",
    province: "PAPUA BARAT",
    postal_code: "98213",
  },
  {
    city_short: "KEP YAPEN",
    province: "PAPUA BARAT",
    postal_code: "98214",
  },
  {
    city_short: "KEP YAPEN",
    province: "PAPUA BARAT",
    postal_code: "98215",
  },
  {
    city_short: "KEP YAPEN",
    province: "PAPUA BARAT",
    postal_code: "98252",
  },
  {
    city_short: "KEP YAPEN",
    province: "PAPUA BARAT",
    postal_code: "98253",
  },
  {
    city_short: "KEP YAPEN",
    province: "PAPUA BARAT",
    postal_code: "98254",
  },
  {
    city_short: "KEP YAPEN",
    province: "PAPUA BARAT",
    postal_code: "98255",
  },
  {
    city_short: "WAROPEN",
    province: "PAPUA BARAT",
    postal_code: "98261",
  },
  {
    city_short: "WAROPEN",
    province: "PAPUA BARAT",
    postal_code: "98262",
  },
  {
    city_short: "MAMBERAMO RAYA",
    province: "PAPUA BARAT",
    postal_code: "98262",
  },
  {
    city_short: "WAROPEN",
    province: "PAPUA BARAT",
    postal_code: "98263",
  },
  {
    city_short: "MANOKWARI",
    province: "PAPUA BARAT",
    postal_code: "98311",
  },
  {
    city_short: "MANOKWARI",
    province: "PAPUA BARAT",
    postal_code: "98312",
  },
  {
    city_short: "MANOKWARI",
    province: "PAPUA BARAT",
    postal_code: "98313",
  },
  {
    city_short: "MANOKWARI",
    province: "PAPUA BARAT",
    postal_code: "98314",
  },
  {
    city_short: "MANOKWARI",
    province: "PAPUA BARAT",
    postal_code: "98315",
  },
  {
    city_short: "PEG ARFAK",
    province: "PAPUA BARAT",
    postal_code: "98315",
  },
  {
    city_short: "MANOKWARI",
    province: "PAPUA BARAT",
    postal_code: "98352",
  },
  {
    city_short: "PEG ARFAK",
    province: "PAPUA BARAT",
    postal_code: "98352",
  },
  {
    city_short: "MANOKWARI SEL",
    province: "PAPUA BARAT",
    postal_code: "98353",
  },
  {
    city_short: "MANOKWARI",
    province: "PAPUA BARAT",
    postal_code: "98354",
  },
  {
    city_short: "PEG ARFAK",
    province: "PAPUA BARAT",
    postal_code: "98354",
  },
  {
    city_short: "MANOKWARI SEL",
    province: "PAPUA BARAT",
    postal_code: "98355",
  },
  {
    city_short: "MANOKWARI",
    province: "PAPUA BARAT",
    postal_code: "98356",
  },
  {
    city_short: "MANOKWARI",
    province: "PAPUA BARAT",
    postal_code: "98357",
  },
  {
    city_short: "PEG ARFAK",
    province: "PAPUA BARAT",
    postal_code: "98357",
  },
  {
    city_short: "PEG ARFAK",
    province: "PAPUA BARAT",
    postal_code: "98358",
  },
  {
    city_short: "PEG ARFAK",
    province: "PAPUA BARAT",
    postal_code: "98359",
  },
  {
    city_short: "MANOKWARI SEL",
    province: "PAPUA BARAT",
    postal_code: "98359",
  },
  {
    city_short: "TELUK WONDAMA",
    province: "PAPUA BARAT",
    postal_code: "98361",
  },
  {
    city_short: "TELUK WONDAMA",
    province: "PAPUA BARAT",
    postal_code: "98362",
  },
  {
    city_short: "TELUK BINTUNI",
    province: "PAPUA BARAT",
    postal_code: "98363",
  },
  {
    city_short: "TELUK BINTUNI",
    province: "PAPUA BARAT",
    postal_code: "98364",
  },
  {
    city_short: "TELUK BINTUNI",
    province: "PAPUA BARAT",
    postal_code: "98365",
  },
  {
    city_short: "TAMBRAUW",
    province: "PAPUA BARAT",
    postal_code: "98371",
  },
  {
    city_short: "TAMBRAUW",
    province: "PAPUA BARAT",
    postal_code: "98372",
  },
  {
    city_short: "TELUK BINTUNI",
    province: "PAPUA BARAT",
    postal_code: "98373",
  },
  {
    city_short: "SORONG",
    province: "PAPUA BARAT",
    postal_code: "98411",
  },
  {
    city_short: "SORONG",
    province: "PAPUA BARAT",
    postal_code: "98412",
  },
  {
    city_short: "SORONG",
    province: "PAPUA BARAT",
    postal_code: "98413",
  },
  {
    city_short: "SORONG",
    province: "PAPUA BARAT",
    postal_code: "98414",
  },
  {
    city_short: "SORONG",
    province: "PAPUA BARAT",
    postal_code: "98415",
  },
  {
    city_short: "SORONG",
    province: "PAPUA BARAT",
    postal_code: "98416",
  },
  {
    city_short: "SORONG",
    province: "PAPUA BARAT",
    postal_code: "98417",
  },
  {
    city_short: "SORONG",
    province: "PAPUA BARAT",
    postal_code: "98418",
  },
  {
    city_short: "SORONG",
    province: "PAPUA BARAT",
    postal_code: "98419",
  },
  {
    city_short: "SORONG",
    province: "PAPUA BARAT",
    postal_code: "98451",
  },
  {
    city_short: "SORONG",
    province: "PAPUA BARAT",
    postal_code: "98452",
  },
  {
    city_short: "SORONG",
    province: "PAPUA BARAT",
    postal_code: "98453",
  },
  {
    city_short: "SORONG SELATAN",
    province: "PAPUA BARAT",
    postal_code: "98454",
  },
  {
    city_short: "SORONG SELATAN",
    province: "PAPUA BARAT",
    postal_code: "98455",
  },
  {
    city_short: "SORONG SELATAN",
    province: "PAPUA BARAT",
    postal_code: "98456",
  },
  {
    city_short: "SORONG",
    province: "PAPUA BARAT",
    postal_code: "98456",
  },
  {
    city_short: "SORONG",
    province: "PAPUA BARAT",
    postal_code: "98457",
  },
  {
    city_short: "MAYBRAT",
    province: "PAPUA BARAT",
    postal_code: "98461",
  },
  {
    city_short: "MAYBRAT",
    province: "PAPUA BARAT",
    postal_code: "98462",
  },
  {
    city_short: "MAYBRAT",
    province: "PAPUA BARAT",
    postal_code: "98463",
  },
  {
    city_short: "SORONG",
    province: "PAPUA BARAT",
    postal_code: "98471",
  },
  {
    city_short: "TAMBRAUW",
    province: "PAPUA BARAT",
    postal_code: "98472",
  },
  {
    city_short: "SORONG",
    province: "PAPUA BARAT",
    postal_code: "98472",
  },
  {
    city_short: "TAMBRAUW",
    province: "PAPUA BARAT",
    postal_code: "98473",
  },
  {
    city_short: "TAMBRAUW",
    province: "PAPUA BARAT",
    postal_code: "98474",
  },
  {
    city_short: "RAJA AMPAT",
    province: "PAPUA BARAT",
    postal_code: "98481",
  },
  {
    city_short: "RAJA AMPAT",
    province: "PAPUA BARAT",
    postal_code: "98482",
  },
  {
    city_short: "RAJA AMPAT",
    province: "PAPUA BARAT",
    postal_code: "98483",
  },
  {
    city_short: "RAJA AMPAT",
    province: "PAPUA BARAT",
    postal_code: "98484",
  },
  {
    city_short: "FAKFAK",
    province: "PAPUA",
    postal_code: "98611",
  },
  {
    city_short: "MAYBRAT",
    province: "PAPUA",
    postal_code: "98652",
  },
  {
    city_short: "FAKFAK",
    province: "PAPUA",
    postal_code: "98652",
  },
  {
    city_short: "KAIMANA",
    province: "PAPUA",
    postal_code: "98653",
  },
  {
    city_short: "KAIMANA",
    province: "PAPUA",
    postal_code: "98654",
  },
  {
    city_short: "KAIMANA",
    province: "PAPUA",
    postal_code: "98655",
  },
  {
    city_short: "KAIMANA",
    province: "PAPUA",
    postal_code: "98656",
  },
  {
    city_short: "FAKFAK",
    province: "PAPUA",
    postal_code: "98661",
  },
  {
    city_short: "FAKFAK",
    province: "PAPUA",
    postal_code: "98662",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98711",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98712",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98713",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98714",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98715",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98716",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98717",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98718",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98719",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98721",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98722",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98723",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98724",
  },
  {
    city_short: "DEIYAI",
    province: "PAPUA",
    postal_code: "98724",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98725",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98726",
  },
  {
    city_short: "DEIYAI",
    province: "PAPUA",
    postal_code: "98727",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98763",
  },
  {
    city_short: "DEIYAI",
    province: "PAPUA",
    postal_code: "98764",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98766",
  },
  {
    city_short: "INTAN JAYA",
    province: "PAPUA",
    postal_code: "98767",
  },
  {
    city_short: "INTAN JAYA",
    province: "PAPUA",
    postal_code: "98768",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98769",
  },
  {
    city_short: "INTAN JAYA",
    province: "PAPUA",
    postal_code: "98769",
  },
  {
    city_short: "DEIYAI",
    province: "PAPUA",
    postal_code: "98781",
  },
  {
    city_short: "PANIAI",
    province: "PAPUA",
    postal_code: "98782",
  },
  {
    city_short: "INTAN JAYA",
    province: "PAPUA",
    postal_code: "98783",
  },
  {
    city_short: "INTAN JAYA",
    province: "PAPUA",
    postal_code: "98784",
  },
  {
    city_short: "NABIRE",
    province: "PAPUA",
    postal_code: "98811",
  },
  {
    city_short: "NABIRE",
    province: "PAPUA",
    postal_code: "98812",
  },
  {
    city_short: "NABIRE",
    province: "PAPUA",
    postal_code: "98813",
  },
  {
    city_short: "NABIRE",
    province: "PAPUA",
    postal_code: "98814",
  },
  {
    city_short: "NABIRE",
    province: "PAPUA",
    postal_code: "98815",
  },
  {
    city_short: "NABIRE",
    province: "PAPUA",
    postal_code: "98816",
  },
  {
    city_short: "NABIRE",
    province: "PAPUA",
    postal_code: "98817",
  },
  {
    city_short: "NABIRE",
    province: "PAPUA",
    postal_code: "98818",
  },
  {
    city_short: "NABIRE",
    province: "PAPUA",
    postal_code: "98852",
  },
  {
    city_short: "NABIRE",
    province: "PAPUA",
    postal_code: "98853",
  },
  {
    city_short: "DOGIYAI",
    province: "PAPUA",
    postal_code: "98854",
  },
  {
    city_short: "NABIRE",
    province: "PAPUA",
    postal_code: "98854",
  },
  {
    city_short: "NABIRE",
    province: "PAPUA",
    postal_code: "98856",
  },
  {
    city_short: "DOGIYAI",
    province: "PAPUA",
    postal_code: "98857",
  },
  {
    city_short: "NABIRE",
    province: "PAPUA",
    postal_code: "98861",
  },
  {
    city_short: "DOGIYAI",
    province: "PAPUA",
    postal_code: "98862",
  },
  {
    city_short: "DOGIYAI",
    province: "PAPUA",
    postal_code: "98863",
  },
  {
    city_short: "PUNCAK JAYA",
    province: "PAPUA",
    postal_code: "98911",
  },
  {
    city_short: "PUNCAK JAYA",
    province: "PAPUA",
    postal_code: "98912",
  },
  {
    city_short: "PUNCAK JAYA",
    province: "PAPUA",
    postal_code: "98913",
  },
  {
    city_short: "PUNCAK JAYA",
    province: "PAPUA",
    postal_code: "98914",
  },
  {
    city_short: "PUNCAK JAYA",
    province: "PAPUA",
    postal_code: "98915",
  },
  {
    city_short: "PUNCAK JAYA",
    province: "PAPUA",
    postal_code: "98916",
  },
  {
    city_short: "PUNCAK JAYA",
    province: "PAPUA",
    postal_code: "98917",
  },
  {
    city_short: "PUNCAK JAYA",
    province: "PAPUA",
    postal_code: "98918",
  },
  {
    city_short: "PUNCAK",
    province: "PAPUA",
    postal_code: "98971",
  },
  {
    city_short: "PUNCAK",
    province: "PAPUA",
    postal_code: "98972",
  },
  {
    city_short: "PUNCAK",
    province: "PAPUA",
    postal_code: "98973",
  },
  {
    city_short: "PUNCAK",
    province: "PAPUA",
    postal_code: "98976",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99111",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99112",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99113",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99114",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99115",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99116",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99117",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99221",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99222",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99223",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99224",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99225",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99226",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99351",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99352",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99353",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99354",
  },
  {
    city_short: "SARMI",
    province: "PAPUA",
    postal_code: "99355",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99356",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99357",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99358",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99359",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99361",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99362",
  },
  {
    city_short: "JAYAPURA",
    province: "PAPUA",
    postal_code: "99364",
  },
  {
    city_short: "SARMI",
    province: "PAPUA",
    postal_code: "99371",
  },
  {
    city_short: "SARMI",
    province: "PAPUA",
    postal_code: "99372",
  },
  {
    city_short: "SARMI",
    province: "PAPUA",
    postal_code: "99373",
  },
  {
    city_short: "SARMI",
    province: "PAPUA",
    postal_code: "99374",
  },
  {
    city_short: "MAMBERAMO RAYA",
    province: "PAPUA",
    postal_code: "99375",
  },
  {
    city_short: "MAMBERAMO RAYA",
    province: "PAPUA",
    postal_code: "99376",
  },
  {
    city_short: "MAMBERAMO RAYA",
    province: "PAPUA",
    postal_code: "99377",
  },
  {
    city_short: "KEEROM",
    province: "PAPUA",
    postal_code: "99465",
  },
  {
    city_short: "KEEROM",
    province: "PAPUA",
    postal_code: "99466",
  },
  {
    city_short: "KEEROM",
    province: "PAPUA",
    postal_code: "99467",
  },
  {
    city_short: "KEEROM",
    province: "PAPUA",
    postal_code: "99468",
  },
  {
    city_short: "KEEROM",
    province: "PAPUA",
    postal_code: "99469",
  },
  {
    city_short: "JAYAWIJAYA",
    province: "PAPUA",
    postal_code: "99511",
  },
  {
    city_short: "JAYAWIJAYA",
    province: "PAPUA",
    postal_code: "99552",
  },
  {
    city_short: "MAMBERAMO TENG",
    province: "PAPUA",
    postal_code: "99553",
  },
  {
    city_short: "JAYAWIJAYA",
    province: "PAPUA",
    postal_code: "99554",
  },
  {
    city_short: "LANNY JAYA",
    province: "PAPUA",
    postal_code: "99555",
  },
  {
    city_short: "LANNY JAYA",
    province: "PAPUA",
    postal_code: "99556",
  },
  {
    city_short: "JAYAWIJAYA",
    province: "PAPUA",
    postal_code: "99557",
  },
  {
    city_short: "MAMBERAMO TENG",
    province: "PAPUA",
    postal_code: "99557",
  },
  {
    city_short: "MAMBERAMO TENG",
    province: "PAPUA",
    postal_code: "99558",
  },
  {
    city_short: "TOLIKARA",
    province: "PAPUA",
    postal_code: "99561",
  },
  {
    city_short: "TOLIKARA",
    province: "PAPUA",
    postal_code: "99562",
  },
  {
    city_short: "LANNY JAYA",
    province: "PAPUA",
    postal_code: "99563",
  },
  {
    city_short: "NDUGA",
    province: "PAPUA",
    postal_code: "99564",
  },
  {
    city_short: "NDUGA",
    province: "PAPUA",
    postal_code: "99565",
  },
  {
    city_short: "JAYAWIJAYA",
    province: "PAPUA",
    postal_code: "99566",
  },
  {
    city_short: "LANNY JAYA",
    province: "PAPUA",
    postal_code: "99567",
  },
  {
    city_short: "TOLIKARA",
    province: "PAPUA",
    postal_code: "99568",
  },
  {
    city_short: "TOLIKARA",
    province: "PAPUA",
    postal_code: "99569",
  },
  {
    city_short: "NDUGA",
    province: "PAPUA",
    postal_code: "99571",
  },
  {
    city_short: "YAHUKIMO",
    province: "PAPUA",
    postal_code: "99571",
  },
  {
    city_short: "PEG BINTANG",
    province: "PAPUA",
    postal_code: "99572",
  },
  {
    city_short: "PEG BINTANG",
    province: "PAPUA",
    postal_code: "99573",
  },
  {
    city_short: "PEG BINTANG",
    province: "PAPUA",
    postal_code: "99574",
  },
  {
    city_short: "PEG BINTANG",
    province: "PAPUA",
    postal_code: "99575",
  },
  {
    city_short: "PEG BINTANG",
    province: "PAPUA",
    postal_code: "99576",
  },
  {
    city_short: "PEG BINTANG",
    province: "PAPUA",
    postal_code: "99577",
  },
  {
    city_short: "YAHUKIMO",
    province: "PAPUA",
    postal_code: "99578",
  },
  {
    city_short: "YAHUKIMO",
    province: "PAPUA",
    postal_code: "99582",
  },
  {
    city_short: "YALIMO",
    province: "PAPUA",
    postal_code: "99583",
  },
  {
    city_short: "YALIMO",
    province: "PAPUA",
    postal_code: "99584",
  },
  {
    city_short: "YALIMO",
    province: "PAPUA",
    postal_code: "99585",
  },
  {
    city_short: "YALIMO",
    province: "PAPUA",
    postal_code: "99586",
  },
  {
    city_short: "YALIMO",
    province: "PAPUA",
    postal_code: "99587",
  },
  {
    city_short: "MERAUKE",
    province: "PAPUA",
    postal_code: "99611",
  },
  {
    city_short: "MERAUKE",
    province: "PAPUA",
    postal_code: "99612",
  },
  {
    city_short: "MERAUKE",
    province: "PAPUA",
    postal_code: "99613",
  },
  {
    city_short: "MERAUKE",
    province: "PAPUA",
    postal_code: "99614",
  },
  {
    city_short: "MERAUKE",
    province: "PAPUA",
    postal_code: "99615",
  },
  {
    city_short: "MERAUKE",
    province: "PAPUA",
    postal_code: "99616",
  },
  {
    city_short: "MERAUKE",
    province: "PAPUA",
    postal_code: "99651",
  },
  {
    city_short: "MERAUKE",
    province: "PAPUA",
    postal_code: "99652",
  },
  {
    city_short: "MERAUKE",
    province: "PAPUA",
    postal_code: "99654",
  },
  {
    city_short: "MERAUKE",
    province: "PAPUA",
    postal_code: "99655",
  },
  {
    city_short: "MERAUKE",
    province: "PAPUA",
    postal_code: "99656",
  },
  {
    city_short: "BOVEN DIGOEL",
    province: "PAPUA",
    postal_code: "99661",
  },
  {
    city_short: "BOVEN DIGOEL",
    province: "PAPUA",
    postal_code: "99662",
  },
  {
    city_short: "BOVEN DIGOEL",
    province: "PAPUA",
    postal_code: "99663",
  },
  {
    city_short: "BOVEN DIGOEL",
    province: "PAPUA",
    postal_code: "99664",
  },
  {
    city_short: "BOVEN DIGOEL",
    province: "PAPUA",
    postal_code: "99665",
  },
  {
    city_short: "ASMAT",
    province: "PAPUA",
    postal_code: "99766",
  },
  {
    city_short: "ASMAT",
    province: "PAPUA",
    postal_code: "99773",
  },
  {
    city_short: "ASMAT",
    province: "PAPUA",
    postal_code: "99776",
  },
  {
    city_short: "ASMAT",
    province: "PAPUA",
    postal_code: "99777",
  },
  {
    city_short: "ASMAT",
    province: "PAPUA",
    postal_code: "99778",
  },
  {
    city_short: "ASMAT",
    province: "PAPUA",
    postal_code: "99779",
  },
  {
    city_short: "ASMAT",
    province: "PAPUA",
    postal_code: "99782",
  },
  {
    city_short: "MAPPI",
    province: "PAPUA",
    postal_code: "99853",
  },
  {
    city_short: "MAPPI",
    province: "PAPUA",
    postal_code: "99871",
  },
  {
    city_short: "MAPPI",
    province: "PAPUA",
    postal_code: "99872",
  },
  {
    city_short: "MAPPI",
    province: "PAPUA",
    postal_code: "99874",
  },
  {
    city_short: "MAPPI",
    province: "PAPUA",
    postal_code: "99875",
  },
  {
    city_short: "MAPPI",
    province: "PAPUA",
    postal_code: "99881",
  },
  {
    city_short: "MIMIKA",
    province: "PAPUA",
    postal_code: "99910",
  },
  {
    city_short: "MIMIKA",
    province: "PAPUA",
    postal_code: "99963",
  },
  {
    city_short: "MIMIKA",
    province: "PAPUA",
    postal_code: "99964",
  },
  {
    city_short: "MIMIKA",
    province: "PAPUA",
    postal_code: "99965",
  },
  {
    city_short: "MIMIKA",
    province: "PAPUA",
    postal_code: "99966",
  },
  {
    city_short: "MIMIKA",
    province: "PAPUA",
    postal_code: "99967",
  },
  {
    city_short: "MIMIKA",
    province: "PAPUA",
    postal_code: "99968",
  },
  {
    city_short: "MIMIKA",
    province: "PAPUA",
    postal_code: "99971",
  },
  {
    city_short: "MIMIKA",
    province: "PAPUA",
    postal_code: "99972",
  },
  {
    city_short: "MIMIKA",
    province: "PAPUA",
    postal_code: "99973",
  },
  {
    city_short: "MIMIKA",
    province: "PAPUA",
    postal_code: "99974",
  },
];
